import MapControl from '../MapControl/map/MapControl';
import * as eventTypes from '../MapControl/map/utils/eventTypes';
import * as formats from '../MapControl/map/utils/formats';
import SubformControl from './SubformControl';
import { applyFieldComponentClasses } from '../FormConfig/fieldControls/componentClasses';
import { applyFieldComponentStyles } from '../FormConfig/fieldControls/componentStyles';
import { applyFieldComponentHtmlAttributes } from '../FormConfig/fieldControls/componentHtmlAttributes';

export default class FormControl {
    constructor(options) {
        this.localization = options.localization;
        this.actionLocalization = options.actionLocalization;
        this.container = options.container;
        this.metadata = null;
        this.otherParameters = options.otherParameters != null ? options.otherParameters : {};
        this.actionButtons = [];
        // isPreview trebuie setat inainte de _loadCommands() (vezi mai jos): altfel
        // in preview flag-ul e inca false cand se apeleaza _loadCommands si se face
        // un GET GetXpCommandsRuntime inutil.
        this.isPreview = options.isPreview != null ? options.isPreview : false;
        this.uniqueId = 'formControl' + options.pageGuid;
        this.pageGuid = options.pageGuid;
        this.uniqueModalId = this.uniqueId + '-modal';
        this.uniqueModalInnerId = this.uniqueId + '-modal-inner';
        this.comboBoxSelectView = this.uniqueId + '-combo-box-select-view';
        this.uploadButtonsId = this.uniqueId + '-file-uploads-buttons';
        this.uploadCancelId = this.uniqueId + '-file-uploads-cancel';
        this.lastChosenTab = null;
        this.context = options.context;
        this.objectId = options.objectId;
        this.isValid = true;
        this.saveTabs = true;
        this.fromActionType = options.fromActionType;
        this.loadCommands = {};
        this.invalidFields = {};

        if (this.context == 'full' && (options.parentGuid == null || options.parentGuid == '')) {
            let pkValParams = location.search.split('&').filter(row => { return row.indexOf('pkVal=') >= 0 });

            if (pkValParams.length > 0) {
                let pkValTuples = pkValParams[0].split('=');
                if (pkValTuples.length == 2) {
                    if (!isNaN(pkValTuples[1]) && pkValTuples[1] != '0') {
                        if (this.objectId == 0 || this.objectId == null || this.objectId == '') {
                            this.objectId = pkValTuples[1];
                        }
                    }
                }
            }
        }

        this.getDataUrl = options.getDataUrl;
        this.getDataPostParam = options.getDataPostParam;
        this.saveDataUrl = options.saveDataUrl;
        this.saveDataPostParam = options.saveDataPostParam;
        this.formId = options.formId;
        this.mapLayerId = options.mapLayerId;
        this.idExtConn = options.idExtConn;
        this.layoutId = options.layoutId;
        this.isFilter = options.isFilter;
        this.listControl = options.listControl;
        this.currentActionId = -1;
        this.generalResources = options.generalResources;
        this.customFormResources = options.customFormResources;
        this.parentGuid = options.parentGuid;
        this.reloadAfterSubmit = false;
        this.ignoreNotificationAfterSubmit = false;
        this.initiatorIdAfterSubmit = null;
        if (this.parentGuid != null && this.parentGuid != '') {
            $('#sublist-modal-' + this.parentGuid.replaceAll('listControl', '')).siblings('.k-window-titlebar').find('[aria-label="Close"]').attr('id', 'form-panel-close-' + this.pageGuid);
            $('#form-panel-close-' + this.pageGuid).hide();
        }

        this.uploadedFiles = {};
        this.dropzones = {};
        this.htmlEditors = {};
        this.actionGeom = {};
        this.formGeomEdited = false;
        this.formItemPrefix = 'entity-form-item-';
        this.commands = options.XpCommands;

        if (this.listControl) {
            this.listId = this.listControl.listId;
        }
        if (!this.commands) {
            this._loadCommands();
        }
        this.allowEdit = false;
        this.allowDelete = false;
        this.dataItem = {};
        this.saveDataItem = {
            idForm: this.formId,
            idExtConn: this.idExtConn,
            pkVal: this.objectId,
            values: {}
        };

        $('#' + this.container)[0][this.uniqueId] = this;

        // control items
        this.saveButtonId = 'form-save-button-' + this._generateUUID();
        this.cancelButtonId = 'form-cancel-button-' + this._generateUUID();
        this.clearFilterButtonId = 'clear-filter-button-' + this._generateUUID();
        this.searchFilterButtonId = 'search-filter-button-' + this._generateUUID();

        // isPreview e deja setat sus (inainte de _loadCommands); aici doar efectul lateral.
        if (this.isPreview) {
            this.allowEdit = true;
            this.allowDelete = true;
        }
        this.featureSelectionChangedHandler = this._handleMapElementSelection();
        this._hiddenModals = null;
        this.parentControl = null;

        if (this._getXpList(this.parentGuid) != null) {
            this.parentControl = this._getXpList(this.parentGuid);
        }

        //CG: pana acum "sunt formular radacina?" se deducea din parentControl, care nu poate fi decat o lista
        //(_getXpList cauta .xp-list-container); un rand de sublista are drept gazda un FormControl, deci il marcam explicit
        this.hostFormControl = options.hostFormControl != null ? options.hostFormControl : null;
        this.isRow = options.isRow === true || this.hostFormControl != null;

        //CG: echivalentul pe instanta al hook-ului global onFormLoaded<pageGuid>; un rand de sublista are
        //nevoie de el ca sa stie cand poate lua amprenta valorilor incarcate (urmarirea modificarilor)
        this.onFormLoaded = typeof options.onFormLoaded === 'function' ? options.onFormLoaded : null;
        this.onBeforeFormLoaded = typeof options.onBeforeFormLoaded === 'function' ? options.onBeforeFormLoaded : null;
        //CG: numarul incarcarii curente; o incarcare care asteapta un onBeforeFormLoaded asincron si e depasita nu mai porneste _initForm
        this._loadSeq = 0;
        this.onBeforeFormSaved = typeof options.onBeforeFormSaved === 'function' ? options.onBeforeFormSaved : null;
        this.onAfterFormSaved = typeof options.onAfterFormSaved === 'function' ? options.onAfterFormSaved : null;
        this.onMapElementSelected = typeof options.onMapElementSelected === 'function' ? options.onMapElementSelected : null;
        this.onFormSublistFilterLoaded = typeof options.onFormSublistFilterLoaded === 'function' ? options.onFormSublistFilterLoaded : null;
        this.onFormMapStarted = typeof options.onFormMapStarted === 'function' ? options.onFormMapStarted : null;
        this.onFormMapFeatureEdited = typeof options.onFormMapFeatureEdited === 'function' ? options.onFormMapFeatureEdited : null;
        this.subformCallbacks = options.subformCallbacks != null ? options.subformCallbacks : {};
        this.onSublistBeforeListLoaded = typeof options.onSublistBeforeListLoaded === 'function' ? options.onSublistBeforeListLoaded : null;
        this.onSublistLoaded = typeof options.onSublistLoaded === 'function' ? options.onSublistLoaded : null;
        this.onSublistFilterLoaded = typeof options.onSublistFilterLoaded === 'function' ? options.onSublistFilterLoaded : null;

        //CG: doar randurile unui subformular primesc cache-ul de surse FK (il da SubformControl si e
        //comun pe stiva); un formular obisnuit ramane fara, deci isi cere sursele exact ca pana acum
        this.fieldSourceCache = options.fieldSourceCache != null ? options.fieldSourceCache : null;

        this.sublists = {};
    }

    getCurrentPlatform() {
        return 1;
    }

    //CG: eliberarea completa a formularului - pe langa continut inchide si modalul propriu
    //si desprinde instanta de pe container, ca sa poata fi aruncata la gunoi
    destroy() {
        //CG: handler-ul de pe butonul de inchidere al modalului gazda e in afara containerului, deci il desprindem aici
        $('#' + this.container).closest('.k-window-content').parent().find('[aria-label="Close"]').off('click.' + this.uniqueId);

        this._disposeForm();

        let modal = $('#' + this.uniqueModalInnerId).data('kendoWindow');
        if (modal != null) {
            modal.destroy();
        }

        let container = $('#' + this.container)[0];
        if (container != null) {
            delete container[this.uniqueId];
        }
    }

    //CG: inchide ce gazduieste formularul dupa salvare/anulare - lista parinte, modalul propriu sau pagina;
    //un rand de sublista e inline in formularul gazda, deci nu are ce inchide (iar history.back ar arunca pagina)
    _closeHost() {
        if (this.isRow) { return; }

        if (this.parentControl != null) {
            this.parentControl.closeChild();
            return;
        }

        let hostWindow = $('#' + this.container).closest('.k-window-content');

        if (hostWindow.length > 0) {
            hostWindow.data('kendoWindow').close();
        } else {
            history.back();
        }
    }

    //CG: JSON.parse/stringify si nu structuredClone - designerul trimite noduri Kendo (functii, referinte
    //circulare) pe care structuredClone le respinge; daca nu se poate clona pastram referinta, ca pana acum
    _cloneMetadata(metadata) {
        try {
            return JSON.parse(JSON.stringify(metadata));
        } catch (e) {
            console.warn('FormControl: layout-ul nu a putut fi clonat, se foloseste referinta primita', e);
            return metadata;
        }
    }

    //CG: culege valorile formularului fara sa porneasca salvarea; un rand de sublista are nevoie exact
    //de pasul asta, pentru ca se comite impreuna cu parintele, nu pe cont propriu
    harvestValues() {
        this.saveDataItem.values = {};
        this._storeData(this.metadata);
        this._storeGeomData();
        this._storeRowsData();
        return this.saveDataItem.values;
    }

    saveState(ignoreNotification, ignoreValidation) {
        this.harvestValues();
        return this._saveState(ignoreNotification, ignoreValidation);
    }

    sublistFilterLoaded(sublistId) {
        if (this.formId != null) {
            if (window['onSublistFilterLoaded' + '_' + this.formId] != null && !this.isPreview) {
                window['onSublistFilterLoaded' + '_' + this.formId](this, sublistId);
            }
        }
        if (window['onSublistFilterLoaded' + this.pageGuid] != null && !this.isPreview) {
            const fn = window['onSublistFilterLoaded' + this.pageGuid];

            if (typeof fn === 'function') {
                if (fn.length >= 2) {
                    fn(this, sublistId);
                } else {
                    fn(sublistId);
                }
            }            
        }
        if (this.onFormSublistFilterLoaded != null) {
            this.onFormSublistFilterLoaded(this, sublistId);
        }
    }

    //public methods
    loadForm(metadata, actionButtons) {
        if (metadata != null && metadata.Items != null && metadata.Items.length > 0) {
            this._disposeForm();
            //CG: layout-ul vine prin referinta si instanta scrie pe nodurile lui (UniqueClientId, isLoaded, pendingFkVal),
            //asa ca doua formulare peste acelasi obiect ar imparti id-urile de DOM si starea - fiecare instanta primeste copia ei
            this.metadata = this._cloneMetadata(metadata);

            if (xapp && xapp.currentAppType && !this.isFilter && !this.isPreview && !this.isRow && this.metadata.Name && this.metadata.Name != '') {
                document.title = this.metadata.Name;
            }

            this.actionButtons = actionButtons;

            this._initFormAfterHooks();
        } else {
            if (this.isFilter && this.listControl != null) {
                this.listControl.filterLoaded();
            }
        }
    }

    reloadForm() {
        //CG: _initForm rescrie DOM-ul dar nu atinge registrul de subliste si dropzone-uri
        this._releaseControls();

        this._initFormAfterHooks();
    }

    //CG: un onBeforeFormLoaded care intoarce Promise amana _initForm; hook-urile vechi (sincrone) raman pe drumul sincron de dinainte
    _initFormAfterHooks() {
        let token = ++this._loadSeq;
        let pending = this._runLoadHooks('onBeforeFormLoaded');

        if (pending == null) {
            this._initForm();
            return;
        }

        pending
            .catch(e => console.error('onBeforeFormLoaded', e))
            .then(() => {
                if (token === this._loadSeq) {
                    this._initForm();
                }
            });
    }

    //CG: ruleaza in ordine hook-ul de pagina, cel de formular si cel de instanta; intoarce null daca toate au fost sincrone,
    //altfel un Promise care le inlantuie pe cele ramase dupa primul asincron
    _runLoadHooks(name) {
        let hooks = [];

        if (!this.isPreview && window[name + this.pageGuid] != null) {
            hooks.push(() => window[name + this.pageGuid](this));
        }
        if (!this.isPreview && this.formId != null && window[name + '_' + this.formId] != null) {
            hooks.push(() => window[name + '_' + this.formId](this));
        }
        if (this[name] != null) {
            hooks.push(() => this[name](this));
        }

        for (let i = 0; i < hooks.length; i++) {
            let result = hooks[i](this);

            if (result != null && typeof result.then === 'function') {
                return hooks.slice(i + 1).reduce((chain, hook) => chain.then(() => hook()), Promise.resolve(result));
            }
        }

        return null;
    }

    getFieldMetadataByInternalId(id) {
        let item = this._searchFieldByInternalId(this.metadata, id);
        return item;
    }

    getFieldMetadataById(id) {
        let item = this._searchFieldByUiName(this.metadata, id);
        return item;
    }

    getFieldMetadataByUniqueId(id) {
        let item = this._searchFieldByUniqueId(this.metadata, id);
        return item;
    }

    getFieldById(id) {
        let item = this._searchFieldByUiName(this.metadata, id);
        let value = null;
        if (item != null) {
            switch (item.CtlType) {
                case 'Switch': value = $("#" + item.UniqueClientId).data('kendoSwitch');
                    break;
                case 'Checkbox': value = $("#" + item.UniqueClientId);
                    break;
                case 'IntegerTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox');
                    break;
                case 'DatePicker': value = $("#" + item.UniqueClientId).data("kendoDatePicker");
                    break;
                case 'NumericTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox');
                    break;
                case 'TextBox': value = $("#" + item.UniqueClientId);
                    break;
                case 'TextArea': value = $("#" + item.UniqueClientId);
                    break;
                case 'Html': value = $("#" + item.UniqueClientId);
                    break;
                case 'RichText': value = $("#" + item.UniqueClientId);
                    break;
                case 'DateTimePicker': value = $("#" + item.UniqueClientId).data("kendoDateTimePicker");
                    break;
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ListView': value = $("#" + item.UniqueClientId);
                            break;
                        case 'MultiSelect': value = $("#" + item.UniqueClientId).data('kendoMultiSelect');
                            break;
                        case 'TreeView': value = $("#" + item.UniqueClientId).data('kendoDropDownTree');
                            break;
                        case 'RadioButton': value = $("#" + item.UniqueClientId);
                            break;
                        case 'MultiSelectCheckBox': value = $("#" + item.UniqueClientId);
                            break;
                        default: value = $("#" + item.UniqueClientId).data('kendoComboBox');
                            break;
                    }
                }

                    break;
                case 'GeomPicker': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ModalMap': value = $("#" + item.UniqueClientId);
                            break;
                        case 'MapView': value = $("#" + item.UniqueClientId)[0].mapControl;
                            break;
                    }
                }
                    break;
                default: break;
            }

            if (item.TypeName == 'UISublistDto' || item.TypeName == 'UISubformDto') {
                value = this.sublists[item.UniqueClientId];
            }

            if (item.TypeName == 'UIMapViewDto') {
                value = $("#" + item.UniqueClientId)[0].mapControl;
            }
        }

        return value;
    }

    getFieldByUniqueId(id) {
        let item = this._searchFieldByUniqueId(this.metadata, id);
        let value = null;
        if (item != null) {
            switch (item.CtlType) {
                case 'Switch': value = $("#" + item.UniqueClientId).data('kendoSwitch');
                    break;
                case 'Checkbox': value = $("#" + item.UniqueClientId);
                    break;
                case 'IntegerTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox');
                    break;
                case 'DatePicker': value = $("#" + item.UniqueClientId).data("kendoDatePicker");
                    break;
                case 'NumericTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox');
                    break;
                case 'TextBox': value = $("#" + item.UniqueClientId);
                    break;
                case 'TextArea': value = $("#" + item.UniqueClientId);
                    break;
                case 'Html': value = $("#" + item.UniqueClientId);
                    break;
                case 'RichText': value = $("#" + item.UniqueClientId);
                    break;
                case 'DateTimePicker': value = $("#" + item.UniqueClientId).data("kendoDateTimePicker");
                    break;
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ListView': value = $("#" + item.UniqueClientId);
                            break;
                        case 'MultiSelect': value = $("#" + item.UniqueClientId).data('kendoMultiSelect');
                            break;
                        case 'TreeView': value = $("#" + item.UniqueClientId).data('kendoDropDownTree');
                            break;
                        case 'RadioButton': value = $("#" + item.UniqueClientId);
                            break;
                        case 'MultiSelectCheckBox': value = $("#" + item.UniqueClientId);
                            break;
                        default: value = $("#" + item.UniqueClientId).data('kendoComboBox');
                            break;
                    }
                }

                    break;
                case 'GeomPicker': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ModalMap': value = $("#" + item.UniqueClientId);
                            break;
                        case 'MapView': value = $("#" + item.UniqueClientId)[0].mapControl;
                            break;
                    }
                }
                    break;
                default: break;
            }

            if (item.TypeName == 'UISublistDto' || item.TypeName == 'UISubformDto') {
                value = this.sublists[item.UniqueClientId];
            }

            if (item.TypeName == 'UIMapViewDto') {
                value = $("#" + item.UniqueClientId)[0].mapControl;
            }
        }

        return value;
    }

    setFieldValue(fieldName, value) {
        this.setFieldValueById(fieldName, value);
    }

    setFieldValueById(id, value) {
        this._setFieldValueByItem(this._searchFieldByUiName(this.metadata, id), value);
    }

    //CG: setarea propriu-zisa pe nodul deja rezolvat; apelantii care au item-ul in mana nu mai fac drumul prin nume
    //(cautarea dupa nume e last-match-wins, deci pe layout-uri cu nume duplicate ar nimeri alt control)
    _setFieldValueByItem(item, value) {
        if (item != null) {
            switch (item.CtlType) {
                case 'Switch': this._threeStateSwitchSetValue("#" + item.UniqueClientId, value);
                    break;
                case 'Checkbox': this._setCheckboxValue(item, value);
                    break;
                case 'IntegerTextBox': $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(value);
                    break;
                case 'DatePicker': $("#" + item.UniqueClientId).data("kendoDatePicker").value(value);
                    break;
                case 'NumericTextBox': $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(value);
                    break;
                case 'TextBox': $("#" + item.UniqueClientId).val(value);
                    break;
                case 'TextArea': $("#" + item.UniqueClientId).val(value);
                    break;
                case 'Html': this._setHtmlValue(item, value);
                    break;
                case 'RichText': $("#" + item.UniqueClientId).data('kendoEditor').value(value);
                    break;
                case 'DateTimePicker': $("#" + item.UniqueClientId).data("kendoDateTimePicker").value(value);
                    break;
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ListView': $("#" + item.UniqueClientId).attr('current-value', value);
                            break;
                        case 'MultiSelect': $("#" + item.UniqueClientId).data('kendoMultiSelect').value(value);
                            break;
                        case 'TreeView': $("#" + item.UniqueClientId).data('kendoDropDownTree').value(value);
                            break;
                        case 'RadioButton': this._setRadioButtonValue(item, value);
                            break;
                        case 'MultiSelectCheckBox': this._setMultiSelectCheckBoxValue(item, value);
                            break;
                        default: $("#" + item.UniqueClientId).data('kendoComboBox').value(value);
                            break;
                    }
                }
                    break;
                case 'GeomPicker': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ModalMap': $("#" + item.UniqueClientId).val(value);
                            break;
                        case 'MapView': $("#" + item.UniqueClientId).attr('current-value', value);
                            break;
                    }
                }
                    break;
                default: break;
            }
        }
    }

    getFieldValueById(id) {
        let item = this._searchFieldByUiName(this.metadata, id);
        let value = null;
        if (item != null) {
            switch (item.CtlType) {
                case 'Switch': value = this._threeStateSwitchGetValue("#" + item.UniqueClientId);
                    break;
                case 'Checkbox': value = this._getCheckboxValue(item);
                    break;
                case 'IntegerTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
                    break;
                case 'DatePicker': value = $("#" + item.UniqueClientId).data("kendoDatePicker").value();
                    break;
                case 'NumericTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
                    break;
                case 'TextBox': value = $("#" + item.UniqueClientId).val();
                    break;
                case 'TextArea': value = $("#" + item.UniqueClientId).val();
                    break;
                case 'Html': value = this._getHtmlValue(item);
                    break;
                case 'RichText': value = $("#" + item.UniqueClientId).data('kendoEditor').value();
                    break;
                case 'DateTimePicker': value = $("#" + item.UniqueClientId).data("kendoDateTimePicker").value();
                    break;
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ListView': value = $("#" + item.UniqueClientId).attr('current-value');
                            break;
                        case 'MultiSelect': value = $("#" + item.UniqueClientId).data('kendoMultiSelect').value();
                            break;
                        case 'TreeView': value = $("#" + item.UniqueClientId).data('kendoDropDownTree').value();
                            break;
                        case 'RadioButton': value = this._getRadioButtonValue(item);
                            break;
                        case 'MultiSelectCheckBox': value = this._getMultiSelectCheckBoxValue(item);
                            break;
                        default: value = $("#" + item.UniqueClientId).data('kendoComboBox').value();
                            break;
                    }
                }
                    break;
                case 'GeomPicker': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ModalMap': value = $("#" + item.UniqueClientId).val();
                            break;
                        case 'MapView': value = $("#" + item.UniqueClientId).attr('current-value');
                            break;
                    }
                }
                    break;
                case 'File': {
                    //value = this.uploadedFiles[item.UniqueClientId] != null ? this.uploadedFiles[item.UniqueClientId].uploadedFileAdded : null;
                    const dropzone = $("#" + item.UniqueClientId)[0].dropzone;
                    value = dropzone != null ? dropzone.files : [];
                    break;
                }
                default: break;
            }
        }

        return value;
    }

    _getFieldValueByUniqueId(id) {
        let item = this._searchFieldByUniqueId(this.metadata, id);
        let value = null;
        if (item != null) {
            switch (item.CtlType) {
                case 'Switch': value = this._threeStateSwitchGetValue("#" + item.UniqueClientId);
                    break;
                case 'Checkbox': value = this._getCheckboxValue(item);
                    break;
                case 'IntegerTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
                    break;
                case 'DatePicker': value = $("#" + item.UniqueClientId).data("kendoDatePicker").value();
                    break;
                case 'NumericTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
                    break;
                case 'TextBox': value = $("#" + item.UniqueClientId).val();
                    break;
                case 'TextArea': value = $("#" + item.UniqueClientId).val();
                    break;
                case 'Html': value = this._getHtmlValue(item);
                    break;
                case 'RichText': value = $("#" + item.UniqueClientId).data('kendoEditor').value();
                    break;
                case 'DateTimePicker': value = $("#" + item.UniqueClientId).data("kendoDateTimePicker").value();
                    break;
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ListView': value = $("#" + item.UniqueClientId).attr('current-value');
                            break;
                        case 'MultiSelect': value = $("#" + item.UniqueClientId).data('kendoMultiSelect').value();
                            break;
                        case 'TreeView': value = $("#" + item.UniqueClientId).data('kendoDropDownTree').value();
                            break;
                        case 'RadioButton': value = this._getRadioButtonValue(item);
                            break;
                        case 'MultiSelectCheckBox': value = this._getMultiSelectCheckBoxValue(item);
                            break;
                        default: value = $("#" + item.UniqueClientId).data('kendoComboBox').value();
                            break;
                    }
                    break;
                }
                case 'GeomPicker': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ModalMap': value = $("#" + item.UniqueClientId).val();
                            break;
                        case 'MapView': value = $("#" + item.UniqueClientId).attr('current-value');
                            break;
                    }
                    break;
                }
                case 'File': {
                    //value = this.uploadedFiles[item.UniqueClientId] != null ? this.uploadedFiles[item.UniqueClientId].uploadedFileAdded : null;
                    const dropzone = $("#" + item.UniqueClientId)[0].dropzone;
                    value = dropzone != null ? dropzone.files : [];
                    break;
                }                    
                default: break;
            }
        }

        return value;
    }

    executeCommandById(id, params) {
        let foundCommands = this.commands.filter((row) => { return row.Id == id });

        if (foundCommands.length > 0) {
            return this._executeCommand(foundCommands[0], params);
        } else {
            return new Promise((resolve, reject) => { return reject('Command does not exist!'); });
        }
    }

    executeCommandByName(name, params) {
        let foundCommands = this.commands.filter((row) => { return row.Name == name });

        if (foundCommands.length > 0) {
            if (foundCommands.length > 0) {
                return this._executeCommand(foundCommands[0], params);
            } else {
                return new Promise((resolve, reject) => { return reject('Command does not exist!'); });
            }
        } else {
            return new Promise((resolve, reject) => { return reject('Command does not exist!'); });
        }
    }

    executeTemplate(idTemplate, params) {
        return new Promise((resolve, reject) => {
            try {
                let postData = {
                    id: idTemplate,
                    idForm: this.formId,
                    params: {}
                };

                if (params != null) {
                    postData.params = params;
                }

                let url = rootUrl + 'EntityForm/ExecuteTemplate';

                $.ajax({
                    type: "POST",
                    url: url,
                    async: true,
                    data: JSON.stringify(postData),
                    contentType: "application/json; charset=utf-8",
                    success: (result) => {
                        if (result != null) {
                            resolve(result);
                        }
                    },
                    error: (e) => {
                        reject(e)
                    }
                });
            } catch (err) {
                reject(err);
            }
        });
    }

    //CG: perechea lui showLoadingPanel; randul nu deschide panoul, deci nu are voie nici sa il inchida -
    //altfel primul rand care termina de incarcat il inchide pe al tuturor
    _hideLoadingPanel() {
        if (this.isRow) { return; }

        Swal.close();
    }

    showLoadingPanel(target) {
        //CG: Swal e singleton pe pagina si se inlocuieste, nu se stivuieste - N randuri ar lupta pe acelasi panou
        if (this.isRow) { return; }

        Swal.fire({
            target: target,
            allowOutsideClick: false,
            willOpen: () => {
                Swal.showLoading();
                $('body').css('overflow', 'auto');
            },
            customClass: {
                container: 'position-absolute'
            }
        });
    }

    loadSublists() {
        //CG: doar sublistele acestui formular; scanarea intregii pagini creste cu numarul de formulare deschise
        let sublists = $('#' + this.container).find('.xp-list-container');

        if (sublists.length > 0) {
            for (let i = 0; i < sublists.length; i++) {
                let sublist = sublists[i];

                let sublistMetadata = this._searchFieldByUniqueId(this.metadata, sublist.id);

                if (sublistMetadata != null && !sublistMetadata.isLoaded) {
                    this._initSublistControl(sublistMetadata, false);
                    sublistMetadata.isLoaded = true;
                }
            }
        }
    }

    isClientCommand(id) {
        let foundCommands = this.commands.filter((row) => { return row.Id == id });

        if (foundCommands.length > 0) {
            return foundCommands[0].Type == 'CLIENT';
        }

        return false;
    }

    _executeCommand(command, params) {
        if (command.Type == 'CLIENT') {
            return new Promise((resolve, reject) => {
                try {
                    if (window['xp_command_' + command.Id] != null) {
                        let result = window['xp_command_' + command.Id](this, params);
                        resolve(result);
                    }
                    else if (window['xp_command_' + this.pageGuid + '_' + command.Id] != null) {
                        let result = window['xp_command_' + this.pageGuid + '_' + command.Id](params);
                        resolve(result);
                    }
                    else {
                        //CG: fara functia client inregistrata promise-ul ramanea nesolutionat la infinit
                        //(nici resolve, nici reject); respingem explicit si logam, ca lipsa sa fie vizibila
                        let message = 'Client command not registered: xp_command_' + command.Id;
                        console.error(message);
                        reject(message);
                    }
                } catch (err) {
                    reject(err);
                }
            });
        } else if (command.Type == 'SERVER_WITH_RESULT' || command.Type == 'C_SHARP_WITH_RESULT') {
            return new Promise((resolve, reject) => {
                try {
                    let postData = {
                        id: command.Id,
                        idEntity: this.metadata.IdEntity,
                        params: {}
                    };

                    if (params != null) {
                        postData.params = params;
                    } else {
                        for (var i = 0; i < command.Parameters.length; i++) {
                            let value = this.getFieldValueById(command.Parameters[i]);

                            if (command.Parameters[i] != 'User.Id') {
                                let type = this.getFieldMetadataById(command.Parameters[i]).EntityField.DataType;

                                if (type == 'INTEGER' && value === '') {
                                    value = '-120043434';
                                }

                                if (type == 'DATE') {
                                    value = this._serializeDate(value);
                                }

                                if (type == 'TIMESTAMP') {
                                    value = this._serializeDateTime(value);
                                }

                                postData.params[command.Parameters[i]] = {
                                    value: value,
                                    type: type
                                }
                            }
                        }
                    }

                    let commandUrl = rootUrl + 'XpCommand/ExecuteCommandWithResult';

                    $.ajax({
                        type: "POST",
                        url: commandUrl,
                        async: true,
                        data: JSON.stringify(postData),
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (result != null) {
                                if (result.Error != null) {
                                    reject(result.Error);
                                }
                                else {
                                    var resp = JSON.parse(result);

                                    if (resp.length == 0) {
                                        resolve(null);
                                    } else if (resp.length == 1) {
                                        resolve(resp[0]);
                                    } else {
                                        resolve(resp);
                                    }
                                }
                            }
                        },
                        error: (e) => {
                            reject(e)
                        }
                    });
                } catch (err) {
                    reject(err);
                }
            });
        } else if (command.Type == 'SERVER_NO_RESULT' || command.Type == 'C_SHARP_NO_RESULT' || command.Type == 'SEND_EMAIL') {
            return new Promise((resolve, reject) => {
                try {
                    let postData = {
                        id: command.Id,
                        idEntity: this.metadata.IdEntity,
                        params: {}
                    };

                    if (params != null) {
                        postData.params = params;
                    } else {
                        for (var i = 0; i < command.Parameters.length; i++) {
                            let value = this.getFieldValueById(command.Parameters[i]);

                            if (command.Parameters[i] != 'User.Id') {
                                let type = this.getFieldMetadataById(command.Parameters[i]).EntityField.DataType;

                                if (type == 'INTEGER' && value === '') {
                                    value = '-120043434';
                                }

                                if (type == 'DATE') {
                                    value = this._serializeDate(value);
                                }

                                if (type == 'TIMESTAMP') {
                                    value = this._serializeDateTime(value);
                                }

                                postData.params[command.Parameters[i]] = {
                                    value: value,
                                    type: type
                                }
                            }
                        }
                    }

                    let commandUrl = rootUrl + 'XpCommand/ExecuteCommandWithoutResult';

                    $.ajax({
                        type: "POST",
                        url: commandUrl,
                        async: true,
                        data: JSON.stringify(postData),
                        contentType: "application/json; charset=utf-8",
                        success: (result) => {
                            if (result != null) {
                                if (result.Error != null) {
                                    reject(result.Error);
                                }
                                else {
                                    if (result.status == true) {
                                        resolve(true);
                                    } else {
                                        resolve(false);
                                    }
                                }
                            } else {
                                resolve(false);
                            }
                        },
                        error: (e) => {
                            reject(e)
                        }
                    });
                } catch (err) {
                    reject(err);
                }
            });
        } else {
            return new Promise((resolve, reject) => { return reject('Command type not implemented!'); });
        }
    }

    _dateToISOString(date) {
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hours = this._padDatePart(date.getHours());
        let minutes = this._padDatePart(date.getHours());
        let seconds = this._padDatePart(date.getSeconds());

        return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds + '.000Z';
    }

    _padDatePart(part) {
        if (part < 10) {
            return '0' + part;
        } else {
            return part;
        }
    }

    //private methods
    _searchFieldByUiName(item, name) {
        let found = null;

        if ((item.TypeName == 'UICustomFieldControlDto' || item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UISublistDto' || item.TypeName == 'UISubformDto' || item.TypeName == 'UIMapViewDto') && item.Name == name) {
            return item;
        }

        if (item.Items != null && item.Items.length > 0) {
            for (var i = 0; i < item.Items.length; i++) {
                let childFound = this._searchFieldByUiName(item.Items[i], name);
                if (childFound != null) {
                    found = childFound;
                }
            }
        }

        return found;
    }

    _searchFieldByUniqueId(item, id) {
        let found = null;

        if ((item.TypeName == 'UICustomFieldControlDto' || item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UISublistDto' || item.TypeName == 'UISubformDto' || item.TypeName == 'UIMapViewDto' || item.TypeName == 'UITabPageDto') && item.UniqueClientId == id) {
            return item;
        }

        if (item.Items != null && item.Items.length > 0) {
            for (var i = 0; i < item.Items.length; i++) {
                let childFound = this._searchFieldByUniqueId(item.Items[i], id);
                if (childFound != null) {
                    found = childFound;
                }
            }
        }

        return found;
    }

    _searchFieldByInternalId(item, id) {
        let found = null;

        if ((item.TypeName == 'UICustomFieldControlDto' || item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UISublistDto' || item.TypeName == 'UISubformDto' || item.TypeName == 'UIMapViewDto' || item.TypeName == 'UITabPageDto') && item.Id == id) {
            return item;
        }

        if (item.Items != null && item.Items.length > 0) {
            for (var i = 0; i < item.Items.length; i++) {
                let childFound = this._searchFieldByInternalId(item.Items[i], id);
                if (childFound != null) {
                    found = childFound;
                }
            }
        }

        return found;
    }

    _searchFieldById(item, id) {
        let found = null;

        if ((item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto') && item.Id == id) {
            return item;
        }

        if (item.Items != null && item.Items.length > 0) {
            for (var i = 0; i < item.Items.length; i++) {
                let childFound = this._searchFieldById(item.Items[i], id);
                if (childFound != null) {
                    found = childFound;
                }
            }
        }

        return found;
    }

    _loadCommands() {
        var commandsUrl;
        if (this.formId != null) {
            commandsUrl = rootUrl + 'XpCommand/GetXpCommandsRuntime?ownerType=EntityForm&id=' + this.formId;
        }
        else if (this.listId != null) {
            commandsUrl = rootUrl + 'XpCommand/GetXpCommandsRuntime?ownerType=EntityList&id=' + this.listId;
        }
        else if (this.mapLayerId != null) {
            commandsUrl = rootUrl + 'XpCommand/GetXpCommandsRuntime?ownerType=MapLayer&id=' + this.mapLayerId;
        }

        return new Promise((resolve, reject) => {
            if (this.isPreview) {
                resolve();
            } else {
                $.ajax({
                    type: "GET",
                    url: commandsUrl,
                    contentType: "application/json; charset=utf-8",
                    async: true,
                    success: (result) => {
                        this.commands = result;
                        resolve();
                    },
                    error: (e) => {
                        toastr.error(e.responseText, '@resources["GetCommandsError"]');
                        resolve();
                    }
                });
            }
        });
    }

    //CG: singurul loc prin care pleaca cererile de sursa FK. Fara cache se comporta ca $.ajax-ul de
    //dinainte; cu cache (adica intr-un rand de sublista) cererile identice ale randurilor se unesc
    _fetchFieldSource(url, data) {
        let request = () => $.ajax({
            type: 'GET',
            url: url,
            data: data,
            dataType: 'json'
        });

        if (this.fieldSourceCache == null) {
            return request();
        }

        return this.fieldSourceCache.read(url, data, request);
    }

    //CG: adaptorul pentru transportul Kendo - read ca functie, ca sa putem trece prin _fetchFieldSource.
    //getUrl se cheama la fiecare citire, exact ca vechiul "url: () => ...", pentru ca are si efecte
    //laterale pe control (readonly, golirea valorii cand dependenta e goala)
    _readFieldSourceInto(options, getUrl) {
        this._fetchFieldSource(getUrl(), options.data)
            .then(result => options.success(result))
            .catch(e => options.error(e));
    }

    _initForm() {
        this.actionGeom = {};

        if (this.parentControl != null) {
            $('#' + this.container).css('max-height', '80vh');
        }

        if ($('#' + this.container)[0] != null) {
            $('#' + this.container)[0].innerHTML = this._getTemplate();
            this._initControlActionHandlers();
        }


        if (!this.isPreview) {
            this.showLoadingPanel('[id="' + this.container + '"]');

        }

        this._getData().then(() => {
            this.saveTabs = false;
            this._initControls(this.metadata);
            this.saveTabs = true;
            if (!this.isPreview) {
                this._bindChangeEvents(this.metadata);
            }

            if (this.objectId != null && this.objectId != 0) {
                let formTabs = sessionStorage.getItem('formTabs');

                if (formTabs != null && formTabs.trim() != '') {
                    formTabs = JSON.parse(formTabs);

                    var tabKey;
                    if (this.formId != null) {
                        tabKey = xapp.currentApp + '_' + this.formId + '_' + this.objectId
                    }
                    else if (this.listId != null) {
                        tabKey = "lst_" + xapp.currentApp + '_' + this.listId + '_' + this.objectId
                    }
                    else if (this.mapLayerId != null) {
                        tabKey = "map_lyr_" + xapp.currentApp + '_' + this.mapLayerId + '_' + this.objectId
                    }
                    if (formTabs[tabKey] != null) {
                        let tabMetadata = this.getFieldMetadataByInternalId(formTabs[tabKey]);

                        if (tabMetadata != null) {
                            this._tabOnClick(tabMetadata.UniqueClientId);
                        }
                    }
                }
            }

            if (!this.isFilter && !this.isPreview && !this.isRow && $('#panel-hdr-title').length > 0 && this.parentControl == null) {
                $('#panel-hdr-title')[0].innerHTML = this.metadata.Name;
            }

            if (this.parentControl != null && !this.isFilter) {
                if (this.parentControl.modalInner != null && $('#' + this.parentControl.modalInner + '_wnd_title').length > 0) {
                    $('#' + this.parentControl.modalInner + '_wnd_title')[0].innerHTML = this.metadata.Name;
                } else if (this.parentControl.uniqueModalInnerId) {
                    $('#' + this.parentControl.uniqueModalInnerId + '_wnd_title')[0].innerHTML = this.metadata.Name;
                }
            }

            if (!this.isPreview) {
                if (!this.isFilter) {
                    this._initData().then(() => {
                        if (this.checkMetadataVisibility()) {
                            $('#' + this.metadata.UniqueClientId + '-wrapper').show();
                        }

                        if (this.parentControl != null) {
                            this.parentControl.centerModal();
                        }
                    });
                } else {
                    let listFilterHolder = JSON.parse(sessionStorage.getItem('listFilterHolder'));

                    if (listFilterHolder != null && listFilterHolder != null && listFilterHolder[this.listControl.uid] != null && Object.keys(listFilterHolder[this.listControl.uid]).length > 0) {
                        this.dataItem = listFilterHolder[this.listControl.uid].values;
                    }

                    this._populateItem(this.metadata, false);

                    this._handleLoadCommands().then(() => {
                        this._handleDefValueCommands(true).then(() => {
                            this.saveDataItem.values = {};
                            this._storeData(this.metadata);

                            if (this.checkMetadataVisibility()) {
                                $('#' + this.metadata.UniqueClientId + '-wrapper').show();
                            }
                            this.listControl.filterLoaded();
                        });
                    });
                }
            } else {
                this._populateItem(this.metadata, false);

                if (this.checkMetadataVisibility()) {
                    $('#' + this.metadata.UniqueClientId + '-wrapper').show();
                }
            }

            if (this.isFilter || this.isPreview) {
                this._addButtonEvents();
                this._hideLoadingPanel();
            }

            setTimeout(() => {
                if (this.parentControl != null) {
                    this.parentControl.centerModal();
                } else if (this.context == 'modal' && modalWindow != null) {
                    modalWindow.center();
                }
            }, 10);
        });

        //CG: modalul gasit prin .closest e al formularului gazda cand suntem rand de sublista,
        //asa ca N randuri s-ar lega toate la acelasi buton de inchidere
        if (!this.isRow && $('#' + this.container).closest('.k-window-content').length > 0) {
            //CG: butonul e in afara containerului, deci _disposeForm nu il curata; _initForm se reia la fiecare
            //reloadForm, asa ca legam pe un eveniment cu nume propriu si il desprindem inainte
            $('#' + this.container).closest('.k-window-content').parent().find('[aria-label="Close"]').off('click.' + this.uniqueId).on('click.' + this.uniqueId, () => {
                if (this.lastEditedLayer) {
                    let maps = Array.from(document.getElementsByClassName('xp-map'));
                    maps.forEach(map => {
                        let mapControl = map.mapControl;
                        let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;

                        featureInteractionControl.stopEdit();
                        featureInteractionControl.clear();
                        featureInteractionControl.editSuspended = false;
                    });
                }

                this._reloadDependantLayers();
            });
        }
    }

    checkMetadataVisibility() {
        if (this.metadata.Style != null && this.metadata.Style.trim() != '') {
            let style = JSON.parse(this.metadata.Style);
            if (style.styleWrapper != null && style.styleWrapper.trim() != '') {
                let wrapperStyle = style.styleWrapper;

                if (wrapperStyle.replaceAll(' ', '').indexOf('display:none') >= 0) {
                    return false;
                }
            }
        }

        return true;
    }

    centerForm() {
        if (this.parentControl != null) {
            this.parentControl.centerModal();
        }
    }

    // populate the created controls

    _getData() {
        return new Promise((resolve, reject) => {
            if (this.isPreview) {
                this.serverData = {};
                resolve();
            } else if (this.isFilter) {
                if (this.listControl != null) {
                    let listFilterHolder = JSON.parse(sessionStorage.getItem('listFilterHolder'));

                    if (this.serverData == null) {
                        if (listFilterHolder != null && listFilterHolder != null && listFilterHolder[this.listControl.uid] != null && Object.keys(listFilterHolder[this.listControl.uid]).length > 0) {
                            this.serverData = listFilterHolder[this.listControl.uid].values;
                        } else {
                            this.serverData = {};
                        }
                    }
                }
                else if (this.mapLayerId != null) {
                    let listFilterHolder = JSON.parse(sessionStorage.getItem('mapLayerFilterHolder'));

                    if (this.serverData == null) {
                        if (listFilterHolder != null && listFilterHolder != null && listFilterHolder[this.mapLayerId] != null && Object.keys(listFilterHolder[this.mapLayerId]).length > 0) {
                            this.serverData = listFilterHolder[this.mapLayerId].values;
                        } else {
                            this.serverData = {};
                        }
                    }
                }
                resolve();
            } else {
                var url;
                if (this.getDataUrl == null || this.getDataUrl == "") {
                    url = rootUrl + 'EntityForm/GetData';
                }
                else {
                    url = rootUrl + this.getDataUrl;
                }
                url += '?idForm=' + this.formId + '&pkVal=' + this.objectId;
                let dataUrl = url;

                if (this.otherParameters != null && this.otherParameters.parentPkVal != null) {
                    dataUrl += '&pkValCurrent=' + this.otherParameters.parentPkVal;
                }

                if (this.otherParameters != null && this.otherParameters.parentIdAction != null) {
                    dataUrl += '&idAction=' + this.otherParameters.parentIdAction;
                }
                if (this.idExtConn != null) {
                    dataUrl += "&idExtConn=" + this.idExtConn;
                }
                var type = "GET";
                var data = null;
                if (this.getDataPostParam != null && this.getDataPostParam != "") {
                    type = "POST";
                    data = this.getDataPostParam;
                }
                $.ajax({
                    type: type,
                    url: dataUrl,
                    data: data,
                    contentType: "application/json; charset=utf-8",
                    async: true,
                    success: (result) => {
                        this.serverData = result;
                        resolve();
                    },
                    error: (e) => {
                        toastr.error(e.responseText, this.getResource('GetDataError'));
                        this._hideLoadingPanel();
                        resolve();
                    }
                });
            }
        });
    }

    _handleLoadCommands() {
        this._mapLoadCommands([this.metadata]);
        this.loadCommands = this._sortLoadCommands(this.loadCommands);

        return new Promise((resolve, reject) => {
            let promises = [];

            let keys = Object.keys(this.loadCommands);

            keys.forEach(key => {
                promises.push(this._handleLoadCommand(this.loadCommands[key]));
            });

            Promise.all(promises).then(() => {
                resolve();
            });
        });
    }

    _handleLoadCommand(loadCommand, itemId) {
        return new Promise((resolve, reject) => {
            this.executeCommandById(loadCommand.command.Id).then(result => {
                let keys = Object.keys(loadCommand.dependands);

                keys.forEach(key => {
                    this._handleLoadCommandDependant(loadCommand.dependands[key], result);
                });

                resolve();
            }).catch(err => {
                resolve();
            });
        });
    }

    _handleLoadCommandDependant(item, data, clearWhenEmpty) {
        let value;
        if (typeof data == 'object') {
            let dataItem = {};
            if (data instanceof Array) {
                if (data.length > 0) {
                    value = [];
                    if (item.CtlProps != null && ['MultiSelect', 'MultiSelectCheckBox'].includes(item.CtlProps.CtlSubType)) {
                        data.forEach(x => {
                            value.push(x[item.Name]);
                        });
                    } else {
                        dataItem = data[0];
                        value = dataItem[item.Name];
                    }
                }
            } else {
                dataItem = data;
                value = dataItem[item.Name];
            }
        } else {
            value = data;
        }

        if (value !== null && value !== undefined) {
            item.loadCommandHandled = true;

            // MultiSelect cu serverFiltering: cand setam .value([ids]) pentru ID-uri ce nu se afla in dataSource,
            // Kendo declanseaza un read al carui url se construieste INAINTE sa comita valoarea, deci .value() e gol
            // si &fkVal pleaca gol -> serverul nu intoarce item-urile -> nu se randeaza chip-uri. Punem id-urile in
            // item.pendingFkVal (citit ca fallback in url-ul de read) inainte de a seta valoarea, ca read-ul intern
            // sa trimita &fkVal corect. Dupa ce item-urile s-au incarcat, re-setam valoarea ca Kendo sa le potriveasca.
            let isServerMultiSelect = item.CtlProps != null
                && item.CtlProps.CtlSubType == 'MultiSelect'
                && $("#" + item.UniqueClientId).data('kendoMultiSelect') != null
                && $("#" + item.UniqueClientId).data('kendoMultiSelect').dataSource.options.serverFiltering;

            if (isServerMultiSelect) {
                item.pendingFkVal = value instanceof Array ? value.join(',') : value;
            }

            if (item.CtlProps != null && item.CtlProps.CtlSubType == 'MultiSelectCheckBox') {
                this._setMultiSelectCheckBoxValue(item, value);
                this._loadMultiSelectCheckBoxItems(item);
                return;
            }

            this._applyFieldValueAndCascade(item, value);

            if (isServerMultiSelect) {
                let multiSelect = $("#" + item.UniqueClientId).data('kendoMultiSelect');
                multiSelect.dataSource.fetch(() => {
                    multiSelect.value(value);
                    item.pendingFkVal = null;
                });
            }
        } else if (clearWhenEmpty && (data == null || (data instanceof Array && data.length == 0))) {
            //CG: comanda de DefValue fara rezultat inseamna "nicio valoare", deci golim campul;
            //fara asta ramanea valoarea veche, calculata pentru parametrii anteriori
            if (item.CtlProps != null && item.CtlProps.CtlSubType == 'MultiSelectCheckBox') {
                this._clearMultiSelectCheckBoxValue(item);
                this._checkItemValidity(item);
            } else {
                this._applyFieldValueAndCascade(item, null);
            }
        }
    }

    _applyFieldValueAndCascade(item, value) {
        this._setFieldValueByItem(item, value);

        if (this._isEligibleForValidation(item)) {
            this._decorateField(item, value != null && value !== '');
        }

        if (item.Guid != null) {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = this.getCascadedDependants(item, dependants);
                this._handleCascadedItems(cascadedDependants, true);
            }
        }

        this._checkItemValidity(item);
    }

    _sortLoadCommands(data) {
        const guidToCommand = {};
        for (const [cmdId, cmdObj] of Object.entries(data)) {
            const deps = cmdObj?.dependands ?? {};
            for (const dep of Object.values(deps)) {
                if (dep && dep.Guid != null) {
                    guidToCommand[String(dep.Guid)] = cmdId;
                }
            }
        }

        const ids = Object.keys(data);
        const graph = new Map(ids.map(id => [id, new Set()]));
        const indegree = new Map(ids.map(id => [id, 0]));

        for (const [cmdId, cmdObj] of Object.entries(data)) {
            const deps = cmdObj?.dependands ?? {};
            for (const dep of Object.values(deps)) {
                const list = dep?.DependsOnGuids ?? [];
                for (const guid of list) {
                    const parent = guidToCommand[String(guid)];
                    if (parent && parent !== cmdId) {
                        const set = graph.get(parent);
                        if (!set.has(cmdId)) {
                            set.add(cmdId);
                            indegree.set(cmdId, (indegree.get(cmdId) || 0) + 1);
                        }
                    }
                }
            }
        }

        const queue = ids.filter(id => (indegree.get(id) || 0) === 0);
        const sortedIds = [];
        while (queue.length) {
            const node = queue.shift();
            sortedIds.push(node);
            for (const neigh of graph.get(node)) {
                indegree.set(neigh, indegree.get(neigh) - 1);
                if (indegree.get(neigh) === 0) queue.push(neigh);
            }
        }

        for (const id of ids) {
            if (!sortedIds.includes(id)) sortedIds.push(id);
        }

        const sortedObj = {};
        for (const id of sortedIds) {
            sortedObj['_' + id] = data[id];
        }
        return sortedObj;
    }

    _mapLoadCommands(items) {
        items.forEach(item => {
            if (item.IdXpCommandLoad != null) {
                if (this.loadCommands[item.IdXpCommandLoad] == null) {
                    let foundCommand = this.commands.find((row) => { return row.Id == item.IdXpCommandLoad });
                    this.loadCommands[item.IdXpCommandLoad] = {
                        command: foundCommand,
                        dependands: {}
                    };
                }

                this.loadCommands[item.IdXpCommandLoad].dependands[item.Id] = item;
            }

            if (item.Items != null && item.Items.length > 0) {
                this._mapLoadCommands(item.Items);
            }
        });
    }

    _collectDefValueCommandItems(items, resultBag) {
        items.forEach(item => {
            if (item.DefValue != null
                && item.DefValue.ValueType == 'XP_COMMAND'
                && item.DefValue.IdXpCommand != null
                && (this.commands || []).find(row => row.Id == item.DefValue.IdXpCommand) != null) {
                resultBag.push(item);
            }

            if (item.Items != null && item.Items.length > 0) {
                this._collectDefValueCommandItems(item.Items, resultBag);
            }
        });
    }

    _isDefValueApplicable(item, isInitial) {
        let applyTo = (item.DefValue && item.DefValue.ApplyTo) || 'NEW';
        let isNewRecord = this.objectId == null || this.objectId == '' || this.objectId == 0 || this.objectId == 'null';
        let currentValue = this.dataItem != null ? this.dataItem['fld_' + item.Id] : null;

        switch (applyTo) {
            case 'NEW':
                return isInitial && isNewRecord;
            case 'WHEN_NULL':
                return currentValue == null || currentValue === '';
            case 'EDIT':
            case 'ALLWAYS':
                if (isInitial && !isNewRecord) {
                    return false;
                }
                return true;
            default:
                return false;
        }
    }

    _isInitialValueDefValueApplicable(item) {
        let applyTo = (item.DefValue && item.DefValue.ApplyTo) || 'NEW';
        let isNewRecord = this.objectId == null || this.objectId == '' || this.objectId == 0 || this.objectId == 'null';
        let currentValue = this.dataItem != null ? this.dataItem['fld_' + item.Id] : null;

        switch (applyTo) {
            case 'NEW':
                return isNewRecord;
            case 'EDIT':
                return !isNewRecord;
            case 'WHEN_NULL':
                return currentValue == null || currentValue === '';
            case 'ALLWAYS':
                return true;
            default:
                return false;
        }
    }

    _handleDefValueCommandItem(item) {
        let cmdId = item.DefValue.IdXpCommand;

        return this.executeCommandById(cmdId, this.isClientCommand(cmdId) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null)
            .then(result => {
                this._handleLoadCommandDependant(item, result, true);
            })
            .catch(() => { });
    }

    _handleSharedServerDefValueCommand(cmdId, items) {
        return this.executeCommandById(cmdId, null)
            .then(result => {
                items.forEach(item => this._handleLoadCommandDependant(item, result, true));
            })
            .catch(() => { });
    }

    _applyJoinFieldFromOtherParameters() {
        let isNewRecord = this.objectId == null || this.objectId == 0 || this.objectId == 'null';
        if (!isNewRecord) {
            return;
        }

        if (this.otherParameters == null
            || this.otherParameters.joinFieldId == null
            || this.otherParameters.joinFieldValue == null) {
            return;
        }

        let joinFieldId = this.otherParameters.joinFieldId;
        let joinFieldValue = this.otherParameters.joinFieldValue;

        let collected = [];
        this._collectFieldsWithEntityField([this.metadata], collected);

        let target = collected.find(item =>
            item.EntityField.Id == joinFieldId
            && item.EntityField.DataSubType == 'FOREIGN_KEY');

        if (target != null) {
            this._applyFieldValueAndCascade(target, joinFieldValue);
        }
    }

    _collectFieldsWithEntityField(items, resultBag) {
        items.forEach(item => {
            if (item.EntityField != null) {
                resultBag.push(item);
            }

            if (item.Items != null && item.Items.length > 0) {
                this._collectFieldsWithEntityField(item.Items, resultBag);
            }
        });
    }

    _handleDefValueCommands(isInitial) {
        let collected = [];
        this._collectDefValueCommandItems([this.metadata], collected);

        let applicable = collected.filter(item => this._isDefValueApplicable(item, isInitial));

        let serverGroups = {};
        let clientItems = [];

        applicable.forEach(item => {
            let cmdId = item.DefValue.IdXpCommand;

            if (this.isClientCommand(cmdId)) {
                clientItems.push(item);
            } else {
                if (serverGroups[cmdId] == null) {
                    serverGroups[cmdId] = [];
                }
                serverGroups[cmdId].push(item);
            }
        });

        let promises = [];

        Object.keys(serverGroups).forEach(cmdId => {
            promises.push(this._handleSharedServerDefValueCommand(cmdId, serverGroups[cmdId]));
        });

        clientItems.forEach(item => {
            promises.push(this._handleDefValueCommandItem(item));
        });

        return Promise.all(promises);
    }

    _initData() {
        this.loadCommands = {};
        this._populateData(this.serverData);

        this._applyJoinFieldFromOtherParameters();

        return new Promise((resolve, reject) => {
            this._handleLoadCommands().then(() => {
                this._handleDefValueCommands(true).then(() => {
                    this._checkVisibility(this.metadata);
                    this._addButtonEvents();
                    this._hideLoadingPanel();

                    let finish = () => {
                        if (this.parentControl != null) {
                            this.parentControl.centerModal();
                        }

                        resolve();
                    };

                    //CG: un onFormLoaded asincron e asteptat inainte de resolve; cele sincrone merg ca inainte
                    let pending = this._runLoadHooks('onFormLoaded');

                    if (pending == null) {
                        finish();
                    } else {
                        pending.catch(e => console.error('onFormLoaded', e)).then(finish);
                    }
                });
            });
        });
    }

    applyFilters(validate) {
        if (validate) {
            this._validateFormData().then(result => {
                if (result) {
                    this._applyFilters();
                }
            });
        } else {
            this._applyFilters();
        }
    }

    _applyFilters() {
        let filters = this.getFormData();

        if (this.listControl != null) {
            this.listControl.notifyFilters(filters);
            if (this.listControl.uid != null) {
                let listFilterHolder = JSON.parse(sessionStorage.getItem('listFilterHolder'));
                listFilterHolder[this.listControl.uid] = filters;
                sessionStorage.setItem('listFilterHolder', JSON.stringify(listFilterHolder));
            }
        }
    }

    _addButtonEvents() {
        if (this.isFilter) {
            $('#' + this.searchFilterButtonId).on('click', () => {
                let filters = this.getFormData();

                this._validateFormData().then(result => {
                    if (result) {
                        if (this.listControl != null) {
                            this.listControl.notifyFilters(filters);
                            if (this.listControl.uid != null) {
                                let listFilterHolder = JSON.parse(sessionStorage.getItem('listFilterHolder'));
                                listFilterHolder[this.listControl.uid] = filters;
                                sessionStorage.setItem('listFilterHolder', JSON.stringify(listFilterHolder));
                            }
                        }
                    }
                });
            });

            $('#' + this.clearFilterButtonId).on('click', () => {
                this._clearData(this.metadata, true);

                let filters = this.getFormData();

                if (this.listControl != null) {
                    this.listControl.notifyFilters(filters);
                    if (this.listControl.uid != null) {
                        let listFilterHolder = JSON.parse(sessionStorage.getItem('listFilterHolder'));
                        listFilterHolder[this.listControl.uid] = {};
                        sessionStorage.setItem('listFilterHolder', JSON.stringify(listFilterHolder));
                    }
                }
            });
        }

        if (this.actionButtons != null) {
            let cancelButtons = this.actionButtons.filter(row => { return row.SubType == 'CANCEL' });

            if (cancelButtons.length > 0) {
                $('#form-panel-close-' + this.pageGuid).show();
            } else {
                $('#form-panel-close-' + this.pageGuid).hide();
            }

            this.actionButtons.forEach(actionButton => {
                if (actionButton.SubType == 'SAVE' || actionButton.SubType == 'APPLY') {
                    if (this.allowEdit || this.isPreview) {
                        $('#form-action-' + this.pageGuid + '-' + actionButton.Id).show();
                    }
                } else if (actionButton.SubType == 'DELETE') {
                    if (this.allowDelete || this.isPreview) {
                        $('#form-action-' + this.pageGuid + '-' + actionButton.Id).show();
                    }
                } else if (actionButton.SubType == 'SHOW_IN_MAP' && (this.objectId == null || this.objectId == '')) {
                    $('#form-action-' + this.pageGuid + '-' + actionButton.Id).hide();
                } else if (actionButton.SubType == 'EDIT_GEOMETRY' && (this.objectId == null || this.objectId == '')) {
                    let hasGeom = false;
                    if (window.featuresToBeProcessed && window.featuresToBeProcessed.layerId && window.featuresToBeProcessed.features && window.featuresToBeProcessed.features.length > 0) {
                        let maps = Array.from(document.getElementsByClassName('xp-map'));
                        maps.forEach(map => {
                            let mapControl = map.mapControl;
                            let layerSettings = mapControl.layerSettingsHandler.getLayerSettings(window.featuresToBeProcessed.layerId);

                            if (actionButton.IdFieldTarget == layerSettings.Entity.GeometryFieldId) {
                                hasGeom = true;
                                this.actionGeom[actionButton.Id] = { wkt: window.featuresToBeProcessed.features[0].geom, srid: window.featuresToBeProcessed.features[0].srid };
                            }
                        });
                    }

                    if (!hasGeom) {
                        $('#form-action-' + this.pageGuid + '-' + actionButton.Id)[0].innerHTML = this._getActionResource('AddGeometry');
                    }
                    $('#form-action-' + this.pageGuid + '-' + actionButton.Id).show();
                } else {
                    $('#form-action-' + this.pageGuid + '-' + actionButton.Id).show();
                }

                $('#form-action-' + this.pageGuid + '-' + actionButton.Id).on('click', (e) => {
                    switch (actionButton.SubType) {
                        case 'EDIT_GEOMETRY': this._editGeometry(actionButton);
                            break;
                        case 'SHOW_IN_MAP': this._showGeometry(actionButton);
                            break;
                        case 'SELECT_FROM_MAP': this._selectMapElement(actionButton);
                            break;
                        case 'DELETE': this._deleteElement(actionButton);
                            break;
                        case 'FORM': this._showForm(actionButton);
                            break;
                        case 'URL': this._showUrl(actionButton);
                            break;
                        case 'FormWf': this._showWfForm(actionButton);
                            break;
                        case 'JS': this._handleJavascriptAction(actionButton);
                            break;
                        case 'CANCEL': this._cancelForm();
                            break;
                        case 'SAVE': this._saveForm(false, '#form-action-' + this.pageGuid + '-' + actionButton.Id);
                            break;
                        case 'APPLY': this._applyFormChanges(false, '#form-action-' + this.pageGuid + '-' + actionButton.Id);
                            break;
                        default: break;
                    }
                });
            });
        }

        if (this.context != 'modal') {
            $('#form-panel-close-' + this.pageGuid).hide();
        }
    }

    _cancelForm() {
        if (window.textAnnotator) {
            window.textAnnotator.destroy();
        }

        if (this.lastEditedLayer != null) {
            let maps = Array.from(document.getElementsByClassName('xp-map'));
            maps.forEach(map => {
                let mapControl = map.mapControl;
                let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;
                featureInteractionControl.clear();
                featureInteractionControl.editSuspended = false;
            });
        }

        this._closeHost();

        this._reloadDependantLayers();
    }

    _saveForm(ignoreNotification, initiatorId) {
        this.harvestValues();
        this._saveData(false, ignoreNotification, initiatorId);
    }

    _applyFormChanges(ignoreNotification, initiatorId) {
        this.harvestValues();
        this._saveData(true, ignoreNotification, initiatorId);
    }

    validateForm() {
        this.harvestValues();
        return this._validateFormData();
    }

    _editGeometry(actionButton) {
        if (window.mapCtrl) {
            this.formGeomEdited = true;
            let layerSettings = window.mapCtrl.config.layersSettings.filter(row => { return row.geometryFieldId == actionButton.IdFieldTarget })[0];

            let mapLayerId = layerSettings.id;
            let featureId = this.objectId;

            let scale = null;

            if (layerSettings.geometryType == 'POINT') {
                scale = 500;
            }

            if (featureInteractionControl.editSuspended == true) {
                this._hideModalsForMapEdit();
                featureInteractionControl.isFromForm = true;
                featureInteractionControl.startEdit(mapLayerId, null, (response) => {
                    if (response != null && response.features != null && response.features.length > 0) {
                        this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                        $('#form-action-' + this.pageGuid + '-' + actionButton.Id)[0].innerHTML = this._getActionResource('ElementAction_EDIT_GEOMETRY');
                    }
                    this._restoreModalsAfterMapEdit();
                    featureInteractionControl.editSuspended = true;
                }, () => {
                    this._restoreModalsAfterMapEdit();
                });
            } else {
                window.mapCtrl.showFeature(mapLayerId, featureId, scale, () => {
                    this._hideModalsForMapEdit();
                    featureInteractionControl.isFromForm = true;
                    featureInteractionControl.startEdit(mapLayerId, null, (response) => {
                        if (response != null && response.features != null && response.features.length > 0) {
                            this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                            $('#form-action-' + this.pageGuid + '-' + actionButton.Id)[0].innerHTML = this._getActionResource('ElementAction_EDIT_GEOMETRY');
                        }
                        this._restoreModalsAfterMapEdit();
                        featureInteractionControl.editSuspended = true;
                    }, () => {
                        this._restoreModalsAfterMapEdit();
                    });
                }, (e) => {
                    if (e == 'Feature not found' || e == 'Feature has no geometry' || e.message == `Unexpected token '<', "<?xml vers"... is not valid JSON` || e.message == `Unexpected token '<', "<!DOCTYPE "... is not valid JSON`) {
                        this._hideModalsForMapEdit();
                        featureInteractionControl.isFromForm = true;
                        featureInteractionControl.startInsert(mapLayerId, (response) => {
                            if (response != null && response.features != null && response.features.length > 0) {
                                this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                                $('#form-action-' + this.pageGuid + '-' + actionButton.Id)[0].innerHTML = this._getActionResource('ElementAction_EDIT_GEOMETRY');
                            }
                            this._restoreModalsAfterMapEdit();
                            featureInteractionControl.editSuspended = true;
                        }, () => {
                            this._restoreModalsAfterMapEdit();
                        });
                    } else {
                        toastr.error(e);
                    }
                });
            }
        } else {
            let maps = Array.from(document.getElementsByClassName('xp-map'));
            maps.forEach(map => {
                let mapControl = map.mapControl;

                let layerSettings = mapControl.layerSettingsHandler.getLayerSettingsByField(actionButton.IdFieldTarget, this.idExtConn, this.objectId, false);

                let featureId = this.objectId;
                if (layerSettings == null) {
                    layerSettings = mapControl.layerSettingsHandler.getLayerSettingsByField(actionButton.IdFieldTarget, this.idExtConn, null, false);
                    featureId = null;
                }

                let mapLayerId = layerSettings.Id;

                let scale = null;

                if (layerSettings.Entity.GeometryFieldTyp == 'POINT') {
                    scale = 500;
                }

                let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;

                let existingFeatures;

                if (this.actionGeom != null && this.actionGeom[actionButton.Id] != null && this.actionGeom[actionButton.Id].wkt != null) {
                    existingFeatures = [this.actionGeom[actionButton.Id]];
                }

                if (featureInteractionControl.editSuspended == true || existingFeatures != null) {
                    this._hideModalsForMapEdit();
                    featureInteractionControl.isFromForm = true;
                    featureInteractionControl.startEdit(mapLayerId, null, (response) => {
                        if (response != null && response.features != null && response.features.length > 0) {
                            this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                            $('#form-action-' + this.pageGuid + '-' + actionButton.Id)[0].innerHTML = this._getActionResource('ElementAction_EDIT_GEOMETRY');
                        }
                        this._restoreModalsAfterMapEdit();
                        featureInteractionControl.editSuspended = true;
                        this.lastEditedLayer = mapLayerId;
                        featureInteractionControl.isFromForm = false;
                    }, () => {
                        this._restoreModalsAfterMapEdit();
                        this.lastEditedLayer = null;
                        featureInteractionControl.isFromForm = false;
                    }, existingFeatures);
                } else {
                    mapControl.showFeature(mapLayerId, featureId, scale, () => {
                        this._hideModalsForMapEdit();
                        featureInteractionControl.isFromForm = true;
                        featureInteractionControl.startEdit(mapLayerId, null, (response) => {
                            if (response != null && response.features != null && response.features.length > 0) {
                                this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                                $('#form-action-' + this.pageGuid + '-' + actionButton.Id)[0].innerHTML = this._getActionResource('ElementAction_EDIT_GEOMETRY');
                            }
                            this._restoreModalsAfterMapEdit();
                            featureInteractionControl.editSuspended = true;
                            this.lastEditedLayer = mapLayerId;
                            featureInteractionControl.isFromForm = false;
                        }, () => {
                            this._restoreModalsAfterMapEdit();
                            this.lastEditedLayer = null;
                            featureInteractionControl.isFromForm = false;
                        });
                    }, (e) => {
                        if (e == 'Feature not found' || e == 'Feature has no geometry' || e.message == `Unexpected token '<', "<?xml vers"... is not valid JSON` || e.message == `Unexpected token '<', "<!DOCTYPE "... is not valid JSON` || e.message == 'Unsupported GeoJSON type: undefined') {
                            this._hideModalsForMapEdit();
                            featureInteractionControl.isFromForm = true;
                            featureInteractionControl.startInsert(mapLayerId, (response) => {
                                if (response != null && response.features != null && response.features.length > 0) {
                                    this.actionGeom[actionButton.Id] = { wkt: response.features[0].geom, srid: response.features[0].srid };
                                    $('#form-action-' + this.pageGuid + '-' + actionButton.Id)[0].innerHTML = this._getActionResource('ElementAction_EDIT_GEOMETRY');
                                }
                                this._restoreModalsAfterMapEdit();
                                featureInteractionControl.editSuspended = true;
                                this.lastEditedLayer = mapLayerId;
                                featureInteractionControl.isFromForm = false;
                            }, () => {
                                this._restoreModalsAfterMapEdit();
                                this.lastEditedLayer = null;
                                featureInteractionControl.isFromForm = false;
                            });
                        } else {
                            toastr.error(e);
                        }
                    });
                }
            });
        }
    }

    //CG: ascunderea era globala iar restaurarea doar pe fereastra proprie, deci ferestrele stivuite ramaneau ascunse;
    //retinem ce era vizibil inainte de editarea pe harta si punem inapoi exact acele elemente
    _hideModalsForMapEdit() {
        if (this._hiddenModals == null) {
            this._hiddenModals = $('.k-window:visible').add($('.k-overlay:visible'));
        }

        this._hiddenModals.hide();
    }

    _restoreModalsAfterMapEdit() {
        if (this._hiddenModals != null) {
            this._hiddenModals.show();
            this._hiddenModals = null;
        }

        //fereastra proprie trebuie sa reapara chiar daca nu era in setul retinut
        $('#' + this.container).closest('.k-window').show();
    }

    _selectMapElement(actionButton) {
        this._hideModalsForMapEdit();
        $event.register("featureSelectionChanged", this.featureSelectionChangedHandler, $('#' + this.container)[0], null);
    }

    _handleMapElementSelection() {
        let featureSelectionChangedHandler = (eventName, eventArgs, sender) => {
            this._restoreModalsAfterMapEdit();

            if (eventArgs.layerId != null) {
                $event.unregister("featureSelectionChanged", this.featureSelectionChangedHandler, $('#' + this.container)[0], null);
                this.currentSelectedLayer = eventArgs.layerId;
                this.currentSelectedFeature = eventArgs.featureId;
                this.currentSelectedLayerObject = eventArgs.layer;

                if (this.mapLayerId != null) {
                    if (window['onMapElementSelected' + '_' + this.mapLayerId] && !this.isPreview) {
                        window['onMapElementSelected' + '_' + this.mapLayerId](this, this.currentSelectedLayer, this.currentSelectedFeature, this.currentSelectedLayerObject);
                    }
                }
                if (window['onMapElementSelected' + this.pageGuid] && !this.isPreview) {
                    window['onMapElementSelected' + this.pageGuid](this.currentSelectedLayer, this.currentSelectedFeature, this.currentSelectedLayerObject);
                }
                if (this.onMapElementSelected != null) {
                    this.onMapElementSelected(this, this.currentSelectedLayer, this.currentSelectedFeature, this.currentSelectedLayerObject);
                }
            }
        }

        return featureSelectionChangedHandler;
    }

    _showGeometry(actionButton) {
        if (window.mapCtrl) {
            let layerSettings = window.mapCtrl.config.layersSettings.filter(row => { return row.geometryFieldId == actionButton.IdFieldTarget })[0];

            let mapLayerId = layerSettings.id;
            let featureId = this.objectId;

            let scale = null;

            if (layerSettings.geometryType == 'POINT') {
                scale = 500;
            }

            if (legendControl != null) {
                legendControl.toggleSelection(mapLayerId, true);
            }

            window.mapCtrl.showFeature(mapLayerId, featureId, scale, () => { }, (evt) => {
                swal.fire({ title: 'Atentie', html: this._getResource(evt) });
            });
        } else {
            let maps = Array.from(document.getElementsByClassName('xp-map'));
            maps.forEach(map => {
                let mapControl = map.mapControl;

                let layerSettings = mapControl.layerSettingsHandler.getLayerSettingsByField(actionButton.IdFieldTarget, this.idExtConn, this.objectId, false);

                let mapLayerId = layerSettings.Id;
                let featureId = this.objectId;

                let scale = null;

                if (layerSettings.Entity.GeometryFieldType == 'POINT') {
                    scale = 500;
                }

                mapControl.generalActionHandler.generalActionControls.legendControl.toggleSelection(mapLayerId, true);

                mapControl.showFeature(mapLayerId, featureId, scale, () => { }, (evt) => {
                    if (typeof evt == 'object' && evt.message != null) {
                        swal.fire({ title: 'Atentie', html: this._getResource(evt.message), allowOutsideClick: false });
                    } else if (typeof evt == 'string') {
                        swal.fire({ title: 'Atentie', html: this._getResource(evt), allowOutsideClick: false });
                    }
                });
            });
        }
    }

    _deleteElement(actionButton) {
        confirmDialog.fire({
            title: this._getCustomFormResource('DeleteItemTitle'),
            text: this._getCustomFormResource('DeleteItemContent'),
            allowOutsideClick: false
        }).then((result) => {
            if (result.value) {
                let url = rootUrl + 'Entity/DeleteData';
                let data = {
                    pkVal: this.objectId,
                    idEntity: this.metadata.IdEntity,
                    idExtConn: this.idExtConn
                };

                $.ajax({
                    type: "POST",
                    url: url,
                    async: true,
                    data: JSON.stringify(data),
                    contentType: "application/json; charset=utf-8",
                    headers: {
                        'X-XSRF-TOKEN': getCookie('XSRF-TOKEN')
                    },
                    success: (result) => {
                        let maps = Array.from(document.getElementsByClassName('xp-map'));

                        maps.forEach(map => {
                            let mapControl = map.mapControl;

                            if (this.lastEditedLayer != null) {
                                let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;
                                featureInteractionControl.clear();
                                featureInteractionControl.editSuspended = false;
                            }

                            mapControl.refresh();
                            mapControl.clearSelection();
                        });

                        this._closeHost();
                    },
                    error: (e) => {
                        toastr.error(this._getCustomFormResource('RemoveItemError'));
                    }
                });
            }
        });
    }

    _showForm(actionButton) {
        let url = rootUrl + 'EntityForm/EntityFormRuntime';

        //idform
        if (actionButton.IdFormTarget != null && actionButton.IdFormTarget != '') {
            url += '?idForm=' + actionButton.IdFormTarget;
        } else {
            url += '?idForm=' + this.getFieldData(actionButton.IdFormUIObjTarget);
        }
        if (this.idExtConn = null) {
            url += '&idExtConn=' + this.idExtConn;
        }

        //pkVal
        if (actionButton.NewRecord) {
            //do nothing here
        }
        else {
            if (actionButton.IdUIObjTarget != null) {
                url += '&pkVal=' + this.getFieldData(actionButton.IdUIObjTarget);
            } else {
                url += '&pkVal=' + this.objectId;
            }
        }

        url += '&idaction=' + actionButton.Id + '&pkValCurrent=' + this.objectId;

        if (url.indexOf('idApp') < 0) {
            url += '&idApp=' + xapp.currentApp;
        }

        if (this.parentGuid == null || this.parentGuid == '') {
            $.pjax({ url: url, container: '#js-page-content', timeout: 10000, contentType: 'application/json' })
        } else {
            let width = null;
            let height = null;
            if (actionButton.UiContent != null && actionButton.UiContent.trim() != '') {
                let uiContent = JSON.parse(actionButton.UiContent);

                if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                    width = uiContent.modalWidth;
                }

                if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                    height = uiContent.modalHeight;
                }
            }

            this.initModal('', height, url, false, width);
        }
    }

    _getXpList(identifier) {
        let lists = $('.xp-list-container');

        if (lists.length > 0) {
            for (let i = 0; i < lists.length; i++) {
                if (lists[i][identifier]) {
                    return lists[i][identifier];
                }
            }
        }
    }

    _showUrl(actionButton) {
        let url = actionButton.Url;

        if (this.parentGuid == null || this.parentGuid == '') {
            if (url.indexOf('http') == 0) {
                window.open(url, '_blank');
            } else {
                $.pjax({ url: url, container: '#js-page-content', timeout: 10000 })
            }
        } else {
            if (url.indexOf('http') == 0) {
                window.open(url, '_blank');
            } else {
                let width = null;
                let height = null;

                if (actionButton.UiContent != null && actionButton.UiContent.trim() != '') {
                    let uiContent = JSON.parse(actionButton.UiContent);

                    if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                        width = uiContent.modalWidth;
                    }

                    if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                        height = uiContent.modalHeight;
                    }
                }

                this.initModal('', height, url, false, width);
            }
        }
    }

    _checkMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    initModal(title, height, url, hideButtons, width, keepForm) {
        let modalOptions = {
            draggable: true,
            resizable: true,
            width: width != null ? width : "70%",
            height: height != null ? height : "auto",
            title: title,
            modal: $('.map-centered').length == 0,
            close: () => { this.closeModal(keepForm); },
            actions: hideButtons ? [] : ["Minimize", "Maximize", "Close"]
        };

        if (this._checkMobile()) {
            modalOptions.height = 'auto';
            modalOptions.maxHeight = 'calc(100% - 3.8rem)';
            modalOptions.width = '100%';
        }

        if (url != null && url != '') {
            if (url.indexOf('?') >= 0) {
                url += '&context=modal&parentGuid=' + this.uniqueId;
            } else {
                url += '?context=modal&parentGuid=' + this.uniqueId;
            }

            modalOptions.content = {
                type: "GET",
                url: url,
                contentType: "application/json"
            };
        }

        $('#' + this.uniqueModalId).append('<div class="p-1" id="' + this.uniqueModalInnerId + '"></div>');

        $('#' + this.uniqueModalInnerId).kendoWindow(modalOptions);

        if ($('body')[0].classList.contains('mod-skin-dark')) {
            $('.k-window').addClass('mod-skin-dark');
        }

        if (this._checkMobile()) {
            // reaplicam full-screen-ul dupa ce continutul remote este incarcat (Kendo recalculeaza layout-ul)
            $('#' + this.uniqueModalInnerId).data("kendoWindow").bind("refresh", () => {
                this._stretchModalFullScreen($('#' + this.uniqueModalInnerId).data("kendoWindow"));
            });
        }

        this.centerModal();

        if (!hideButtons) {
            this._hideOwnWindow();
        }
    }

    centerModal() {
        let kendoWindow = $('#' + this.uniqueModalInnerId).data("kendoWindow");
        kendoWindow.center();

        if (this._checkMobile()) {
            // pe mobil fortam fereastra sa ocupe tot ecranul sub header (3.8rem)
            this._stretchModalFullScreen(kendoWindow);
        }
    }

    // Kendo Window cu height:'auto' se intinde doar dupa continut si .center() o pozitioneaza
    // gresit la width:100% (din cauza border-ului wrapper-ului). Pe mobil ancoram explicit
    // wrapper-ul la viewport ca sa umple toata pagina sub header.
    _stretchModalFullScreen(kendoWindow) {
        if (kendoWindow == null) {
            return;
        }

        kendoWindow.wrapper.css({
            position: 'fixed',
            top: '3.8rem',
            left: '0',
            right: '0',
            width: '100%',
            height: 'calc(100% - 3.8rem)',
            'max-height': 'none',
            margin: '0'
        });

        // continutul ferestrei trebuie sa umple wrapper-ul, mai putin bara de titlu
        let titlebarHeight = kendoWindow.wrapper.children('.k-window-titlebar').outerHeight() || 0;
        kendoWindow.wrapper.children('.k-window-content').css({
            height: 'calc(100% - ' + titlebarHeight + 'px)',
            'max-height': 'none'
        });
    }

    //CG: fereastra gasita prin .closest e comuna mai multor instante (randuri de sublista, formulare stivuite),
    //deci o ascundem cu numarator - prima cerere ascunde, ultima eliberare arata inapoi
    _hideOwnWindow() {
        let hostWindow = $('#' + this.container).closest('.k-window');

        if (hostWindow.length == 0) { return; }

        let count = (hostWindow.data('xpHideCount') || 0) + 1;
        hostWindow.data('xpHideCount', count);

        if (count == 1) {
            hostWindow.hide();
        }
    }

    _showOwnWindow() {
        let hostWindow = $('#' + this.container).closest('.k-window');

        if (hostWindow.length == 0) { return; }

        let count = Math.max((hostWindow.data('xpHideCount') || 0) - 1, 0);
        hostWindow.data('xpHideCount', count);

        if (count == 0) {
            hostWindow.show();
        }
    }

    closeModal(keepForm) {
        $('#' + this.uniqueModalInnerId).data("kendoWindow").destroy();
        this._showOwnWindow();

        if (!keepForm) {
            this.reloadForm();
        }
    }

    _showWfForm(actionButton) {
        var url = rootUrl + 'UIAction/GetFormWFRun?idAction=' + actionButton.Id;

        if (actionButton.Content != null && actionButton.Content.trim() != '') {
            let paramsMap = JSON.parse(actionButton.Content);
            let params = {};
            if (paramsMap.length > 0) {
                paramsMap.forEach(param => {
                    params[param] = this.getFieldValueById(param);
                });
            }

            url += '&parameters=' + JSON.stringify(params);
        }

        if (this.parentGuid == null || this.parentGuid == '') {
            $.pjax({ url: url, container: '#js-page-content', timeout: 10000 })
        } else {
            let width = null;
            let height = null;

            if (actionButton.UiContent != null && actionButton.UiContent.trim() != '') {
                let uiContent = JSON.parse(actionButton.UiContent);

                if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                    width = uiContent.modalWidth;
                }

                if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                    height = uiContent.modalHeight;
                }
            }

            this.initModal('', height, url, false, width);
        }
    }

    _handleJavascriptAction(actionButton) {
        if (window['btn_' + actionButton.Id + '_onClick'] != null) {
            window['btn_' + actionButton.Id + '_onClick']();
        }
        if (window['xp_form_action_' + actionButton.Id + '_onClick'] != null) {
            window['xp_form_action_' + actionButton.Id + '_onClick'](this);
        }
    }

    _handleControlJavascriptAction(action, controlMetadata) {
        let control = this.getFieldByUniqueId(controlMetadata.UniqueClientId);
        if (window['btn_' + action.Id + '_onClick'] != null) {
            window['btn_' + action.Id + '_onClick']();
        }
        if (window['xp_control_action_' + action.Id + '_onClick'] != null) {
            window['xp_control_action_' + action.Id + '_onClick'](this, control);
        }
    }

    _initControlActionHandlers() {
        let container = $('#' + this.container);
        container.off('.xpControlActions');
        $(document).off('.' + this.uniqueId + '.xpControlActions');

        container.on('click.xpControlActions', '.xp-control-action-group-button', (event) => {
            event.preventDefault();
            event.stopPropagation();

            let group = $(event.currentTarget).closest('.xp-control-action-group');
            let menu = group.children('.xp-control-action-menu');
            let shouldOpen = !menu.hasClass('show');
            if (shouldOpen) {
                container.find('.xp-control-action-menu.show').not(group.parents('.xp-control-action-menu')).each(function () {
                    $(this).removeClass('show').siblings('.xp-control-action-group-button').attr('aria-expanded', 'false');
                });
                menu.addClass('show');
            } else {
                menu.add(menu.find('.xp-control-action-menu.show')).each(function () {
                    $(this).removeClass('show').siblings('.xp-control-action-group-button').attr('aria-expanded', 'false');
                });
            }
            group.children('.xp-control-action-group-button').attr('aria-expanded', shouldOpen ? 'true' : 'false');
        });

        container.on('click.xpControlActions', '.xp-control-action', (event) => {
            event.preventDefault();
            event.stopPropagation();

            let button = $(event.currentTarget);
            let controlMetadata = this._findControlMetadata(button.attr('data-control-client-id'));
            if (controlMetadata == null) {
                return;
            }
            let action = this._findControlAction(controlMetadata, button.attr('data-control-action-id'));
            if (action != null) {
                this._handleControlAction(action, controlMetadata, button);
            }
            container.find('.xp-control-action-menu.show').each(function () {
                $(this).removeClass('show').siblings('.xp-control-action-group-button').attr('aria-expanded', 'false');
            });
        });

        $(document).on('click.' + this.uniqueId + '.xpControlActions', (event) => {
            if ($(event.target).closest('#' + this.container + ' .xp-control-action-group').length == 0) {
                container.find('.xp-control-action-menu.show').each(function () {
                    $(this).removeClass('show').siblings('.xp-control-action-group-button').attr('aria-expanded', 'false');
                });
            }
        });
    }

    _handleControlAction(action, controlMetadata, button) {
        switch (action.SubType) {
            case 'EDIT_GEOMETRY': this._editGeometry(action); break;
            case 'SHOW_IN_MAP': this._showGeometry(action); break;
            case 'SELECT_FROM_MAP': this._selectMapElement(action); break;
            case 'DELETE': this._deleteElement(action); break;
            case 'FORM': this._showForm(action); break;
            case 'URL': this._showUrl(action); break;
            case 'FormWf': this._showWfForm(action); break;
            case 'JS': this._handleControlJavascriptAction(action, controlMetadata); break;
            case 'CANCEL': this._cancelForm(); break;
            case 'SAVE': this._saveForm(false, button); break;
            case 'APPLY': this._applyFormChanges(false, button); break;
            default: break;
        }
    }

    _findControlMetadata(uniqueClientId) {
        let result = null;
        let visit = (item) => {
            if (item == null || result != null) {
                return;
            }
            if (item.UniqueClientId == uniqueClientId) {
                result = item;
                return;
            }
            if (item.Items != null) {
                item.Items.forEach(visit);
            }
        };
        visit(this.metadata);
        return result;
    }

    _findControlAction(controlMetadata, actionId) {
        let result = null;
        let visit = (actions) => {
            if (actions == null || result != null) {
                return;
            }
            actions.forEach(action => {
                if (action.Id == actionId) {
                    result = action;
                    return;
                }
                visit(action.Items);
            });
        };
        visit(controlMetadata.Actions);
        return result;
    }

    getFieldData(id) {
        let formData = this.getFormData();
        return formData.values['fld_' + id];
    }

    getFormData() {
        this._storeData(this.metadata);
        this._storeGeomData();
        return this.saveDataItem;
    }

    _storeGeomData() {
        if (this.fromActionType != 'EDIT_MULTI' && this.fromActionType != 'ADD_MULTI') {
            let keys = Object.keys(this.actionGeom);
            keys.forEach(key => {
                this.saveDataItem.values['act_' + key] = this.actionGeom[key];
            });
        }
    }

    //CG: randurile subformularelor calatoresc in acelasi "values" ca si campurile, sub o cheie proprie;
    //serverul le salveaza dupa parinte, in aceeasi tranzactie (vezi UISubformDto.RowsValueKeyPrefix)
    _storeRowsData() {
        let keys = Object.keys(this.sublists);

        for (let i = 0; i < keys.length; i++) {
            let sublist = this.sublists[keys[i]];

            //CG: in registru stau si ListControl-urile grilelor, care nu au ce culege
            if (sublist == null || typeof sublist.harvest !== 'function') {
                continue;
            }

            this.saveDataItem.values[SubformControl.VALUE_KEY_PREFIX + sublist.item.Id] = sublist.harvest();
        }
    }

    //CG: fisierele pleaca pe disc doar la salvarea gazdei, iar un rand de sublista nu se salveaza singur -
    //deci gazda trebuie sa incarce si dropzone-urile randurilor, altfel payload-ul lor duce un dzIdentifier
    //fara chunk-uri comise si salvarea intregului lot cade cu FileNotFoundException
    _collectPendingUploads() {
        let pending = this._getOwnPendingUploads();

        Object.keys(this.sublists).forEach(key => {
            let sublist = this.sublists[key];

            //CG: in registru stau si ListControl-urile grilelor, care nu au randuri
            if (sublist == null || typeof sublist.getRows !== 'function') {
                return;
            }

            sublist.getRows().forEach(row => {
                if (row.formControl != null) {
                    pending = pending.concat(row.formControl._getOwnPendingUploads());
                }
            });
        });

        return pending;
    }

    //CG: perechea poarta si formularul, nu doar cheia - randurile au propriile dropzones/uploadedFiles
    _getOwnPendingUploads() {
        if (this.uploadedFiles == null) {
            return [];
        }

        return Object.keys(this.uploadedFiles)
            .filter(key => !this.uploadedFiles[key].uploadedFileProcessed)
            .map(key => { return { formControl: this, key: key }; });
    }

    // send data to backend

    _saveData(reloadData, ignoreNotification, initiatorId) {
        //CG: marcajele randurilor refuzate la incercarea precedenta ar ramane pe ecran dupa corectare
        this._clearRowErrors();

        this._validateFormData().then(result => {
            if (result) {
                this._storeData(this.metadata);
                this._storeGeomData();
                this._storeRowsData();

                let filesToUpload = this._collectPendingUploads();

                if (filesToUpload.length > 0) {
                    this._uploadFilesAndSubmitData(filesToUpload, reloadData, ignoreNotification, initiatorId);
                } else {
                    this._submitData(reloadData, ignoreNotification, initiatorId);
                }
            } else {
                let content = `<span style="font-weight: bold;">` + this._getResource('InvalidFieldsIntro') + `</span><br>`;
                let errorCount = 5;
                let needsEllipsis = true;
                let errorKeys = Object.keys(this.invalidFields);

                if (errorKeys.length < errorCount) {
                    errorCount = errorKeys.length;
                    needsEllipsis = false;
                }

                for (let i = 0; i < errorCount; i++) {
                    content += `<span>` + this.invalidFields[errorKeys[i]].message + `</span><br>`;
                }

                if (needsEllipsis) {
                    content += `<span>...</span>`;
                }

                swal.fire({ title: this._getResource('Attention'), html: content });
                this.invalidFields = {};
            }
        });
    }

    _saveState(ignoreNotification, ignoreValidation) {
        return new Promise((resolve, reject) => {
            var url;
            if (this.saveDataUrl == null || this.saveDataUrl == "") {
                url = rootUrl + 'EntityForm/SaveData';
            }
            else {
                url = rootUrl + this.saveDataUrl;
            }
            let saveDataUrl = url;

            this.saveDataItem.otherParameters = this.otherParameters;
            if (this.saveDataPostParam != null && this.saveDataPostParam != "") {
                this.saveDataItem.postParam = this.saveDataPostParam;
            }

            if (ignoreNotification) {
                this.saveDataItem.ignoreNotify = true;
            }

            if (ignoreValidation) {
                this.saveDataItem.ignoreNullValidation = true;
            }

            $.ajax({
                type: "POST",
                url: saveDataUrl,
                headers: {
                    'X-XSRF-TOKEN': getCookie('XSRF-TOKEN')
                },
                async: true,
                data: JSON.stringify(this.saveDataItem),
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    if (result != null && (result.Error == null || result.Error == '')) {
                        resolve(result);
                    } else if (result == null || result.Error == null) {
                        reject(this.getResource('GetLayoutError'));
                        toastr.error(this.getResource('GetLayoutError'));
                    } else {
                        toastr.error(result.Error);
                        reject(result.Error);
                    }
                },
                error: (e) => {
                    toastr.error(this.getResource('GetLayoutError'));
                    reject(this.getResource('GetLayoutError'));
                }
            });
        });
    }

    //CG: filesToUpload sunt perechi {formControl, key} - cheia singura nu mai ajunge de cand incarcam
    //si fisierele randurilor de sublista, care stau in dropzones-ul propriului FormControl
    _uploadFilesAndSubmitData(filesToUpload, reloadData, ignoreNotification, initiatorId) {
        let invalidSize = false;
        filesToUpload.forEach((fileToUpload) => {
            const dz = fileToUpload.formControl.dropzones[fileToUpload.key].get(0).dropzone;
            dz.files.forEach(file => {
                if (file.size == 0) {
                    invalidSize = true;
                }
            });
        });

        if (invalidSize) {
            swal.fire({ title: 'Atentie', html: 'Fisierele incarcate nu pot fi goale!' });
            return;
        }

        this.reloadAfterSubmit = reloadData;
        this.ignoreNotificationAfterSubmit = ignoreNotification;
        this.initiatorIdAfterSubmit = initiatorId;
        this.initModal(this._getResource('FilesUploadTitle'), 'auto', null, true, '50%');

        let template = `<div class="panel-content file-uploads-panel">`;

        filesToUpload.forEach(fileToUpload => {
            const dz = fileToUpload.formControl.dropzones[fileToUpload.key].get(0).dropzone;
            dz.files.forEach(file => {
                template += `<div class="form-row">
                            <label class="form-label pl-1">` + file.name + `</label>
                        </div>
                        <div class="file-upload-progress" id="${file.upload.uuid}-progress">
                            <div class="file-upload-bar" id="${file.upload.uuid}-bar">0%</div>
                         </div>`;
            });
        });
        //CG: id-urile erau literale intr-un modal care e per-instanta, deci a doua incarcare simultana
        //se lega la butonul primei; le sufixam si le cautam doar in modalul propriu
        template += `<div id="` + this.uploadButtonsId + `" style="display: none;"><div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right pr-0 pb-0 pt-2 pl-0 mr-0 ml-0" style="padding-bottom: 0.5rem !important; display: none;"><button id="` + this.uploadCancelId + `" class="btn ml-auto btn-secondary" title="` + this._getResource('Cancel') + `" type="button">` + this._getResource('Cancel') + `</button></div></div>`;
        template += `</div>`;

        $('#' + this.uniqueModalInnerId).append(template);
        this.centerModal();

        $('#' + this.uniqueModalInnerId).find('#' + this.uploadCancelId).off('click').on('click', () => {
            this.closeModal();
        });

        filesToUpload.forEach(fileToUpload => {
            const dz = fileToUpload.formControl.dropzones[fileToUpload.key].get(0).dropzone;
            var filesToUploadCount = 0;
            dz.files.forEach(file => {
                if (file.upload != null) {
                    filesToUploadCount++;
                }
            });
            fileToUpload.formControl.uploadedFiles[fileToUpload.key].uploadedFiles = 0;
            fileToUpload.formControl.uploadedFiles[fileToUpload.key].filesToUpload = filesToUploadCount;
            dz.files.forEach(file => {
                if (file.upload != null) {
                    dz.uploadFile(file);
                }
            });
        });
    }

    //CG: randurile salvate nu se marcheaza aici - pe reincarcare stiva se reconstruieste si se rehidrateaza
    //din baza (obiectId-ul nou e pus mai jos, inainte de reloadForm), iar pe inchidere nu mai conteaza
    _onAfterFormSaved(reloadData, data, result) {
        if (!reloadData) {
            if (this.lastEditedLayer) {
                let maps = Array.from(document.getElementsByClassName('xp-map'));
                maps.forEach(map => {
                    let mapControl = map.mapControl;
                    let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;

                    featureInteractionControl.stopEdit();
                    featureInteractionControl.clear();
                    featureInteractionControl.editSuspended = false;
                });
            }

            this._reloadDependantLayers();

            this._closeHost();
        } else {
            if (this.lastEditedLayer != null) {
                let maps = Array.from(document.getElementsByClassName('xp-map'));
                maps.forEach(map => {
                    let mapControl = map.mapControl;
                    let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;
                    featureInteractionControl.clear();
                    featureInteractionControl.editSuspended = false;
                });
            }

            this._reloadDependantLayers();

            if (result.jsonEntity != null && result.jsonEntity != '') {
                let parsedResult = JSON.parse(result.jsonEntity);

                let newId = parsedResult.pkVal;
                if (this.objectId != newId) {
                    this.objectId = newId;
                    this.saveDataItem.pkVal = this.objectId;

                    if (this.context == 'full') {
                        var newURL = this._updateURLParameter(window.location.href, 'pkVal', newId);
                        let state = history.state;

                        if (state != null) {
                            state.url = newURL;
                        }

                        history.replaceState(state, '', newURL);
                    }
                }
            }

            this.reloadForm();
        }
    }

    _getSubformRowsForCallbacks() {
        return Object.values(this.sublists).filter(subform => subform instanceof SubformControl).flatMap(subform => {
            let sentRows = this.saveDataItem.values[SubformControl.VALUE_KEY_PREFIX + subform.item.Id] || [];
            return subform.getRows().map(row => ({
                form: row.formControl,
                data: sentRows.find(sentRow => sentRow.__rowId == row.rowId)
            })).filter(row => row.form != null && row.data != null);
        });
    }

    async _runBeforeSaveCallbacks() {
        if (this.onBeforeFormSaved != null && await this.onBeforeFormSaved(this, this.saveDataItem) === false) {
            return false;
        }
        for (const row of this._getSubformRowsForCallbacks()) {
            if (row.form.onBeforeFormSaved != null && await row.form.onBeforeFormSaved(row.form, row.data) === false) {
                return false;
            }
        }
        return true;
    }

    async _runAfterSaveCallbacks(data, result) {
        if (this.onAfterFormSaved != null) {
            await this.onAfterFormSaved(this, data, result);
        }
        for (const row of this._getSubformRowsForCallbacks()) {
            if (row.form.onAfterFormSaved != null) {
                await row.form.onAfterFormSaved(row.form, row.data, result);
            }
        }
    }

    _saveFormData(reloadData, ignoreNotification, initiatorId, saveDataUrl) {
        if (initiatorId != null && $(initiatorId) != null) {
            $(initiatorId).attr('disabled', true);
        }
        var data = null;

        //CG: featuresToBeProcessed e global pe pagina, deci randurile de sublista nu au voie sa il consume -
        //altfel toate ar stampila aceeasi geometrie; il si golim dupa ce l-am folosit, ca la ramura MULTI
        if (!this.isRow && this.fromActionType == 'ADD' && this.saveDataItem.values) {
            if (window.featuresToBeProcessed && window.featuresToBeProcessed.layerId && window.featuresToBeProcessed.features && window.featuresToBeProcessed.features.length > 0) {
                this.saveDataItem.values['ml_' + window.featuresToBeProcessed.layerId] = { wkt: window.featuresToBeProcessed.features[0].geom, srid: window.featuresToBeProcessed.features[0].srid };
                this.lastEditedLayer = window.featuresToBeProcessed.layerId;
                window.featuresToBeProcessed = null;
            }
        }
        if (!this.isRow && (this.fromActionType == 'ADD_MULTI' || this.fromActionType == 'EDIT_MULTI') && this.saveDataItem.values) {
            if (window.featuresToBeProcessed && window.featuresToBeProcessed.layerId && window.featuresToBeProcessed.features && window.featuresToBeProcessed.features.length > 0) {
                let data = [];
                this.lastEditedLayer = window.featuresToBeProcessed.layerId;

                window.featuresToBeProcessed.features.forEach(x => {
                    let clone = JSON.parse(JSON.stringify(this.saveDataItem));

                    if (this.fromActionType == 'EDIT_MULTI') {
                        clone.pkVal = x;
                    } else if (this.fromActionType == 'ADD_MULTI') {
                        clone.values['ml_' + window.featuresToBeProcessed.layerId] = { wkt: x.geom, srid: x.srid };
                    }

                    data.push(clone);
                });

                window.featuresToBeProcessed = null;
            }
        }

        //multiplicam folosind fisierele uploadate daca este cazul
        if (this.objectId == null || this.objectId == '') {
            if (this.uploadedFiles != null && Object.keys(this.uploadedFiles).length > 0) {
                let fileKeys = Object.keys(this.uploadedFiles);

                if (fileKeys.length > 0) {
                    fileKeys.forEach(fileToUploadKey => {
                        const dz = $('#' + fileToUploadKey)[0].dropzone;
                        const idUiObj = $('#' + fileToUploadKey)[0].dataset.idUiObj;
                        var iFilesCount = 0;
                        for (const file of dz.files) {
                            if (file.upload != null) {
                                iFilesCount++;
                            }
                        }
                        if (iFilesCount > 1) {
                            //clonam datele existente
                            if (data == null) {
                                data = [];
                                let clone = JSON.parse(JSON.stringify(this.saveDataItem));
                                data.push(clone);
                            }

                            var newData = [];
                            for (const file of dz.files) {
                                if (file.upload != null) {
                                    for (const item of data) {
                                        let clone = JSON.parse(JSON.stringify(item));
                                        //setam valorile din fisier pe noul item


                                        clone.values['fld_' + idUiObj] = true;
                                        clone.values['fld_' + idUiObj + '_dzIdentifier'] = file.upload.uuid;
                                        clone.values['fld_' + idUiObj + '_xp_fileName'] = file.name;
                                        clone.values['fld_' + idUiObj + '_xp_mimeType'] = file.type;

                                        newData.push(clone);
                                    }
                                }
                            }
                            data = newData;
                        }
                    });
                }
            }
        }

        if (data != null) {
            saveDataUrl = rootUrl + 'EntityForm/SaveBulkData';
            showLoadingPanel();
            $.ajax({
                type: "POST",
                url: saveDataUrl,
                async: true,
                data: JSON.stringify(data),
                contentType: "application/json; charset=utf-8",
                headers: {
                    'X-XSRF-TOKEN': getCookie('XSRF-TOKEN')
                },
                success: (result) => {
                    hideLoadingPanel();
                    if (this.lastEditedLayer != null) {
                        let maps = Array.from(document.getElementsByClassName('xp-map'));
                        maps.forEach(map => {
                            let mapControl = map.mapControl;
                            let featureInteractionControl = mapControl.generalActionHandler.generalActionControls.editControl;
                            featureInteractionControl.clear();
                            featureInteractionControl.editSuspended = false;
                        });
                    }

                    this._reloadDependantLayers();

                    this._closeHost();
                },
                error: (e) => {
                    hideLoadingPanel();
                    if (initiatorId != null && $(initiatorId) != null) {
                        $(initiatorId).attr('disabled', false);
                    }

                    toastr.error(this.getResource('GetLayoutError'));
                }
            });
        } else {
            showLoadingPanel();
            $.ajax({
                type: "POST",
                url: saveDataUrl,
                async: true,
                data: JSON.stringify(this.saveDataItem),
                contentType: "application/json; charset=utf-8",
                headers: {
                    'X-XSRF-TOKEN': getCookie('XSRF-TOKEN')
                },
                success: (result) => {
                    hideLoadingPanel();
                    if (initiatorId != null && $(initiatorId) != null) {
                        $(initiatorId).attr('disabled', false);
                    }

                    if (result != null && (result.Error == null || result.Error == '')) {
                        var data = this.saveDataItem;
                        if (result.jsonEntity != null && result.jsonEntity != '') {
                            var parsedResult = JSON.parse(result.jsonEntity);
                            data.pkVal = parsedResult.pkVal;
                        }
                        let finishSave = () => this._runAfterSaveCallbacks(data, result).then(() => {
                            this._onAfterFormSaved(reloadData, data, result);
                        });

                        if (this.formId != null && window['onAfterFormSaved' + '_' + this.formId] != null && !this.isPreview) {
                            window['onAfterFormSaved' + '_' + this.formId](this, data, result).then(finishSave);
                        }
                        else if (window['onAfterFormSaved' + this.pageGuid] != null && !this.isPreview) {
                            //window['onAfterFormSaved' + this.pageGuid](this, data, result).then(finishSave);
                            const fn = window['onAfterFormSaved' + this.pageGuid];

                            if (typeof fn === 'function') {
                                if (fn.length >= 3) {
                                    fn(this, data, result).then(finishSave);
                                } else {
                                    fn(data, result).then(finishSave);
                                }
                            }
                        }
                        else {
                            finishSave();
                        }
                    } else if (result == null || result.Error == null) {
                        toastr.error(this.getResource('GetLayoutError'));
                    } else {
                        let reportError = () => this._runAfterSaveCallbacks(this.saveDataItem, result).then(() => {
                            this._reportSaveError(result);
                        });
                        if (this.formId != null && window['onAfterFormSaved' + '_' + this.formId] != null && !this.isPreview) {
                            window['onAfterFormSaved' + '_' + this.formId](this, this.saveDataItem, result).then(reportError);
                        }
                        else if (window['onAfterFormSaved' + this.pageGuid] != null && !this.isPreview) {
                            //window['onAfterFormSaved' + this.pageGuid](this, this.saveDataItem, result).then(reportError);
                            const fn = window['onAfterFormSaved' + this.pageGuid];

                            if (typeof fn === 'function') {
                                if (fn.length >= 3) {
                                    fn(this, this.saveDataItem, result).then(reportError);
                                } else {
                                    fn(this.saveDataItem, result).then(reportError);
                                }
                            }
                        } else {
                            reportError();
                        }
                    }
                },
                error: (e) => {
                    hideLoadingPanel();
                    if (initiatorId != null && $(initiatorId) != null) {
                        $(initiatorId).attr('disabled', false);
                    }

                    toastr.error(this.getResource('GetLayoutError'));
                }
            });
        }
    }

    _submitData(reloadData, ignoreNotification, initiatorId) {
        var url;
        if (this.saveDataUrl == null || this.saveDataUrl == "") {
            url = rootUrl + 'EntityForm/SaveData';
        }
        else {
            url = rootUrl + this.saveDataUrl;
        }
        let saveDataUrl = url;

        this.saveDataItem.otherParameters = this.otherParameters;
        if (this.saveDataPostParam != null && this.saveDataPostParam != "") {
            this.saveDataItem.postParam = this.saveDataPostParam;
        }

        if (ignoreNotification) {
            this.saveDataItem.ignoreNotify = true;
        }

        this._runBeforeSaveCallbacks().then(save => {
            if (!save) {
                return;
            }
            if (this.formId != null && window['onBeforeFormSaved' + '_' + this.formId] != null && !this.isPreview) {
                window['onBeforeFormSaved' + '_' + this.formId](this, this.saveDataItem).then(allowSave => {
                    if (allowSave) {
                        this._saveFormData(reloadData, ignoreNotification, initiatorId, saveDataUrl);
                    }
                });
            }
            else if (window['onBeforeFormSaved' + this.pageGuid] != null && !this.isPreview) {
                // window['onBeforeFormSaved' + this.pageGuid](this.saveDataItem).then(allowSave => {
                //     if (allowSave) {
                //         this._saveFormData(reloadData, ignoreNotification, initiatorId, saveDataUrl);
                //     }
                // });
                const fn = window['onBeforeFormSaved' + this.pageGuid];

                if (typeof fn === 'function') {
                    if (fn.length >= 2) {
                        fn(this, this.saveDataItem).then(allowSave => {
                            if (allowSave) {
                                this._saveFormData(reloadData, ignoreNotification, initiatorId, saveDataUrl);
                            }
                        });
                    } else {
                        fn(this.saveDataItem).then(allowSave => {
                            if (allowSave) {
                                this._saveFormData(reloadData, ignoreNotification, initiatorId, saveDataUrl);
                            }
                        });
                    }
                }
            }
            else {
                this._saveFormData(reloadData, ignoreNotification, initiatorId, saveDataUrl);
            }
        });
    }

    _updateURLParameter(url, param, paramVal) {
        var newAdditionalURL = "";
        var tempArray = url.split("?");
        var baseURL = tempArray[0];
        var additionalURL = tempArray[1];
        var temp = "";
        if (additionalURL) {
            tempArray = additionalURL.split("&");
            for (var i = 0; i < tempArray.length; i++) {
                if (tempArray[i].split('=')[0] != param) {
                    newAdditionalURL += temp + tempArray[i];
                    temp = "&";
                }
            }
        }

        var rows_txt = temp + "" + param + "=" + paramVal;
        return baseURL + "?" + newAdditionalURL + rows_txt;
    }

    _validateFormData() {
        return new Promise((resolve, reject) => {
            this.isValid = true;
            //CG: sumarul se reconstruieste din validarea de acum, nu din ce au lasat handler-ele de change
            this.invalidFields = {};

            let keys = Object.keys(this.saveDataItem.values);
            let promises = [];

            for (let i = 0; i < keys.length; i++) {
                if (keys[i].indexOf('fld') >= 0) {
                    let tuples = keys[i].split('_');

                    if (tuples.length == 2) {
                        let id = tuples[1];

                        let item = this._searchFieldById(this.metadata, id);

                        promises.push(this._checkItemValidity(item));
                    }
                }
            }

            promises.push(this._validateRowsData());

            Promise.all(promises).then(() => {
                resolve(this.isValid);
            });
        });
    }

    //CG: cand eroarea s-a putut pune pe randul ei avem deja sumar si camp decorat - un toast peste ar fi zgomot
    _reportSaveError(result) {
        if (this._showRowError(result)) {
            return;
        }

        toastr.error(result.Error);
    }

    //CG: serverul opreste lotul la primul rand picat si spune care e (RowId) si, cand stie, pe ce camp.
    //Intoarce true daca a stiut sa ruteze eroarea - altfel apelantul ramane pe toast-ul obisnuit
    _showRowError(result) {
        if (result == null || result.jsonRowError == null || result.jsonRowError == '') {
            return false;
        }

        let rowError = null;

        try {
            rowError = JSON.parse(result.jsonRowError);
        } catch (e) {
            return false;
        }

        let sublist = this._getSublistByItemId(rowError.IdUISubList);

        if (sublist == null || typeof sublist.showServerError !== 'function') {
            return false;
        }

        let placed = sublist.showServerError(rowError);

        swal.fire({
            title: this._getResource('Attention'),
            html: `<span style="font-weight: bold;">` + this._getResource('RowSaveFailed') + `</span><br><span>` + placed.message + `</span>`
        });

        if (placed.containerId != null) {
            this._revealRow(placed.containerId);
        }

        return true;
    }

    //CG: registrul e pe UniqueClientId, dar serverul stie doar Id-ul nodului de sublista
    _getSublistByItemId(idUISubList) {
        let keys = Object.keys(this.sublists);

        for (let i = 0; i < keys.length; i++) {
            let sublist = this.sublists[keys[i]];

            if (sublist != null && sublist.item != null && sublist.item.Id == idUISubList) {
                return sublist;
            }
        }

        return null;
    }

    //CG: randul poate sta intr-un tab neafisat, deci intai deschidem tab-ul si abia apoi derulam la el
    _revealRow(containerId) {
        let wrapper = $('#' + containerId + '-wrapper');

        if (wrapper.length == 0) {
            return;
        }

        let tabPage = wrapper.closest('.tab-pane');

        if (tabPage.length > 0 && !tabPage.hasClass('active')) {
            this._tabOnClick(tabPage.attr('id'));
        }

        wrapper[0].scrollIntoView({ block: 'center' });
    }

    //CG: marcajele de la salvarea anterioara ar ramane pe ecran si dupa ce randul a fost corectat
    _clearRowErrors() {
        Object.keys(this.sublists).forEach(key => {
            let sublist = this.sublists[key];

            if (sublist != null && typeof sublist.clearServerErrors === 'function') {
                sublist.clearServerErrors();
            }
        });
    }

    //CG: randurile sublistelor ROWS se valideaza cu aceleasi reguli ca formularul copil deschis in modal;
    //mesajele lor intra in acelasi sumar ca ale gazdei, prefixate cu numarul randului
    _validateRowsData() {
        let keys = Object.keys(this.sublists);
        let promises = [];

        for (let i = 0; i < keys.length; i++) {
            let sublist = this.sublists[keys[i]];

            if (sublist == null || typeof sublist.validate !== 'function') {
                continue;
            }

            promises.push(sublist.validate().then(result => {
                if (!result.isValid) {
                    this.isValid = false;
                }

                Object.keys(result.invalidFields).forEach(key => {
                    this.invalidFields[key] = result.invalidFields[key];
                });
            }));
        }

        return Promise.all(promises);
    }

    _decorateField(item, isValid, message) {
        if (isValid) {
            //CG: campul corectat intre timp nu mai are ce cauta in sumarul de la salvare
            delete this.invalidFields[item.Id];
            $("#" + item.UniqueClientId + '-validation').hide();
            $("#" + item.UniqueClientId + '-validation').removeClass('invalid-item');
            $("#" + item.UniqueClientId + '-validation').siblings('span').children('span').children('.k-select').removeClass('invalid-kendo-select');
            $("#" + item.UniqueClientId + '-validation').siblings('span').children('span').children('.k-input').removeClass('invalid-kendo-input');
            $("#" + item.UniqueClientId + '-validation').siblings('.normal-input').removeClass('invalid-normal-input');
            $("#" + item.UniqueClientId + '-validation').siblings('.dropzone').removeClass('invalid-normal-input');
        } else {
            let invalidField = {
                field: item
            };

            $("#" + item.UniqueClientId + '-validation').show();

            if (message) {
                invalidField.message = message;
                $("#" + item.UniqueClientId + '-validation')[0].innerHTML = message;
            } else {
                invalidField.message = this._getFieldValidationMessage(item);
                $("#" + item.UniqueClientId + '-validation')[0].innerHTML = invalidField.message;
            }

            this.invalidFields[item.Id] = invalidField;

            $("#" + item.UniqueClientId + '-validation').addClass('invalid-item');
            $("#" + item.UniqueClientId + '-validation').siblings('span').children('span').children('.k-select').addClass('invalid-kendo-select');
            $("#" + item.UniqueClientId + '-validation').siblings('span').children('span').children('.k-input').addClass('invalid-kendo-input');
            $("#" + item.UniqueClientId + '-validation').siblings('.normal-input').addClass('invalid-normal-input');
            $("#" + item.UniqueClientId + '-validation').siblings('.dropzone').addClass('invalid-normal-input');
        }
    }

    // clear input data

    _clearData(item, ignoreHidden) {
        if (this._isRendered(item) && (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto')) {
            let isEligible = true;

            if (ignoreHidden && item.Hidden) {
                isEligible = false;
            }

            if (isEligible && item.CtlType != null) {
                switch (item.CtlType) {
                    case 'Switch': this._threeStateSwitchSetValue("#" + item.UniqueClientId, null);
                        break;
                    case 'Checkbox': this._setCheckboxValue(item, null);
                        break;
                    case 'IntegerTextBox': $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(null);
                        break;
                    case 'DatePicker': $("#" + item.UniqueClientId).data('kendoDatePicker').value(null);
                        break;
                    case 'NumericTextBox': $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(null);
                        break;
                    case 'TextBox': $("#" + item.UniqueClientId).val(null);
                        break;
                    case 'TextArea': $("#" + item.UniqueClientId).val(null);
                        break;
                    case 'Html': this._setHtmlValue(item, null);
                        break;
                    case 'RichText': $("#" + item.UniqueClientId).data('kendoEditor').value(null);
                        break;
                    case 'DateTimePicker': $("#" + item.UniqueClientId).data('kendoDateTimePicker').value(null);
                        break;
                    case 'ComboBox': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ListView': break; //TO DO
                            case 'MultiSelect': $("#" + item.UniqueClientId).data('kendoMultiSelect').value(null);
                                break;
                            case 'TreeView': $("#" + item.UniqueClientId).data('kendoDropDownTree').value(null);
                                break;
                            case 'RadioButton': this._setRadioButtonValue(item, null);
                                break;
                            case 'MultiSelectCheckBox': this._clearMultiSelectCheckBoxValue(item);
                                break;
                            default: $("#" + item.UniqueClientId).data('kendoComboBox').value(null);
                                break;
                        }
                    }
                        break;
                    case 'GeomPicker': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ModalMap': $("#" + item.UniqueClientId).val(null);
                                break;
                            case 'MapView': this._clearGeomPickerMapViewData(item);
                                break;
                        }
                    }
                        break;
                    case 'File': break;
                    default: break;
                }
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._clearData(child, ignoreHidden);
            });
        }
    }

    _clearGeomPickerMapViewData(item) {
        let element = $("#" + item.UniqueClientId);
        element.attr('current-value', '');

        //CG: harta e inline si geometria e deja desenata, deci pe langa valoare golim si stratul temporar
        let mapControl = element.length > 0 ? element[0].mapControl : null;
        if (mapControl == null) {
            return;
        }

        mapControl.clearTemporaryFeatures(item.Name);

        let layer = mapControl.layerHandler.getLayerById(item.Name);
        if (layer.length > 0) {
            $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: null, layerSettings: layer[0].get('temporarySettings'), isNew: true }, this, this._getMapClassId(item));
        }
    }

    // store input data
    _storeData(item) {
        if (item == null) return;
        if (this._isRendered(item) && (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto')) {
            if (item.CtlType != null) {
                switch (item.CtlType) {
                    case 'Switch': this._storeSwitchData(item);
                        break;
                    case 'Checkbox': this._storeSwitchData(item);
                        break;
                    case 'IntegerTextBox': this._storeIntegerTextBoxData(item);
                        break;
                    case 'DatePicker': this._storeDatePickerData(item);
                        break;
                    case 'NumericTextBox': this._storeNumericTextBoxData(item);
                        break;
                    case 'TextBox': this._storeTextBoxData(item);
                        break;
                    case 'TextArea': this._storeTextAreaData(item);
                        break;
                    case 'Html': this._storeHtmlData(item);
                        break;
                    case 'RichText': this._storeRichTextData(item);
                        break;
                    case 'DateTimePicker': this._storeDateTimePickerData(item);
                        break;
                    case 'ComboBox': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ListView': this._storeComboBoxListViewData(item);
                                break;
                            case 'MultiSelect': this._storeMultiSelectData(item);
                                break;
                            case 'TreeView': this._storeDropDownTreeData(item);
                                break;
                            case 'RadioButton': this._storeRadioButtonData(item);
                                break;
                            case 'MultiSelectCheckBox': this._storeMultiSelectCheckBoxData(item);
                                break;
                            default: this._storeComboBoxData(item);
                                break;
                        }
                    }
                        break;
                    case 'GeomPicker': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ModalMap': this._storeGeomPickerModalMapControl(item);
                                break;
                            case 'MapView': this._storeGeomPickerMapViewControl(item);
                                break;
                        }
                    }
                        break;
                    case 'File': this._storeFileData(item);
                        break;
                    default: break;
                }
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._storeData(child);
            });
        }
    }

    _storeDatePickerData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).data('kendoDatePicker').value() != null && $("#" + item.UniqueClientId).data('kendoDatePicker').value() != '') {
            value = this._serializeDate($("#" + item.UniqueClientId).data('kendoDatePicker').value());
        }

        if (this.fromActionType == 'EDIT_MULTI') {
            if (value != null && value != '') {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        } else {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeIntegerTextBoxData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).data('kendoNumericTextBox').value() != null) {
            value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
        }

        if (this.fromActionType == 'EDIT_MULTI') {
            if (value != null && value != '') {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        } else {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeNumericTextBoxData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).data('kendoNumericTextBox').value() != null) {
            value = $("#" + item.UniqueClientId).data('kendoNumericTextBox').value();
        }

        if (this.fromActionType == 'EDIT_MULTI') {
            if (value != null && value != '') {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        } else {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeHtmlData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = this._getHtmlValue(item);

        if (this.fromActionType == 'EDIT_MULTI') {
            if (value != null && value != '') {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        } else {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeRichTextData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).data('kendoEditor').value() != null) {
            value = $("#" + item.UniqueClientId).data('kendoEditor').value();
        }

        if (this.fromActionType == 'EDIT_MULTI') {
            if (value != null && value != '') {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        } else {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeTextBoxData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).val() != null && $("#" + item.UniqueClientId).val() != '') {
            value = $("#" + item.UniqueClientId).val();
        }

        if (this.fromActionType == 'EDIT_MULTI') {
            if (value != null && value != '') {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        } else {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeGeomPickerModalMapControl(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).val() != null && $("#" + item.UniqueClientId).val() != '') {
            value = $("#" + item.UniqueClientId).val();
        }

        if (this.fromActionType == 'EDIT_MULTI') {
            if (value != null && value != '') {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        } else {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeGeomPickerMapViewControl(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = $("#" + item.UniqueClientId).attr('current-value');

        if (this.fromActionType == 'EDIT_MULTI') {
            if (value != null && value != '') {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        } else {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }


    _storeTextAreaData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).val() != null && $("#" + item.UniqueClientId).val() != '') {
            value = $("#" + item.UniqueClientId).val();
        }

        if (this.fromActionType == 'EDIT_MULTI') {
            if (value != null && value != '') {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        } else {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeDateTimePickerData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = null;

        if ($("#" + item.UniqueClientId).data('kendoDateTimePicker').value() != null && $("#" + item.UniqueClientId).data('kendoDateTimePicker').value() != '') {
            value = this._serializeDateTime($("#" + item.UniqueClientId).data('kendoDateTimePicker').value());
        }

        if (this.fromActionType == 'EDIT_MULTI') {
            if (value != null && value != '') {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        } else {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _serializeDate(date) {
        if (date != null) {
            let result = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
            return result;
        }

        return null;
    }

    _serializeDateTime(date) {
        if (date != null) {
            let result = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + "-" + date.getHours() + "-" + date.getMinutes() + "-" + date.getSeconds();
            return result;
        }

        return null;
    }

    _deserializeDate(date) {
        if (date == null || date == '') {
            return null;
        }
        else {
            var tuples = date.split("-");
            var result = new Date(tuples[0], tuples[1] - 1, tuples[2]);
            return result;
        }
    }

    _deserializeDateTime(date) {
        if (date == null || date == '') {
            return null;
        }
        else {
            var tuples = date.split("-");
            var result = new Date(tuples[0], tuples[1] - 1, tuples[2], tuples[3], tuples[4], tuples[5]);
            return result;
        }
    }

    _storeSwitchData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        if (item.EntityField && item.EntityField.DataType == 'INTEGER') {
            let value = 0;
            var switchValue = item.CtlType == 'Checkbox' ? this._getCheckboxValue(item) : this._threeStateSwitchGetValue("#" + item.UniqueClientId);
            if (switchValue === null) {
                if (!item.NotNull) {
                    value = null;
                }
            }
            else if (switchValue === true) {
                value = 1;
            }

            if (this.fromActionType == 'EDIT_MULTI') {
                if (value != null) {
                    this.saveDataItem.values['fld_' + item.Id] = value;
                }
            } else {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }

        } else if (item.EntityField && item.EntityField.DataType == 'BOOLEAN') {
            let value = false;

            var switchValue = item.CtlType == 'Checkbox' ? this._getCheckboxValue(item) : this._threeStateSwitchGetValue("#" + item.UniqueClientId);
            if (switchValue === null) {
                if (!item.NotNull) {
                    value = null;
                }
            }
            else if (switchValue === true) {
                value = true;
            }

            if (this.fromActionType == 'EDIT_MULTI') {
                if (value != null) {
                    this.saveDataItem.values['fld_' + item.Id] = value;
                }
            } else {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        } else if (item.EntityField && item.EntityField.DataType == 'BOOLINT') {
            let value = 0;

            var switchValue = item.CtlType == 'Checkbox' ? this._getCheckboxValue(item) : this._threeStateSwitchGetValue("#" + item.UniqueClientId);
            if (switchValue === null) {
                if (!item.NotNull) {
                    value = null;
                }
            }
            else if (switchValue === true) {
                value = 1;
            }

            if (this.fromActionType == 'EDIT_MULTI') {
                if (value != null) {
                    this.saveDataItem.values['fld_' + item.Id] = value;
                }
            } else {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        }
    }

    _storeMultiSelectData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = $("#" + item.UniqueClientId).data('kendoMultiSelect').value().filter(v => v !== '');

        if (value != null && value.length > 0) {
            this.saveDataItem.values['fld_' + item.Id] = value;
        } else {
            if (this.fromActionType != 'EDIT_MULTI') {
                this.saveDataItem.values['fld_' + item.Id] = null;
            }
        }
    }

    _storeDropDownTreeData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = $("#" + item.UniqueClientId).data('kendoDropDownTree').value();

        if (value != null) {
            if (this.fromActionType == 'EDIT_MULTI') {
                if (value != null && value != '') {
                    this.saveDataItem.values['fld_' + item.Id] = value;
                }
            } else {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        }
    }

    _storeComboBoxData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = $("#" + item.UniqueClientId).data('kendoComboBox').value();

        if (value != null) {
            if (this.fromActionType == 'EDIT_MULTI') {
                if (value != null && value != '') {
                    this.saveDataItem.values['fld_' + item.Id] = value;
                }
            } else {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        }
    }

    _storeRadioButtonData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = this._getRadioButtonValue(item);
        if (value != null && (this.fromActionType != 'EDIT_MULTI' || value != '')) {
            this.saveDataItem.values['fld_' + item.Id] = value;
        }
    }

    _storeMultiSelectCheckBoxData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        const value = this._getMultiSelectCheckBoxValue(item);
        if (value.length > 0 || this.fromActionType != 'EDIT_MULTI') {
            this.saveDataItem.values['fld_' + item.Id] = value.length > 0 ? value : null;
        }
    }

    _storeComboBoxListViewData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        let value = $("#" + item.UniqueClientId).attr('current-value');

        if (value != null) {
            if (this.fromActionType == 'EDIT_MULTI') {
                if (value != null && value != '') {
                    this.saveDataItem.values['fld_' + item.Id] = value;
                }
            } else {
                this.saveDataItem.values['fld_' + item.Id] = value;
            }
        }
    }

    _storeFileData(item) {
        if (item.IsReadOnly || $("#" + item.UniqueClientId).attr('persisted') == 'false' || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 0 || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            return;
        }

        if (this.uploadedFiles[item.UniqueClientId] != null) {
            if (this.uploadedFiles[item.UniqueClientId].uploadedFileAdded) {
                if (this.uploadedFiles[item.UniqueClientId].file != null) {
                    this.saveDataItem.values['fld_' + item.Id] = true;
                    this.saveDataItem.values['fld_' + item.Id + '_dzIdentifier'] = this.uploadedFiles[item.UniqueClientId].file.upload.uuid;
                    this.saveDataItem.values['fld_' + item.Id + '_xp_fileName'] = this.uploadedFiles[item.UniqueClientId].file.name;
                    this.saveDataItem.values['fld_' + item.Id + '_xp_mimeType'] = this.uploadedFiles[item.UniqueClientId].file.type;
                }
            } else {
                this.saveDataItem.values['fld_' + item.Id] = false;
            }
        } else {
            if (this.fromActionType != 'EDIT_MULTI') {
                this.saveDataItem.values['fld_' + item.Id] = null;
            }
        }
    }

    _populateData(item) {
        if (item != null) {
            this.allowEdit = item.xp_allow_edit != null && item.xp_allow_edit == '1';
            this.allowDelete = item.xp_allow_del != null && item.xp_allow_del == '1';

            this.dataItem = item;
            this._populateItem(this.metadata, false);
        }
    }

    _populateItem(item, ignoreComplex) {
        if (this._isRendered(item) && (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto')) {
            if (item.CtlType != null) {
                switch (item.CtlType) {
                    case 'Switch': this._populateSwitchControl(item);
                        break;
                    case 'Checkbox': this._populateCheckboxControl(item);
                        break;
                    case 'IntegerTextBox': this._populateIntegerTextBoxControl(item);
                        break;
                    case 'DatePicker': this._populateDatePickerControl(item);
                        break;
                    case 'NumericTextBox': this._populateNumericTextBoxControl(item);
                        break;
                    case 'TextBox': this._populateTextBoxControl(item);
                        break;
                    case 'TextArea': this._populateTextAreaControl(item);
                        break;
                    case 'Html': this._populateHtmlControl(item);
                        break;
                    case 'RichText': this._populateRichTextControl(item);
                        break;
                    case 'DateTimePicker': this._populateDateTimePickerControl(item);
                        break;
                    case 'ComboBox': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ListView': this._populateComboBoxListViewControl(item);
                                break;
                            case 'MultiSelect': this._populateMultiSelectControl(item);
                                break;
                            case 'TreeView': this._populateDropDownTreeControl(item);
                                break;
                            case 'RadioButton': this._populateRadioButtonControl(item);
                                break;
                            case 'MultiSelectCheckBox': this._populateMultiSelectCheckBoxControl(item);
                                break;
                            default: this._populateComboBoxControl(item);
                                break;
                        }
                    }
                        break;
                    case 'GeomPicker': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ModalMap': this._populateGeomPickerModalMapControl(item);
                                break;
                            case 'MapView': this._populateGeomPickerMapViewControl(item);
                                break;
                        }
                    }
                        break;
                    case 'File': this._populateFileControl(item);
                        break;
                    default: break;
                }

                if (this.isFilter && item.DefValue && item.DefValue.Value) {
                    this._setFieldValueByItem(item, item.DefValue.Value);
                }
            }
        }

        if (item.TypeName == 'UISublistDto') {
            let hasParent = this.objectId != null && this.objectId != 'null' && this.objectId != 0;

            //CG: sublistele imbricate intr-un rand nu sunt sustinute inca - cheia de filtre din
            //sessionStorage e la nivel de layout, deci toate randurile ar imparti acelasi filtru
            if (this.isRow && item.IdList != null) {
                console.warn('FormControl: sublista "' + (item.Name || item.Id) + '" a fost ignorata, sublistele imbricate intr-un rand nu sunt sustinute');
            }
            else if (item.IdList != null && (this.isPreview || hasParent)) {
                if (!item.isLoaded) {
                    this._initSublistControl(item, ignoreComplex);
                    item.isLoaded = !ignoreComplex;
                }
            }
        }

        if (item.TypeName == 'UISubformDto') {
            //CG: randurile se completeaza tocmai inainte ca parintele sa existe (se comit impreuna cu el), deci nu
            //cerem objectId; intr-un panou de filtre nu au sens, iar subformularele imbricate intr-un rand nu sunt sustinute
            if (this.isRow) {
                console.warn('FormControl: subformularul "' + (item.Name || item.Id) + '" a fost ignorat, subformularele imbricate intr-un rand nu sunt sustinute');
            }
            else if (!this.isFilter && (this.isPreview || item.IdForm != null)) {
                if (!item.isLoaded) {
                    this._initSublistControl(item, ignoreComplex);
                    item.isLoaded = !ignoreComplex;
                }
            }
        }

        if (!this.isPreview) {
            this._checkItemReadonly(item);
        }

        if (item.Items != null && item.Items.length > 0) {
            for (let i = 0; i < item.Items.length; i++) {
                let child = item.Items[i];
                this._populateItem(child, (item.TypeName == 'UITabControlDto' && i > 0 ? true : ignoreComplex));
            }
        }
    }

    _populateDatePickerControl(item) {
        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoDatePicker").readonly(true);
        }

        //SM: am anulat logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        // if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && !this.isFilter) {
        //     $("#" + item.UniqueClientId).data("kendoDatePicker").readonly(true);
        // }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoDatePicker").bind('change', (e) => {
                if (e.sender.value() == null) {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }
    }

    _populateIntegerTextBoxControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        }

        //SM: am anulat logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        // if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && !this.isFilter) {
        //     $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        // }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").bind('change', (e) => {
                if (e.sender.value() == null) {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }

        $("#" + item.UniqueClientId).data("kendoNumericTextBox").bind('change', (e) => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = this.getCascadedDependants(item, dependants);

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });
    }

    _isEligibleForValidation(item) {
        let result = item.NotNull || (item.EntityField != null && item.EntityField.NotNull && !this.isFilter);

        if (!((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden)) {
            result = false;
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            result = false;
        }

        return result;
    }

    _populateNumericTextBoxControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).data('kendoNumericTextBox').value(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        }

        //SM: am anulat logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        // if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && !this.isFilter) {
        //     $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        // }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").bind('change', (e) => {
                if (e.sender.value() == null) {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }

        $("#" + item.UniqueClientId).data("kendoNumericTextBox").bind('change', (e) => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = this.getCascadedDependants(item, dependants);

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });
    }

    _populateHtmlControl(item) {
        let value = this.dataItem['fld_' + item.Id];
        if (value == null
            && item.DefValue != null
            && item.DefValue.ValueType == 'VALUE'
            && this._isInitialValueDefValueApplicable(item)) {
            value = item.DefValue.Value;
        }

        if (value != null) {
            this._setHtmlValue(item, value);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        //SM: am anulat logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        // let readonly = item.IsReadOnly
        //     || ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter)
        //     || (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && !this.isFilter);
        let readonly = item.IsReadOnly
            || ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0));
        this._setHtmlReadonly(item, readonly);
    }

    _populateRichTextControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).data('kendoEditor').value(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            //$("#" + item.UniqueClientId).data("kendoEditor").readonly(true);
            const editor = $("#" + item.UniqueClientId).data("kendoEditor");
            $(editor.body).removeAttr("contenteditable");
            editor.wrapper.find(".k-toolbar").hide();
            $('#' + item.UniqueClientId).closest('table').addClass('disabled-control');
        }

        //SM: am anulat logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        // if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && !this.isFilter) {
        //     //$("#" + item.UniqueClientId).data("kendoEditor").readonly(true);
        //     const editor = $("#" + item.UniqueClientId).data("kendoEditor");
        //     $(editor.body).removeAttr("contenteditable");
        //     editor.wrapper.find(".k-toolbar").hide();
        //     $('#' + item.UniqueClientId).closest('table').addClass('disabled-control');
        // }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoEditor").bind('change', (e) => {
                if (e.sender.value() == null) {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }
    }

    _populateTextBoxControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).val(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }

        //SM: am anulat logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        // if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && !this.isFilter) {
        //     $("#" + item.UniqueClientId).attr('readonly', true);
        // }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).on('keyup', (e) => {
                if ($("#" + item.UniqueClientId).val() == '') {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }

        $("#" + item.UniqueClientId).on('focusout', () => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = this.getCascadedDependants(item, dependants);

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });
    }

    _populateGeomPickerModalMapControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).val(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }

        //SM: am anulat logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        // if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && !this.isFilter) {
        //     $("#" + item.UniqueClientId).attr('readonly', true);
        // }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).on('keyup', (e) => {
                if ($("#" + item.UniqueClientId).val() == '') {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }

        $("#" + item.UniqueClientId).on('focusout', () => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = this.getCascadedDependants(item, dependants);

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });
    }

    _populateGeomPickerMapViewControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).attr('current-value', this.dataItem['fld_' + item.Id]);
            this._populateMap($("#" + item.UniqueClientId)[0].mapControl, item);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }
    }

    _populateMap(mapControl, item) {
        if (mapControl.isLoaded) {
            let feature = {};
            feature['id'] = this.objectId;

            let value = '';

            if (item.CtlProps.CtlSubType == 'ModalMap') {
                value = $("#" + item.UniqueClientId).val();
            } else {
                value = $("#" + item.UniqueClientId).attr('current-value');
            }

            feature[item.EntityField.FieldName] = value;
            mapControl.addTemporaryFeatures(item.Name, [feature], formats.WKT, true, true);

            //if (value == null || value.trim() == '') {
            $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: null, layerSettings: mapControl.layerHandler.getLayerById(item.Name)[0].get('temporarySettings'), isNew: true }, this, this._getMapClassId(item));
            //}

            if (this.formId != null && window['onFormMapStarted' + '_' + this.formId] != null && !this.isPreview) {
                window['onFormMapStarted' + '_' + this.formId](this, mapControl, item);
            }
            else if (window['onFormMapStarted' + this.pageGuid] != null && !this.isPreview) {
                window['onFormMapStarted' + this.pageGuid](mapControl, item);
            }
            if (this.onFormMapStarted != null) {
                this.onFormMapStarted(this, mapControl, item);
            }
        } else {
            setTimeout(() => {
                this._populateMap(mapControl, item);
            }, 100);
        }
    }

    _populateTextAreaControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).val(this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }

        //SM: am anulat logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        // if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && !this.isFilter) {
        //     $("#" + item.UniqueClientId).attr('readonly', true);
        // }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).on('keyup', (e) => {
                if ($("#" + item.UniqueClientId).val() == '') {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }

        $("#" + item.UniqueClientId).on('focusout', () => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = this.getCascadedDependants(item, dependants);

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });
    }

    _populateDateTimePickerControl(item) {
        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoDateTimePicker").readonly(true);
        }

        //SM: am anulat logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        // if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && !this.isFilter) {
        //     $("#" + item.UniqueClientId).data("kendoDateTimePicker").readonly(true);
        // }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoDateTimePicker").bind('change', (e) => {
                if (e.sender.value() == null) {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }
    }

    _populateSwitchControl(item) {
        var switchValue = this._parseBooleanCommandResult(this.dataItem['fld_' + item.Id]);

        this._threeStateSwitchSetValue("#" + item.UniqueClientId, switchValue);

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $("#" + item.UniqueClientId).data('kendoSwitch').readonly(true);
        }

        //SM: am anulat logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        // if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && !this.isFilter) {
        //     $("#" + item.UniqueClientId).data('kendoSwitch').readonly(true);
        // }

        let dependants = this._getDependants(item.Guid);

        if (dependants != null && dependants.length > 0) {
            this._handleItemsState(dependants, true);
        }
    }

    _populateMultiSelectControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            /*if (this.allowEdit && !item.IsReadOnly) {
                $("#" + item.UniqueClientId).data("kendoMultiSelect").readonly(false);
            }*/

            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants, true);
            }
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0 || item.IsReadOnly) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoMultiSelect").readonly(true);
        }

        //SM: am anulatt logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        //if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandLoad != null && item.IdXpCommandSave == null && !this.isFilter) {
        //    $("#" + item.UniqueClientId).data("kendoMultiSelect").readonly(true);
        //}

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoMultiSelect").bind('change', (e) => {
                let val = e.sender.value();
                if (val == null || val.length == 0) {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }
    }

    _populateDropDownTreeControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            if (this.allowEdit && !item.IsReadOnly) {
                $("#" + item.UniqueClientId).data("kendoDropDownTree").readonly(false);
                $('#' + item.UniqueClientId).parent().removeClass('isReadonly');
            }

            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants, true);
            }
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0 || item.IsReadOnly) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoDropDownTree").readonly(true);
            $('#' + item.UniqueClientId).parent().addClass('isReadonly');
        }

        //SM: am anulat logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        // if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && !this.isFilter) {
        //     $("#" + item.UniqueClientId).data("kendoDropDownTree").readonly(true);
        //     $('#' + item.UniqueClientId).parent().addClass('isReadonly');
        // }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoDropDownTree").bind('change', (e) => {
                if (e.sender.value() == null || e.sender.value().trim() == '') {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }
    }

    _populateComboBoxControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            if (this.allowEdit && !item.IsReadOnly) {
                $("#" + item.UniqueClientId).data("kendoComboBox").readonly(false);
            }

            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants, true);
            }
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0 || item.IsReadOnly) && !this.isFilter) {
            $("#" + item.UniqueClientId).data("kendoComboBox").readonly(true);
        }

        //SM: am anulatt logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        // if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && item.IdXpCommandLoad != null && !this.isFilter) {
        //     $("#" + item.UniqueClientId).data("kendoComboBox").readonly(true);
        // }

        if (this._isEligibleForValidation(item)) {
            $("#" + item.UniqueClientId).data("kendoComboBox").bind('change', (e) => {
                if (e.sender.value() == null || e.sender.value().trim() == '') {
                    this._decorateField(item, false);
                } else {
                    this._decorateField(item, true);
                }
            });
        }
    }

    _populateRadioButtonControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            this._setRadioButtonValue(item, this.dataItem['fld_' + item.Id]);
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        //SM: am anulat logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        //let readonly = ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0 || item.IsReadOnly) && !this.isFilter)
        //    || (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && item.IdXpCommandLoad != null && !this.isFilter);
        let readonly = ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0 || item.IsReadOnly));
        this._setRadioButtonReadonly(item, readonly);
    }

    _populateMultiSelectCheckBoxControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            this._setMultiSelectCheckBoxValue(item, this.dataItem['fld_' + item.Id]);
        }
        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }
        this._setMultiSelectCheckBoxReadonly(item, !this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0 || item.IsReadOnly);
    }

    _populateComboBoxListViewControl(item) {
        if (this.dataItem['fld_' + item.Id] != null) {
            $("#" + item.UniqueClientId).attr('current-value', this.dataItem['fld_' + item.Id]);
            let listViewDataSourceUrl = rootUrl + 'Entity/GetFieldSource?idField=' + item.Id + '&fkVal=' + this.dataItem['fld_' + item.Id];
            if (this.idExtConn != null) {
                listViewDataSourceUrl += "&idExtConn=" + this.idExtConn;
            }

            //CG: si asta e pe drumul de incarcare, deci trece prin acelasi cache - un ListView cu aceeasi
            //valoare pe mai multe randuri cerea de fiecare data aceeasi sursa
            this._fetchFieldSource(listViewDataSourceUrl, null)
                .then((result) => {
                    if (result != null && result.length > 0) {
                        let currentValue = result.filter((row) => {
                            return row.Id == this.dataItem['fld_' + item.Id];
                        });

                        if (currentValue != null & currentValue.length > 0) {
                            $("#" + item.UniqueClientId).attr('current-value', currentValue[0].Id);
                            $('#' + item.UniqueClientId + '-img img').attr('src', rootUrl + 'Entity/GetFileContent?idEntityField=' + currentValue[0].Attr[1] + '&pkVal=' + currentValue[0].Id);
                            $('#' + item.UniqueClientId + '-img .list-view-selection-title')[0].innerHTML = currentValue[0].Name;
                            $('#' + item.UniqueClientId + '-img .list-view-selection-description')[0].innerHTML = currentValue[0].Attr[0];
                            $('#' + item.UniqueClientId + '-img').addClass('d-flex');
                            $('#' + item.UniqueClientId + '-placeholder').removeClass('d-flex');
                            $('#' + item.UniqueClientId + '-placeholder').hide();
                        }
                    }
                })
                .catch((e) => {
                    toastr.error(e.responseText, this._getResource('GetFieldSourceError'));
                });

            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants, true);
            }
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $('#' + item.UniqueClientId).addClass('disabled-control');
        }

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).addClass('disabled-control');
        }

        //SM: am anulat logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        // if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && !this.isFilter) {
        //     $("#" + item.UniqueClientId).addClass('disabled-control');
        // }

        $("#" + item.UniqueClientId).on('click', (evt) => {
            this._initComboBoxListViewControl(item);
        });
    }

    _initComboBoxListViewControl(item) {
        this.initModal(item.Label, '70%', null, false, null, true);

        //CG: id-ul cautarii se leaga de instanta; hardcodat producea id-uri duplicate cand doua formulare deschid selectorul
        let searchId = this.comboBoxSelectView + '-search';

        $('#' + this.uniqueModalInnerId).append('<div class="col-8 d-flex" style="margin: 0 auto;"><input id="' + searchId + '" placeholder="' + this._getResource('Search') + '" type="text" class="form-control mb-3" style="border-top-right-radius: 0 !important; border-bottom-right-radius: 0 !important;"/><span class="fal fa-search btn btn-primary" style="height: 2.3rem; line-height: 1.5rem; font-size: 1.1rem; border-top-left-radius: 0 !important; border-bottom-left-radius: 0 !important;"></span></div><div id="' + this.comboBoxSelectView + '" style="display: grid; grid-template-columns: auto auto; border: none; min-height: calc(100% - 3.5rem);"></div>');

        $("#" + this.comboBoxSelectView).kendoListView({
            dataSource: {
                serverFiltering: false,
                transport: {
                    read: {
                        dataType: 'json',
                        url: () => {
                            return rootURL + 'Entity/GetFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn;
                        }
                    }
                }
            },
            height: 350,
            layout: "grid",
            grid: {
                cols: 2,
            },
            scrollable: "endless",
            template: (item) => {
                return `<div class="list-view-item" data-id="` + item.Id + `" data-entity-field="` + item.Attr[1] + `" data-title="` + item.Name + `" data-description="` + item.Attr[0] + `" style="height: 400px; padding: 1.5rem; cursor: pointer;">
                    <div class="list-view-item-label" style="height: 2rem; font-size: 1rem; font-family: roboto; font-weight: 500; color: #666666;display: flex; align-content: center; flex-wrap: wrap; justify-content: center;">` + item.Name + `</div>
                    <div class="list-view-item-label" style="height: 2rem; font-family: roboto; color: #666666;display: flex; align-content: center; flex-wrap: wrap; justify-content: center;">` + item.Attr[0] + `</div>
                    <div style="height: calc(100% - 4rem); display: flex; justify-content: center;">
                        <img src="` + (rootUrl + 'Entity/GetFileContent?idEntityField=' + item.Attr[1] + '&pkVal=' + item.Id) + `"></img>
                    </div>
                </div>`;
            },
            dataBound: () => {
                //CG: doar item-ii acestui selector, si off inainte de on pentru ca dataBound se reia la scroll-ul endless
                $('#' + this.comboBoxSelectView + ' .list-view-item').off('click').on('click', (evt) => {
                    let selectedId = evt.currentTarget.getAttribute('data-id');
                    let selectedIdEntityField = evt.currentTarget.getAttribute('data-entity-field');
                    let selectedTitle = evt.currentTarget.getAttribute('data-title');
                    let selectedDescription = evt.currentTarget.getAttribute('data-description');
                    this.closeModal(true);
                    $("#" + item.UniqueClientId).attr('current-value', selectedId);
                    $('#' + item.UniqueClientId + '-img img').attr('src', rootUrl + 'Entity/GetFileContent?idEntityField=' + selectedIdEntityField + '&pkVal=' + selectedId);
                    $('#' + item.UniqueClientId + '-img').addClass('d-flex');
                    $('#' + item.UniqueClientId + '-placeholder').removeClass('d-flex');
                    $('#' + item.UniqueClientId + '-placeholder').hide();
                    $('#' + item.UniqueClientId + '-img .list-view-selection-title')[0].innerHTML = selectedTitle;
                    $('#' + item.UniqueClientId + '-img .list-view-selection-description')[0].innerHTML = selectedDescription;

                    let dependants = this._getDependants(item.Guid);

                    if (dependants != null && dependants.length > 0) {
                        this._handleItemsState(dependants);

                        let cascadedDependants = this.getCascadedDependants(item, dependants);

                        this._handleCascadedItems(cascadedDependants);
                    }

                    this._checkItemValidity(item);
                });
            }
        });

        $('#' + searchId).on('keyup', () => {
            let criteria = $('#' + searchId).val();

            let choices = $('#' + this.comboBoxSelectView + ' .list-view-item');
            for (let i = 0; i < choices.length; i++) {
                let choice = $(choices[i]);
                let title = choice.attr('data-title');
                let description = choice.attr('data-description');


                if (title.toLowerCase().indexOf(criteria.toLowerCase()) >= 0 || description.toLowerCase().indexOf(criteria.toLowerCase()) >= 0) {
                    choice.show();
                } else {
                    choice.hide();
                }
            }
        });
    }

    _populateFileControl(item) {
        if (this.dataItem['fld_' + item.Id] != null && this.dataItem['fld_' + item.Id] != 'False') {
            if (this.uploadedFiles[item.UniqueClientId] == null) {
                this.uploadedFiles[item.UniqueClientId] = {};
            }

            this.uploadedFiles[item.UniqueClientId].uploadedFileAdded = true;
            let thumb = { name: this.dataItem['fld_' + item.Id + '_xp_file_name'] != null ? this.dataItem['fld_' + item.Id + '_xp_file_name'] : 'N/A', size: 0, dataURL: rootUrl + 'Entity/GetFileContent?idEntityField=' + item.EntityField.Id + '&pkVal=' + this.objectId + '&_r=' + Math.random(5) };

            $("#" + item.UniqueClientId)[0].dropzone.files.push(thumb);

            $("#" + item.UniqueClientId)[0].dropzone.emit('addedfile', thumb);

            $("#" + item.UniqueClientId)[0].dropzone.createThumbnailFromUrl(thumb,
                $("#" + item.UniqueClientId)[0].dropzone.options.thumbnailWidth, $("#" + item.UniqueClientId)[0].dropzone.options.thumbnailHeight,
                $("#" + item.UniqueClientId)[0].dropzone.options.thumbnailMethod, true, function (thumbnail) {
                    $("#" + item.UniqueClientId)[0].dropzone.emit('thumbnail', thumb, thumb.dataURL);
                });

            $("#" + item.UniqueClientId)[0].dropzone.emit('complete', thumb);

            $("#" + item.UniqueClientId + ' .dz-remove')[0].innerHTML = '';
            $("#" + item.UniqueClientId + ' .dz-remove').addClass('btn btn-danger fal fa-trash-alt d-inline ml-2');
            $("#" + item.UniqueClientId + ' .dz-remove').before('<a class="btn btn-primary fal fa-download d-inline" style="padding-left: 0.5rem; padding-right: 0.5rem; font-size: 14px; text-align: center; display: block; cursor: pointer; border: none;" href="' + rootUrl + 'Entity/GetFileContent?idEntityField=' + item.EntityField.Id + '&pkVal=' + this.objectId + '" target="_blank"></a>');
        }

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if (!this.allowEdit || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) {
            $('#' + item.UniqueClientId).addClass('disabled-control');
            $("#" + item.UniqueClientId + ' .dz-remove').remove();
        }

        //SM: am anulat logica potrivit careia un control fara legatura cu un camp si fara comanda de salvare trebuie sa fie ReadOnly
        // if (item.TypeName == 'UICustomFieldControlDto' && item.IdXpCommandSave == null && !this.isFilter) {
        //     $('#' + item.UniqueClientId).addClass('disabled-control');
        //     $("#" + item.UniqueClientId + ' .dz-remove').remove();
        // }
    }

    //set a file control to accept multifiles on add: the inserted records are cloned and each uploaded file is used for a record
    allowMultiFileOnAdd(maxFiles = 20) {
        if (this.objectId == null || this.objectId == '') {
            if (this.uploadedFiles != null && Object.keys(this.uploadedFiles).length > 0) {
                let fileKeys = Object.keys(this.uploadedFiles);
                fileKeys.forEach(fileKey => {
                    //aici trebuie sa mai testam daca se accepta multiple fisiere la salvare
                    const dz = $('#' + fileKey)[0].dropzone;
                    dz.options.maxFiles = maxFiles;
                    $(dz.hiddenFileInput).prop('multiple', true);
                });
            }
        }
    }

    //CG: sablonul coboara doar prin containere (layout, tab, grup, paragraf), deci un nod al carui parinte
    //nu e container n-are element in pagina; il semnalam o singura data si il sarim, ca sa nu cada tot formularul
    _isRendered(item) {
        if (item.UniqueClientId != null && document.getElementById(item.UniqueClientId) != null) {
            return true;
        }

        if (this._unrenderedItems == null) {
            this._unrenderedItems = {};
        }

        //CG: cheia nu poate fi UniqueClientId - cand sablonul nu a rulat deloc e null pe tot arborele
        //si semnalarea s-ar opri la primul nod
        let key = item.UniqueClientId != null ? item.UniqueClientId : item.TypeName + '-' + item.Id;

        if (!this._unrenderedItems[key]) {
            this._unrenderedItems[key] = true;
            console.warn('FormControl: nod nerandat, se ignora', { TypeName: item.TypeName, CtlType: item.CtlType, Id: item.Id, Name: item.Name, Label: item.Label });
        }

        return false;
    }

    // init and add events to the created controls
    _initControls(item) {
        if (item.IdXpCommandLoad != null) {
            item.loadCommandHandled = false;
        }

        let isRendered = this._isRendered(item);

        if (isRendered && (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto')) {
            if (item.CtlType != null) {
                switch (item.CtlType) {
                    case 'Switch': this._initSwitchControl(item);
                        break;
                    case 'Checkbox': this._initCheckboxControl(item);
                        break;
                    case 'IntegerTextBox': this._initIntegerTextBoxControl(item);
                        break;
                    case 'DatePicker': this._initDatePickerControl(item);
                        break;
                    case 'NumericTextBox': this._initNumericTextBoxControl(item);
                        break;
                    case 'TextBox': this._initTextBoxControl(item);
                        break;
                    case 'TextArea': this._initTextAreaControl(item);
                        break;
                    case 'Html': this._initHtmlControl(item);
                        break;
                    case 'RichText': this._initRichTextControl(item);
                        break;
                    case 'DateTimePicker': this._initDateTimePickerControl(item);
                        break;
                    case 'ComboBox': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ListView': break;
                            case 'MultiSelect': this._initMultiSelectControl(item);
                                break;
                            case 'TreeView': this._initDropDownTreeControl(item);
                                break;
                            case 'RadioButton': this._initRadioButtonControl(item);
                                break;
                            case 'MultiSelectCheckBox': this._initMultiSelectCheckBoxControl(item);
                                break;
                            default: this._initComboBoxControl(item);
                                break;
                        }
                    }
                        break;
                    case 'GeomPicker': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ModalMap': this._initGeomPickerModalMapControl(item);
                                break;
                            case 'MapView': this._initGeomPickerMapViewControl(item);
                                break;
                        }
                    }
                        break;
                    case 'File': this._initFileControl(item);
                        break;
                    default: break;
                }
                applyFieldComponentClasses(item);
                applyFieldComponentStyles(item);
                applyFieldComponentHtmlAttributes(item);
                this._applyFieldPlaceholder(item);
            }
        }

        if (isRendered && item.TypeName == 'UIMapViewDto') {
            if (item.IdMap != null) {
                this._initMapViewControl(item);
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._initControls(child);
            });
        }

        if (isRendered && item.IdXpCommandVisible != null && !this.isPreview) {
            this._hideItem(item);
        }
    }

    _hideItem(item) {
        if (item.TypeName == 'UITabPageDto') {
            $('#' + item.UniqueClientId + '-anchor').parent().hide();
            $('#' + item.UniqueClientId + '-anchor').hide();

            if ($('#' + item.UniqueClientId + '-anchor')[0].classList.contains('active')) {
                let siblings = $('#' + item.UniqueClientId + '-anchor').parent().siblings();

                for (let i = 0; i < siblings.length; i++) {
                    if (siblings[i].style.display != 'none') {
                        siblings[i].click();
                        i = siblings.length;
                    }
                }
            }
        } else if (item.TypeName == 'UIGroupDto' || item.TypeName == 'UITabControlDto') {
            $('#' + item.UniqueClientId).hide();
        } else {
            $("#" + item.UniqueClientId + "-wrapper").hide();
        }

        this._setVisibleState(item, false);
    }

    _setPersistedState(item, persisted) {
        $("#" + item.UniqueClientId).attr('persisted', persisted);
        if (item.Items != null) {
            item.Items.forEach(child => { this._setPersistedState(child, persisted) });
        }
    }

    _setVisibleState(item, visible) {
        $("#" + item.UniqueClientId).attr('item-visible', visible);
        if (item.Items != null) {
            item.Items.forEach(child => { this._setVisibleState(child, visible) });
        }

        if (!visible) {
            this._decorateField(item, true);
        }
    }

    _getVisibleState(item) {
        let state = $("#" + item.UniqueClientId).attr('item-visible');

        if (state == null || state == "true") {
            return true;
        } else {
            return false;
        }
    }

    _setReadonlyState(item, readonly) {
        $("#" + item.UniqueClientId).attr('item-readonly', readonly);
        if (item.Items != null) {
            item.Items.forEach(child => { this._setReadonlyState(child, readonly) });
        }

        if (readonly) {
            this._decorateField(item, true);
        }
    }

    _getReadonlyState(item) {
        let state = $("#" + item.UniqueClientId).attr('item-readonly');

        if (state == null || state == "false") {
            return false;
        } else {
            return true;
        }
    }

    _setItemReadonly(item) {
        if (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto') {
            if (item.CtlType == 'TextBox' || item.CtlType == 'TextArea') {
                $('#' + item.UniqueClientId).attr('readonly', true);
            } else if (item.CtlType == 'ComboBox') {
                if (item.CtlProps.CtlSubType == 'ListView') {
                    $('#' + item.UniqueClientId).addClass('disabled-control');
                } else if (item.CtlProps.CtlSubType == 'ComboBox') {
                    $('#' + item.UniqueClientId).data('kendoComboBox').readonly(true);
                } else if (item.CtlProps.CtlSubType == 'TreeView') {
                    $('#' + item.UniqueClientId).data('kendoDropDownTree').readonly(true);
                    $('#' + item.UniqueClientId).parent().addClass('isReadonly');
                } else if (item.CtlProps.CtlSubType == 'MultiSelect') {
                    $('#' + item.UniqueClientId).data('kendoMultiSelect').readonly(true);
                } else if (item.CtlProps.CtlSubType == 'RadioButton') {
                    this._setRadioButtonReadonly(item, true);
                } else if (item.CtlProps.CtlSubType == 'MultiSelectCheckBox') {
                    this._setMultiSelectCheckBoxReadonly(item, true);
                }
            } else if (item.CtlType == 'IntegerTextBox' || item.CtlType == 'NumericTextBox') {
                $('#' + item.UniqueClientId).data('kendoNumericTextBox').readonly(true);
            } else if (item.CtlType == 'DatePicker') {
                $('#' + item.UniqueClientId).data('kendoDatePicker').readonly(true);
            } else if (item.CtlType == 'DateTimePicker') {
                $('#' + item.UniqueClientId).data('kendoDateTimePicker').readonly(true);
            } else if (item.CtlType == 'Html') {
                this._setHtmlReadonly(item, true);
            } else if (item.CtlType == 'RichText') {
                const editor = $("#" + item.UniqueClientId).data("kendoEditor");
                $(editor.body).removeAttr("contenteditable");
                editor.wrapper.find(".k-toolbar").hide();
                $('#' + item.UniqueClientId).closest('table').addClass('disabled-control');
            } else if (item.CtlType == 'Switch') {
                $('#' + item.UniqueClientId).data('kendoSwitch').readonly(true);
            } else if (item.CtlType == 'Checkbox') {
                $('#' + item.UniqueClientId).prop('disabled', true);
            } else if (item.CtlType == 'File') {
                $('#' + item.UniqueClientId).addClass('disabled-control');
            } else if (item.CtlType == 'GeomPicker') {
                if (item.CtlProps.CtlSubType == 'ModalMap') {
                    $("#" + item.UniqueClientId).attr('readonly', true);
                } else if (item.CtlProps.CtlSubType == 'MapView') {
                    //TODO
                }
            }
        } else {
            $('#' + item.UniqueClientId).addClass('disabled-control');
        }

        this._setReadonlyState(item, true);
    }

    _setItemReadwrite(item) {
        if (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto') {
            if (item.CtlType == 'TextBox' || item.CtlType == 'TextArea') {
                $('#' + item.UniqueClientId).attr('readonly', false);
            } else if (item.CtlType == 'ComboBox') {
                if (item.CtlProps.CtlSubType == 'ListView') {
                    $('#' + item.UniqueClientId).removeClass('disabled-control');
                } else if (item.CtlProps.CtlSubType == 'ComboBox') {
                    $('#' + item.UniqueClientId).data('kendoComboBox').readonly(false);
                } else if (item.CtlProps.CtlSubType == 'TreeView') {
                    $('#' + item.UniqueClientId).data('kendoDropDownTree').readonly(false);
                    $('#' + item.UniqueClientId).parent().removeClass('isReadonly');
                } else if (item.CtlProps.CtlSubType == 'MultiSelect') {
                    $('#' + item.UniqueClientId).data('kendoMultiSelect').readonly(false);
                } else if (item.CtlProps.CtlSubType == 'RadioButton') {
                    this._setRadioButtonReadonly(item, false);
                } else if (item.CtlProps.CtlSubType == 'MultiSelectCheckBox') {
                    this._setMultiSelectCheckBoxReadonly(item, false);
                }
            } else if (item.CtlType == 'IntegerTextBox' || item.CtlType == 'NumericTextBox') {
                $('#' + item.UniqueClientId).data('kendoNumericTextBox').readonly(false);
            } else if (item.CtlType == 'DatePicker') {
                $('#' + item.UniqueClientId).data('kendoDatePicker').readonly(false);
            } else if (item.CtlType == 'DateTimePicker') {
                $('#' + item.UniqueClientId).data('kendoDateTimePicker').readonly(false);
            } else if (item.CtlType == 'Html') {
                this._setHtmlReadonly(item, false);
            } else if (item.CtlType == 'RichText') {
                //$('#' + item.UniqueClientId).closest('table').removeClass('disabled-control');
                const editor = $("#" + item.UniqueClientId).data("kendoEditor");
                $(editor.body).attr("contenteditable", "true");
                editor.wrapper.find(".k-toolbar").show();
                $('#' + item.UniqueClientId).closest('table').removeClass('disabled-control');
            } else if (item.CtlType == 'Switch') {
                $('#' + item.UniqueClientId).data('kendoSwitch').readonly(false);
            } else if (item.CtlType == 'Checkbox') {
                $('#' + item.UniqueClientId).prop('disabled', false);
            } else if (item.CtlType == 'File') {
                $('#' + item.UniqueClientId).removeClass('disabled-control');
            } else if (item.CtlType == 'GeomPicker') {
                if (item.CtlProps.CtlSubType == 'ModalMap') {
                    $("#" + item.UniqueClientId).attr('readonly', false);
                } else if (item.CtlProps.CtlSubType == 'MapView') {
                    //TODO
                }
            }
        } else {
            $('#' + item.UniqueClientId).removeClass('disabled-control');
        }

        this._setReadonlyState(item, false);
    }

    _showItem(item) {
        this._setPersistedState(item, true);

        if (item.TypeName == 'UITabPageDto') {
            $('#' + item.UniqueClientId + '-anchor').parent().show();
            $('#' + item.UniqueClientId + '-anchor').show();
        } else if (item.TypeName == 'UIGroupDto' || item.TypeName == 'UITabControlDto') {
            $('#' + item.UniqueClientId).show();
        } else {
            $("#" + item.UniqueClientId + "-wrapper").show();
        }

        if (item.CtlType == 'Html' && this.htmlEditors[item.UniqueClientId] != null) {
            this.htmlEditors[item.UniqueClientId].resize();
        }

        this._setVisibleState(item, true);
    }

    _bindChangeEvents(item) {
        if (this._isRendered(item) && (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto')) {
            if (item.CtlType != null) {
                switch (item.CtlType) {
                    case 'ComboBox': {
                        switch (this._getFieldControlSubType(item)) {
                            case 'ListView': break;//TO DO
                            case 'MultiSelect': this._bindMultiSelectChange(item);
                                break;
                            case 'TreeView': this._bindDropDownTreeChange(item);
                                break;
                            case 'RadioButton': this._bindRadioButtonChange(item);
                                break;
                            case 'MultiSelectCheckBox': this._bindMultiSelectCheckBoxChange(item);
                                break;
                            default: this._bindComboBoxChange(item);
                                break;
                        }
                    }
                        break;
                    default: break;
                }
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._bindChangeEvents(child);
            });
        }
    }

    _bindMultiSelectChange(item) {
        $("#" + item.UniqueClientId).data('kendoMultiSelect').bind("change", (e) => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = this.getCascadedDependants(item, dependants);

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });

        if (this._isAllowAdd(item)) {
            this._bindMultiSelectAllowAdd(item);
        }
    }

    //MultiSelect nu pastreaza textul tastat in change; interceptam Enter in faza de capture
    //(inaintea handler-ului intern Kendo) pe input-ul nativ, altfel Kendo consuma tasta prima.
    _bindMultiSelectAllowAdd(item) {
        let multiSelect = $("#" + item.UniqueClientId).data('kendoMultiSelect');
        let inputEl = multiSelect.input[0];

        inputEl.addEventListener('keydown', (ev) => {
            if (ev.keyCode != 13) {//Enter
                return;
            }

            //daca popup-ul are un element evidentiat, lasam Kendo sa-l selecteze normal
            if (multiSelect.popup != null && multiSelect.popup.visible()
                && multiSelect.listView != null && multiSelect.listView.focus() != null) {
                return;
            }

            let typed = (inputEl.value || '').trim();
            if (typed == '' || this._comboBoxHasMatch(multiSelect, typed)) {
                return;
            }

            ev.preventDefault();
            ev.stopImmediatePropagation();

            this._confirmAndAddEntityFieldValue(item, typed).then(added => {
                if (added == null) {
                    return;
                }

                multiSelect.dataSource.add(added);
                let values = (multiSelect.value() || []).slice();
                values.push(added.Id);
                multiSelect.value(values);
                multiSelect.trigger('change');
                multiSelect.input.val('');
                multiSelect.close();
            });
        }, true);//capture
    }

    _bindDropDownTreeChange(item) {
        $("#" + item.UniqueClientId).data('kendoDropDownTree').bind("change", (e) => {
            if (e.sender.value() == null || e.sender.value() == '') {
                e.sender.text('');
                e.sender._oldText = '';
                e.sender._prev = '';
            }

            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = this.getCascadedDependants(item, dependants);

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });
    }

    _bindRadioButtonChange(item) {
        $('#' + item.UniqueClientId).off('change.xpRadioButton').on('change.xpRadioButton', 'input[type="radio"]', (e) => {
            this._setRadioButtonValue(item, e.target.value);

            let dependants = this._getDependants(item.Guid);
            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);
                this._handleCascadedItems(this.getCascadedDependants(item, dependants));
            }

            this._checkItemValidity(item);
        });
    }

    _bindMultiSelectCheckBoxChange(item) {
        $('#' + item.UniqueClientId).off('change.xpMultiSelectCheckBox').on('change.xpMultiSelectCheckBox', 'input[type="checkbox"]', () => {
            let dependants = this._getDependants(item.Guid);
            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);
                this._handleCascadedItems(this.getCascadedDependants(item, dependants));
            }
            if (this._isEligibleForValidation(item)) {
                this._decorateField(item, this._getMultiSelectCheckBoxValue(item).length > 0);
            }
            this._checkItemValidity(item);
        });
    }

    _bindComboBoxChange(item) {
        $("#" + item.UniqueClientId).data('kendoComboBox').bind("change", (e) => {
            if (e.sender.value() == null || e.sender.value() == '') {
                e.sender.text('');
                e.sender._oldText = '';
                e.sender._prev = '';
            }

            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = this.getCascadedDependants(item, dependants);

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        });

        if (this._isAllowAdd(item)) {
            this._bindComboBoxAllowAdd(item);
        }
    }

    //acelasi mecanism ca la MultiSelect: interceptam Enter in faza de capture pe input-ul nativ
    //(inaintea handler-ului intern Kendo) pentru a propune adaugarea unei valori noi.
    _bindComboBoxAllowAdd(item) {
        let comboBox = $("#" + item.UniqueClientId).data('kendoComboBox');
        let inputEl = comboBox.input[0];

        inputEl.addEventListener('keydown', (ev) => {
            if (ev.keyCode != 13) {//Enter
                return;
            }

            //nu ne bazam pe evidentierea din popup: Kendo auto-evidentiaza mereu primul element chiar
            //daca nu se potriveste. Decidem strict pe text: daca exista un item cu exact acest nume il
            //lasam pe Kendo sa-l selecteze; altfel textul e nou -> propunem adaugarea.
            let typed = (inputEl.value || '').trim();
            if (typed == '' || this._comboBoxHasMatch(comboBox, typed)) {
                return;
            }

            ev.preventDefault();
            ev.stopImmediatePropagation();

            this._confirmAndAddEntityFieldValue(item, typed).then(added => {
                if (added == null) {
                    comboBox.value(null);
                    comboBox.text('');
                    return;
                }

                comboBox.dataSource.add(added);
                comboBox.value(added.Id);
                comboBox.trigger('change');
                comboBox.close();
            });
        }, true);//capture
    }

    _isAllowAdd(item) {
        //AllowAdd doar cand putem rezolva entitatea FK; conexiunile externe / campurile fara FK sunt excluse
        return item.CtlProps != null && item.CtlProps.AllowAdd == true
            && !this.isPreview && this._getFkEntityId(item) != null;
    }

    //entitatea in care se adauga valoarea noua, in aceeasi ordine ca GetFieldSource pe server:
    //IdEntitySource (sursa specificata manual - ex. MultiSelect M-N) inaintea cheii externe din camp.
    _getFkEntityId(item) {
        if (item.IdEntitySource != null) {
            return item.IdEntitySource;
        }
        if (item.EntityField != null && item.EntityField.IdEntityFK != null) {
            return item.EntityField.IdEntityFK;
        }
        return null;
    }

    _comboBoxHasMatch(widget, typed) {
        let data = widget.dataSource.data();
        let lc = typed.toLowerCase();
        for (let i = 0; i < data.length; i++) {
            if (data[i].Name != null && data[i].Name.toLowerCase() == lc) {
                return true;
            }
        }
        return false;
    }

    //POST catre AddEntityFieldSource dupa confirmare; rezolva cu {Id, Name} sau null (anulat/eroare)
    _confirmAndAddEntityFieldValue(item, name) {
        return swal.fire({
            title: this._getResource('Attention'),
            html: this._getResource('AllowAddConfirm').replace('{0}', name),
            showCancelButton: true,
            confirmButtonText: this._getResource('SWITCH_ON'),
            cancelButtonText: this._getResource('SWITCH_OFF'),
            allowOutsideClick: false
        }).then(result => {
            if (!result.isConfirmed) {
                return null;
            }

            return $.ajax({
                url: rootURL + 'Entity/AddEntityFieldSource',
                type: 'POST',
                data: { idEntity: this._getFkEntityId(item), name: name }
            }).then(res => {
                if (res != null && res.Id != null && res.errorObj == null) {
                    //CG: nomenclatorul tocmai s-a schimbat, deci listele tinute minte sunt vechi
                    if (this.fieldSourceCache != null) {
                        this.fieldSourceCache.clear();
                    }
                    return res;
                }
                return null;
            }).catch(() => {
                return null;
            });
        });
    }

    _checkVisibility(item) {
        if (item.IdXpCommandVisible != null) {
            this.executeCommandById(item.IdXpCommandVisible, this.isClientCommand(item.IdXpCommandVisible) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                if (this._parseBooleanCommandResult(result) == true) {
                    this._showItem(item);
                } else {
                    this._hideItem(item);
                }
            });
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._checkVisibility(child);
            });
        }
    }

    _checkItemValidity(item) {
        return new Promise((resolve, reject) => {
            if (!item.Hidden && !item.IsReadOnly && this._getVisibleState(item) && !this._getReadonlyState(item)) {
                let value = this._getFieldValueByUniqueId(item.UniqueClientId);

                let isEmpty =
                    value === null ||
                    value === '' ||
                    (value instanceof Array && value.length == 0) ||
                    (item.CtlType === 'File' && value === false);

                if (item.IdXpCommandNotNull != null) {
                    if (isEmpty) {
                        this.executeCommandById(item.IdXpCommandNotNull, this.isClientCommand(item.IdXpCommandNotNull) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                            if (this._parseBooleanCommandResult(result) == true) {
                                this._decorateField(item, false);
                                this.isValid = false;
                                resolve();
                            } else {
                                this._decorateField(item, true);

                                if (item.IdXpCommandValid != null) {
                                    this.executeCommandById(item.IdXpCommandValid, this.isClientCommand(item.IdXpCommandValid) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                                        let value = this._parseStringCommandResult(result);

                                        if (value != null) {
                                            this._decorateField(item, false, value);
                                            this.isValid = false;
                                        } else {
                                            this._decorateField(item, true);
                                        }
                                        resolve();
                                    });
                                } else {
                                    resolve();
                                }
                            }
                        });
                    } else {
                        this._decorateField(item, true);

                        if (item.IdXpCommandValid != null) {
                            this.executeCommandById(item.IdXpCommandValid, this.isClientCommand(item.IdXpCommandValid) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                                let value = this._parseStringCommandResult(result);

                                if (value != null) {
                                    this._decorateField(item, false, value);
                                    this.isValid = false;
                                } else {
                                    this._decorateField(item, true);
                                }
                                resolve();
                            });
                        } else {
                            resolve();
                        }
                    }
                } else if (this._isEligibleForValidation(item)) {
                    if (isEmpty) {
                        this._decorateField(item, false);
                        this.isValid = false;
                        resolve();
                    } else {
                        this._decorateField(item, true);

                        if (item.IdXpCommandValid != null) {
                            this.executeCommandById(item.IdXpCommandValid, this.isClientCommand(item.IdXpCommandValid) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                                let value = this._parseStringCommandResult(result);

                                if (value != null) {
                                    this._decorateField(item, false, value);
                                    this.isValid = false;
                                } else {
                                    this._decorateField(item, true);
                                }
                                resolve();
                            });
                        } else {
                            resolve();
                        }
                    }
                } else if (item.IdXpCommandValid != null) {
                    this.executeCommandById(item.IdXpCommandValid, this.isClientCommand(item.IdXpCommandValid) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                        let value = this._parseStringCommandResult(result);

                        if (value != null) {
                            this._decorateField(item, false, value);
                            this.isValid = false;
                        } else {
                            this._decorateField(item, true);
                        }
                        resolve();
                    });
                } else {
                    resolve();
                }
            } else {
                resolve();
            }
        });
    }

    _checkItemReadonly(item) {
        return new Promise((resolve, reject) => {
            if (item.IdXpCommandReadOnly != null) {
                this.executeCommandById(item.IdXpCommandReadOnly, this.isClientCommand(item.IdXpCommandReadOnly) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                    if (this._parseBooleanCommandResult(result) == true) {
                        this._setItemReadonly(item);
                    } else {
                        this._setItemReadwrite(item);
                    }
                    resolve();
                });
            } else {
                resolve();
            }
        });

    }

    _checkItemVisibility(item) {
        return new Promise((resolve, reject) => {
            if (item.IdXpCommandVisible != null) {
                this.executeCommandById(item.IdXpCommandVisible, this.isClientCommand(item.IdXpCommandVisible) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                    if (this._parseBooleanCommandResult(result) == true) {
                        this._showItem(item);
                    } else {
                        this._hideItem(item);
                    }
                    resolve();
                });
            } else {
                resolve();
            }
        });
    }

    _checkValidate(item) {
        if (item.IdValidateCommand != null) {
            this.executeCommandById(item.IdValidateCommand, this.isClientCommand(item.IdValidateCommand) ? { item: item, value: this._getFieldValueByUniqueId(item.UniqueClientId) } : null).then((result) => {
                if (result == null) {
                    //validarea este ok
                    this._decorateField(item, true);
                } else {
                    //validarea nu este ok
                    alert(result);
                    this._decorateField(item, false);
                }
            });
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._checkValidate(child);
            });
        }
    }

    _parseBooleanCommandResult(item) {
        if (item == null) {
            return null;
        }

        if (item == 1 || item == '1' || item == true || item == 'true' || item == 'True') {
            return true;
        }

        if (item === 0 || item === '0' || item === false || item === 'false' || item === 'False') {
            return false;
        }

        let keys = Object.keys(item);

        if (keys.length > 0) {
            let value = item[keys[0]];

            if (value === 1 || value === '1' || value === true || value === 'true' || value === 'True') {
                return true;
            }

            if (value === 0 || value === '0' || value === false || value === 'false' || value === 'False') {
                return false;
            }
        }

        return null;
    }

    _parseStringCommandResult(item) {
        if (item != null) {
            if (typeof item === 'string') {
                return item;
            } else if (typeof item === 'object') {
                let keys = Object.keys(item);

                if (keys.length > 0) {
                    let value = item[keys[0]];

                    if (typeof value === 'string') {
                        return value;
                    }
                }
            }
        }

        return null;
    }

    _initDatePickerControl(item) {
        let options = {};

        if (item.Format != null && item.Format.trim() != '') {
            options.format = item.Format;
        }

        if (this.serverData['fld_' + item.Id] != null) {
            options.value = this._deserializeDate(this.serverData['fld_' + item.Id]);
        }

        options.change = (e) => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = this.getCascadedDependants(item, dependants);

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        };

        options.popup = {
            appendTo: this._getAppendTo(item)
        }

        $("#" + item.UniqueClientId).kendoDatePicker(options);

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoDatePicker").readonly(true);
        }
    }

    _initIntegerTextBoxControl(item) {
        let format = "0";

        if (item.Format != null && item.Format.trim() != '') {
            format = item.Format;
        }

        $("#" + item.UniqueClientId).kendoNumericTextBox({
            format: format,
            decimals: 0,
            value: this.serverData != null && this.serverData['fld_' + item.Id] != null ? this.serverData['fld_' + item.Id] : null,
            popup: {
                appendTo: this._getAppendTo(item)
            }
        });

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        }
    }

    _initNumericTextBoxControl(item) {
        let options = {};

        if (item.Format != null && item.Format.trim() != '') {
            options.format = item.Format;
            options.decimals = this._getDecimalsFromFormat(item.Format);
        }

        options.popup = {
            appendTo: this._getAppendTo(item)
        }

        $("#" + item.UniqueClientId).kendoNumericTextBox(options);

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoNumericTextBox").readonly(true);
        }
    }

    _getHtmlValue(item) {
        let editor = this.htmlEditors[item.UniqueClientId];
        if (editor != null) {
            return editor.getValue();
        }

        let element = document.getElementById(item.UniqueClientId);
        return element != null && element.htmlValue != null ? element.htmlValue : null;
    }

    _setHtmlValue(item, value) {
        let element = document.getElementById(item.UniqueClientId);
        if (element == null) {
            return;
        }

        element.htmlValue = value;

        let editor = this.htmlEditors[item.UniqueClientId];
        if (editor != null && editor.getValue() !== (value != null ? value : '')) {
            element.htmlSettingValue = true;
            editor.setValue(value != null ? value : '', -1);
            element.htmlSettingValue = false;
        }

        $('#' + item.UniqueClientId + '-rendered').html(value != null ? value : '');
    }

    _createHtmlEditor(item) {
        let editor = this.htmlEditors[item.UniqueClientId];
        if (editor != null) {
            return editor;
        }

        editor = ace.edit(item.UniqueClientId + '-editor', {
            mode: "ace/mode/html",
            selectionStyle: "text",
            theme: "ace/theme/chrome"
        });

        let element = document.getElementById(item.UniqueClientId);
        editor.setValue(element != null && element.htmlValue != null ? element.htmlValue : '', -1);
        editor.session.on('change', () => {
            if (element != null && element.htmlSettingValue) {
                return;
            }

            if (element != null) {
                element.htmlValue = editor.getValue();
            }

            if (this._isEligibleForValidation(item)) {
                this._decorateField(item, editor.getValue() !== '');
            }
        });

        editor.on('blur', () => {
            let dependants = this._getDependants(item.Guid);
            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);
                this._handleCascadedItems(this.getCascadedDependants(item, dependants));
            }

            this._checkItemValidity(item);
        });
        editor.on('focus', () => editor.resize());

        this.htmlEditors[item.UniqueClientId] = editor;
        return editor;
    }

    _destroyHtmlEditor(item) {
        let editor = this.htmlEditors[item.UniqueClientId];
        if (editor == null) {
            return;
        }

        let element = document.getElementById(item.UniqueClientId);
        if (element != null) {
            element.htmlValue = editor.getValue();
        }

        editor.destroy();
        delete this.htmlEditors[item.UniqueClientId];

        let editorElement = document.getElementById(item.UniqueClientId + '-editor');
        if (editorElement != null) {
            editorElement.innerHTML = '';
        }
    }

    _setHtmlReadonly(item, readonly) {
        if (readonly) {
            let editor = this.htmlEditors[item.UniqueClientId];
            if (editor != null) {
                let element = document.getElementById(item.UniqueClientId);
                if (element != null) {
                    element.htmlValue = editor.getValue();
                }
            }
            $('#' + item.UniqueClientId).css('border', 'none');
            $('#' + item.UniqueClientId + '-rendered').html(this._getHtmlValue(item) || '').css('display', 'block');
            $('#' + item.UniqueClientId + '-editor').css('display', 'none');
        } else {
            $('#' + item.UniqueClientId).css('border', '');
            $('#' + item.UniqueClientId + '-rendered').css('display', 'none');
            $('#' + item.UniqueClientId + '-editor').css('display', 'block');
            let editor = this._createHtmlEditor(item);
            setTimeout(() => editor.resize(true), 0);
        }
    }

    _initHtmlControl(item) {
        this._setHtmlValue(item, null);
    }

    _initRichTextControl(item) {
        let options = {
            tools: [
                "undo",
                "redo",
                { name: "separator1", type: "separator" },
                {
                    name: "fontName",
                    items: [
                        { text: "Andale Mono", value: "\"Andale Mono\"" }, // Font-family names composed of several words should be wrapped in \" \"
                        { text: "Arial", value: "Arial" },
                        { text: "Arial Black", value: "\"Arial Black\"" },
                        { text: "Book Antiqua", value: "\"Book Antiqua\"" },
                        { text: "Comic Sans MS", value: "\"Comic Sans MS\"" },
                        { text: "Courier New", value: "\"Courier New\"" },
                        { text: "Georgia", value: "Georgia" },
                        { text: "Helvetica", value: "Helvetica" },
                        { text: "Impact", value: "Impact" },
                        { text: "Symbol", value: "Symbol" },
                        { text: "Tahoma", value: "Tahoma" },
                        { text: "Terminal", value: "Terminal" },
                        { text: "Times New Roman", value: "\"Times New Roman\"" },
                        { text: "Trebuchet MS", value: "\"Trebuchet MS\"" },
                        { text: "Verdana", value: "Verdana" },
                    ]
                },
                "fontSize",
                "bold",
                "italic",
                "underline",
                "backColor",
                "foreColor",
                { name: "separator2", type: "separator" },
                "insertUnorderedList",
                "justifyLeft",
                "justifyCenter",
                "justifyRight",
                { name: "separator3", type: "separator" },
                "formatting",
                { name: "separator4", type: "separator" },
                "createLink",
                "unlink",
                "insertImage",
                { name: "separator5", type: "separator" },
                "tableWizard",
                "tableProperties",
                "tableCellProperties",
                "createTable",
                "addRowAbove",
                "addRowBelow",
                "addColumnLeft",
                "addColumnRight",
                "deleteRow",
                "deleteColumn",
                "mergeCellsHorizontally",
                "mergeCellsVertically",
                "splitCellHorizontally",
                "splitCellVertically",
                "tableAlignLeft",
                "tableAlignCenter",
                "tableAlignRight"
            ]
        };

        options.change = (e) => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = this.getCascadedDependants(item, dependants);

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        };

        options.popup = {
            appendTo: this._getAppendTo(item)
        }

        $("#" + item.UniqueClientId).kendoEditor(options);

        if (item.IsReadOnly) {
            //$("#" + item.UniqueClientId).data("kendoEditor").readonly(true);
            const editor = $("#" + item.UniqueClientId).data("kendoEditor");
            $(editor.body).removeAttr("contenteditable");
            editor.wrapper.find(".k-toolbar").hide();
            $('#' + item.UniqueClientId).closest('table').addClass('disabled-control');
        }
    }

    _getDecimalsFromFormat(format) {
        switch (format) {
            case '{0:0.0}': return 1;
            case '{0:0.00}': return 2;
            case '{0:0.000}': return 3;
            case '{0:0.0000}': return 4;
            case '{0:0.00000}': return 5;
            case '{0:0.000000}': return 6;
            default: return 2;
        }
    }

    _initTextBoxControl(item) {
        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }
    }

    _applyFieldPlaceholder(item) {
        const ctlProps = item != null ? item.CtlProps : null;
        const placeholder = ctlProps != null && typeof ctlProps.Placeholder === 'string'
            ? ctlProps.Placeholder : '';
        if (placeholder.trim() === '') {
            return;
        }

        const ctlType = item.CtlType;
        const subtype = ctlProps != null ? ctlProps.CtlSubType : null;
        const supportsPlaceholder = ['TextBox', 'TextArea', 'IntegerTextBox', 'NumericTextBox', 'DatePicker', 'DateTimePicker'].includes(ctlType)
            || (ctlType === 'ComboBox' && ['ListView', 'RadioButton'].indexOf(subtype) < 0);
        if (!supportsPlaceholder) {
            return;
        }

        const element = document.getElementById(item.UniqueClientId);
        if (element == null) {
            return;
        }

        // Aplică placeholderul pe elementul sursă și pe inputul vizibil creat de widgeturile Kendo.
        element.setAttribute('placeholder', placeholder);
        const widget = $(element).data('kendoNumericTextBox')
            || $(element).data('kendoDatePicker')
            || $(element).data('kendoDateTimePicker')
            || $(element).data('kendoComboBox')
            || $(element).data('kendoMultiSelect')
            || $(element).data('kendoDropDownTree');
        if (widget != null) {
            if (widget.input != null && widget.input.length > 0) {
                widget.input.attr('placeholder', placeholder);
            }
            if (widget.wrapper != null) {
                widget.wrapper.find('input.k-input-inner, input.k-input').attr('placeholder', placeholder);
            }
        }
    }

    _initTextAreaControl(item) {
        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        }
    }

    _initDateTimePickerControl(item) {
        let options = {};

        if (item.Format != null && item.Format.trim() != '') {
            options.format = item.Format;
        }

        if (this.serverData['fld_' + item.Id] != null) {
            options.value = this._deserializeDateTime(this.serverData['fld_' + item.Id]);
        }

        options.change = (e) => {
            let dependants = this._getDependants(item.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = this.getCascadedDependants(item, dependants);

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(item);
        };

        options.popup = {
            appendTo: this._getAppendTo(item)
        }

        $("#" + item.UniqueClientId).kendoDateTimePicker(options);

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoDateTimePicker").readonly(true);
        }
    }

    _initSwitchControl(item) {

        $("#" + item.UniqueClientId).kendoSwitch({
            messages: {
                checked: this._getResource('SWITCH_ON'),
                unchecked: this._getResource('SWITCH_OFF')
            },
            checked: false,
            change: (e) => {
                if (!item.NotNull) {
                    this._threeStateSwitch_Change(e);
                }
                let dependants = this._getDependants(item.Guid);

                if (dependants != null && dependants.length > 0) {
                    this._handleItemsState(dependants);

                    let cascadedDependants = this.getCascadedDependants(item, dependants);

                    this._handleCascadedItems(cascadedDependants);
                }

                //self check
                this._checkItemValidity(item);
            },
            popup: {
                appendTo: this._getAppendTo(item)
            }
        });

        if (!item.NotNull) {
            $("#" + item.UniqueClientId).prop("threeState", true);
            this._threeStateSwitchSetValue("#" + item.UniqueClientId, null);
        }
        else {
            this._threeStateSwitchSetValue("#" + item.UniqueClientId, false);
        }
        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data('kendoSwitch').readonly(true);
        }
    }

    _initCheckboxControl(item) {
        let checkbox = $("#" + item.UniqueClientId);
        this._setCheckboxValue(item, this._isCheckboxNullable(item) ? null : false);
        checkbox.on('change', () => {
            let checked = checkbox.prop('checked') === true;
            let previousValue = checkbox.data('checkboxValue');
            let value = this._isCheckboxNullable(item) && previousValue === false && checked ? null : checked;
            this._setCheckboxValue(item, value);

            let dependants = this._getDependants(item.Guid);
            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);
                let cascadedDependants = this.getCascadedDependants(item, dependants);
                this._handleCascadedItems(cascadedDependants);
            }

            this._checkItemValidity(item);
        });

        if (item.IsReadOnly) {
            checkbox.prop('disabled', true);
        }
    }

    _getCheckboxValue(item) {
        let checkbox = $("#" + item.UniqueClientId);
        if (!this._isCheckboxNullable(item)) {
            return checkbox.prop('checked') === true;
        }

        let value = checkbox.data('checkboxValue');
        return value === undefined ? (checkbox.prop('indeterminate') ? null : checkbox.prop('checked') === true) : value;
    }

    _setCheckboxValue(item, value) {
        let checkbox = $("#" + item.UniqueClientId);
        let nullable = this._isCheckboxNullable(item);
        if (value == null) {
            value = nullable ? null : false;
        } else {
            let parsed = this._parseBooleanCommandResult(value);
            value = parsed == null ? false : parsed;
        }

        checkbox.prop('checked', value === true);
        checkbox.prop('indeterminate', value === null && nullable);
        checkbox.data('checkboxValue', value);
    }

    _isCheckboxNullable(item) {
        return !item.NotNull && !(item.EntityField != null && item.EntityField.NotNull && !this.isFilter);
    }

    _populateCheckboxControl(item) {
        let checkboxValue = this._parseBooleanCommandResult(this.dataItem['fld_' + item.Id]);
        this._setCheckboxValue(item, checkboxValue);

        if ((this.dataItem['fld_' + item.Id + '_xp_allow_view'] == null || this.dataItem['fld_' + item.Id + '_xp_allow_view'] == 1) && !item.Hidden) {
            $('#' + item.UniqueClientId + '-wrapper').show();
        }

        if ((!this.allowEdit || item.IsReadOnly || this.dataItem['fld_' + item.Id + '_xp_allow_edit'] == 0) && !this.isFilter) {
            $('#' + item.UniqueClientId).prop('disabled', true);
        }
    }

    _threeStateSwitch_Change(e) {
        if (!e.checked) {
            if (!e.sender.element.prop("indeterminate")) {
                e.sender.element.prop("indeterminate", true);
                e.sender.wrapper.addClass("k-indeterminate");

                e.sender.setOptions({
                    messages: {
                        checked: this._getResource("SWITCH_NA")
                    }
                });
                e.preventDefault();
                e.sender.element.prop("currentValue", null);
            } else {
                e.sender.element.prop("indeterminate", false);
                e.sender.wrapper.removeClass("k-indeterminate");

                e.sender.setOptions({
                    messages: {
                        checked: this._getResource("SWITCH_ON")
                    }
                });

                e.sender.element.prop("currentValue", false);
            }
        }
        else {
            e.sender.element.prop("currentValue", true);
        }
    }
    _threeStateSwitchGetValue(sender) {
        var ctl = $(sender).data("kendoSwitch");
        if (ctl.element.prop("threeState")) {
            return ctl.element.prop("currentValue");
        }
        else {
            var value = ctl.value();
            if (value === null) {
                return false;
            }
            else {
                return value;
            }
        }

        //if (ctl.value()) {
        //    if (ctl.element.prop("indeterminate")) {
        //        return null;
        //    }
        //    else {
        //        return true;
        //    }
        //}
        //else {
        //    return false;
        //}
    }
    _threeStateSwitchSetValue(sender, value) {
        var ctl = $(sender).data("kendoSwitch");
        if (ctl.element.prop("threeState")) {
            ctl.element.prop("currentValue", value);
            if (value == null) {
                ctl.value(true);
                ctl.element.prop("indeterminate", true);
                ctl.wrapper.addClass("k-indeterminate");
                ctl.setOptions({
                    messages: {
                        checked: this._getResource("SWITCH_NA")
                    }
                });
            }
            else {
                ctl.element.prop("indeterminate", false);
                ctl.wrapper.removeClass("k-indeterminate");
                ctl.setOptions({
                    messages: {
                        checked: this._getResource("SWITCH_ON")
                    }
                });
                ctl.value(value);
            }
        }
        else {
            if (value === null) {
                value = false;
            }
            ctl.value(value);
        }
    }

    _initMapViewControl(item) {
        if (item.IdMap != null) {
            //CG: containerul e in interiorul controlului, deci il cautam acolo si nu pe toata pagina dupa map-id
            let container = document.getElementById(item.UniqueClientId).querySelector('.xp-map-container');
            $("#" + item.UniqueClientId)[0].mapControl = new MapControl(item.IdMap, container, rootURL, this._getMapClassId(item));
            $("#" + item.UniqueClientId)[0].mapControl.init();
        }
    }

    _initSublistControl(item, ignore) {
        if (ignore) {
            return;
        }

        //CG: subformularul trece pe aici pentru ca foloseste acelasi container (xp-list-container) - asa il
        //gasesc si loadSublists si deschiderea unui tab amanat, fara cod separat
        if (item.TypeName == 'UISubformDto') {
            this._initSubformControl(item);
            return;
        }

        if (item.IdList == null || item.IdList == '') {
            return;
        }

        let sublistUrl = '';

        if (this.isPreview) {
            sublistUrl = rootURL + 'EntityList/EntitySubListRuntime?IdList=' + item.IdList + '&pageGuid=' + this._generateUUID();
        } else {
            sublistUrl = rootURL + 'EntityList/EntitySubListRuntime?idUISubList=' + item.Id + '&pkVal=' + this.objectId + '&pageGuid=' + this._generateUUID();
            if (this.idExtConn != null) {
                sublistUrl += "&idExtConn=" + this.idExtConn;
            }
        }

        $.ajax({
            type: "GET",
            url: sublistUrl,
            contentType: "application/json; charset=utf-8",
            async: true,
            success: (listMeta) => {
                $('#' + item.UniqueClientId).append('<script>' + listMeta.CustomJs + '</script>');
                let filterId = listMeta.IdFilter != null ? listMeta.IdFilter : -1;

                listMeta.Context = '';
                listMeta.CurrentUrl = 'full';
                listMeta.ReturnUrl = '';
                listMeta.ContainerId = item.UniqueClientId;
                listMeta.Template = 'standard';
                listMeta.GeneralResources = this.generalResources;
                listMeta.EntityFormResources = this.customFormResources;
                listMeta.UiActionResources = this.actionLocalization;
                listMeta.RootUrl = rootUrl;
                listMeta.IsPreview = this.isPreview;
                listMeta.LayoutResources = this.localization;
                listMeta.FilterId = filterId;
                listMeta.Parent = this;
                listMeta.onBeforeListLoaded = (list) => {
                    if (this.onSublistBeforeListLoaded != null) {
                        this.onSublistBeforeListLoaded(list, item);
                    }
                };
                listMeta.onListLoaded = (list) => {
                    if (this.onSublistLoaded != null) {
                        this.onSublistLoaded(list, item);
                    }
                };
                listMeta.onFilterLoaded = (list) => {
                    if (this.onSublistFilterLoaded != null) {
                        this.onSublistFilterLoaded(list, item);
                    }
                };
                listMeta.uiLayoutId = item.Id;
                listMeta.parentPkVal = this.objectId;

                if (item.CtlProps == null || item.CtlProps.Autobind == null) {
                    listMeta.Autobind = true;
                } else {
                    listMeta.Autobind = item.CtlProps.Autobind;
                }

                this.sublists[item.UniqueClientId] = new ListControl(listMeta);
                item.isLoaded = true;
            },
            error: (e) => {
                toastr.error(e.responseText, this._getResource('GetSublistError'));
            }
        });
    }

    //CG: subformularul se inregistreaza in acelasi this.sublists ca ListControl, deci descoperirea,
    //cascadarea si getFieldValue merg mai departe nemodificate
    _initSubformControl(item) {
        //CG: deschiderea unui tab si loadSublists ajung aici fara garzile din _populateItem - un rand sau un filtru nu gazduieste subformulare
        if (this.isRow || this.isFilter) {
            return;
        }

        //CG: _getSublistTemplate reseteaza isLoaded la fiecare reloadForm, deci aici se reintra peste o
        //stiva veche; fara eliberare ar ramane in aer N FormControl-uri de rand, fiecare cu modalul lui
        let previous = this.sublists[item.UniqueClientId];
        if (previous != null && typeof previous.destroy === 'function') {
            previous.destroy();
        }

        this.sublists[item.UniqueClientId] = new SubformControl({
            hostForm: this,
            item: item,
            containerId: item.UniqueClientId,
            localization: this.localization,
            rootUrl: rootUrl,
            idExtConn: this.idExtConn,
            parentPkVal: this.objectId,
            isPreview: this.isPreview,
            //CG: clasa se ia din modulul curent, ca SubformControl sa nu importe inapoi FormControl
            createRowForm: (options) => new FormControl(options)
        });
    }

    //CG: mutat din transport-ul dataSource-ului, neschimbat. Se cheama la fiecare citire pentru ca are
    //si efecte laterale pe control: goleste valoarea si trece pe readonly cand dependenta e goala
    _getMultiSelectSourceUrl(item) {
        if (item.DependsOnGuids != null && item.DependsOnGuids.length > 0) {
            let isReadonly = false;
            let setNullOnReadonly = true;
            let filter = {};

            item.DependsOnGuids.forEach(depends => {
                let dependant = this._getItemByGuid(depends, [this.metadata]);

                if (dependant.IdXpCommandLoad != null && !dependant.loadCommandHandled) {
                    setNullOnReadonly = false;
                }

                let value = this._getItemValueByGuid(depends, true);

                var tagName = dependant.Name;
                var tagNameFld = "fld_" + dependant.Name;
                var dataType = dependant.DataType;
                if (dependant.EntityField) {
                    tagName = dependant.EntityField.FieldName;
                    dataType = dependant.EntityField.DataType;
                }
                if (value === null || value === '' || (value instanceof Array && value.length == 0)) {
                    if (item.SqlWhere != null && item.SqlWhere != '' && (item.SqlWhere.indexOf(tagName) >= 0 || item.SqlWhere.indexOf(tagNameFld) >= 0)) {
                        isReadonly = true;

                        filter["fld_" + dependant.Id] = {
                            value: value,
                            type: dataType
                        };
                    }
                } else {
                    if (item.SqlWhere != null && item.SqlWhere != '' && (item.SqlWhere.indexOf(tagName) >= 0 || item.SqlWhere.indexOf(tagNameFld) >= 0)) {

                        filter["fld_" + dependant.Id] = {
                            value: value,
                            type: dataType
                        };
                    }
                }
            });

            if (this.isPreview) {
                return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + '&filter=' + JSON.stringify(filter);
            }

            if (isReadonly) {
                if (setNullOnReadonly) {
                    $('#' + item.UniqueClientId).data("kendoMultiSelect").value(null);
                }

                $('#' + item.UniqueClientId).data("kendoMultiSelect").readonly(true);

                let additionalFilter = '';

                var fkVal = $('#' + item.UniqueClientId).data('kendoMultiSelect').value();
                var search = $('#' + item.UniqueClientId).data('kendoMultiSelect').input.val();
                additionalFilter = '&search=' + search;

                additionalFilter += '&fkVal=' + fkVal;

                return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + additionalFilter;
            } else {
                let additionalFilter = '';

                // vezi nota de la ramura fara dependente: la load-command, item.pendingFkVal
                // contine setul complet de id-uri din comanda. Cand e setat il folosim direct,
                // pentru ca .value() poate fi inca gol sau partial (doar un id comis de Kendo).
                var fkVal = item.pendingFkVal != null
                    ? item.pendingFkVal
                    : $('#' + item.UniqueClientId).data('kendoMultiSelect').value();
                var search = $('#' + item.UniqueClientId).data('kendoMultiSelect').input.val();
                additionalFilter = '&search=' + search;
                additionalFilter += '&fkVal=' + fkVal;

                return rootURL + 'Entity/GetFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn + '&filter=' + JSON.stringify(filter) + additionalFilter;
            }
        } else {
            if (this.isPreview) {
                return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id;
            }

            let additionalFilter = '';

            // La incarcarea unei comenzi de valoare implicita, item.pendingFkVal contine setul
            // complet de id-uri din comanda. Cand e setat il folosim direct, pentru ca .value()
            // poate fi inca gol (url-ul de read se construieste inainte de comiterea valorii) sau
            // partial (Kendo a comis doar un id) -> altfel ar pleca un singur id in loc de toate.
            var fkVal = item.pendingFkVal != null
                ? item.pendingFkVal
                : $('#' + item.UniqueClientId).data('kendoMultiSelect').value();
            var search = $('#' + item.UniqueClientId).data('kendoMultiSelect').input.val();
            additionalFilter = '&search=' + search;
            additionalFilter += '&fkVal=' + fkVal;

            return rootURL + 'Entity/GetFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn + additionalFilter;
        }
    }

    _initMultiSelectControl(item) {
        $("#" + item.UniqueClientId).kendoMultiSelect({
            autoBind: !this.isPreview,
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            suggest: true,
            ignoreCase: true,
            popup: {
                appendTo: this._getAppendTo(item)
            },
            value: this.serverData != null && this.serverData['fld_' + item.Id] != null ? this.serverData['fld_' + item.Id] : null,
            template: (dataItem) => {
                if (dataItem.Attr != null) {
                    if (dataItem.Attr.length == 2) {
                        if (dataItem.Attr[1] != null) {
                            return '<img src="' + (rootUrl + 'Entity/GetFileContent?idEntityField=' + dataItem.Attr[1] + '&pkVal=' + dataItem.Id) + '" width="60" height="60" /><span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + (dataItem.Attr[0] != null ? ('<br>' + dataItem.Attr[0]) : '') + '</span>'
                        }
                        else {
                            return '<span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + (dataItem.Attr[0] != null ? ('<br>' + dataItem.Attr[0]) : '') + '</span>';
                        }
                    }
                    else if (dataItem.Attr.length == 1) {
                        return '<span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + (dataItem.Attr[0] != null ? ('<br>' + dataItem.Attr[0]) : '') + '</span>';
                    }
                } else {
                    return '<span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + '</span>';
                }
            },
            dataSource: {
                serverFiltering: (item.DependsOnGuids != null && item.DependsOnGuids.length > 0) || (item.Rows != null && item.Rows > 0),
                transport: {
                    //CG: read ca functie, nu {url} - asa cererea trece prin _fetchFieldSource si randurile
                    //unei subliste si-o pot imparti. Url-ul se construieste tot la fiecare citire
                    read: (options) => this._readFieldSourceInto(options, () => this._getMultiSelectSourceUrl(item))
                }
            },
            dataBound: () => {
                let val = $('#' + item.UniqueClientId).attr('initValue');
                if (val != null && val != '') {
                    $('#' + item.UniqueClientId).attr('initValue', null);

                    let cbo = $('#' + item.UniqueClientId).data("kendoMultiSelect");
                    cbo.dataSource.data().forEach(x => {
                        if (x.Id == val) {
                            cbo.value(val);
                            cbo.trigger('change');
                        }
                    });
                }
            }
        });

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoMultiSelect").readonly(true);
        }
    }

    _getAppendTo(item) {
        if ($("#" + item.UniqueClientId).closest('.k-window').length > 0) {
            return $("#" + item.UniqueClientId).closest('.k-window');
        } else {
            return $("#" + item.UniqueClientId).parent();
        }
    }

    //CG: mutat din transport-ul dataSource-ului, neschimbat (vezi _getMultiSelectSourceUrl)
    _getDropDownTreeSourceUrl(item) {
        if (item.DependsOnGuids != null && item.DependsOnGuids.length > 0) {
            let isReadonly = false;
            let setNullOnReadonly = true;
            let filter = {};

            item.DependsOnGuids.forEach(depends => {
                let dependant = this._getItemByGuid(depends, [this.metadata]);

                if (dependant.IdXpCommandLoad != null && !dependant.loadCommandHandled) {
                    setNullOnReadonly = false;
                }

                let value = this._getItemValueByGuid(depends, true);
                var tagName = dependant.Name;
                var tagNameFld = "fld_" + dependant.Name;
                var dataType = dependant.DataType;
                if (dependant.EntityField) {
                    tagName = dependant.EntityField.FieldName;
                    dataType = dependant.EntityField.DataType;
                }
                if (value === null || value === '' || (value instanceof Array && value.length == 0)) {
                    if (item.SqlWhere != null && item.SqlWhere != '' && (item.SqlWhere.indexOf(tagName) >= 0 || item.SqlWhere.indexOf(tagNameFld) >= 0)) {
                        isReadonly = true;

                        filter["fld_" + dependant.Id] = {
                            value: value,
                            type: dataType
                        };
                    }
                } else {
                    if (item.SqlWhere != null && item.SqlWhere != '' && (item.SqlWhere.indexOf(tagName) >= 0 || item.SqlWhere.indexOf(tagNameFld) >= 0)) {

                        filter["fld_" + dependant.Id] = {
                            value: value,
                            type: dataType
                        };
                    }
                }
            });

            if (this.isPreview) {
                return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + '&filter=' + JSON.stringify(filter);
            }

            if (isReadonly) {
                if (setNullOnReadonly) {
                    $('#' + item.UniqueClientId).data("kendoDropDownTree").value(null);
                }

                $('#' + item.UniqueClientId).data("kendoDropDownTree").readonly(true);
                $('#' + item.UniqueClientId).parent().addClass('isReadonly');

                let additionalFilter = '';

                var fkVal = $('#' + item.UniqueClientId).data('kendoDropDownTree').value();
                var search = $('#' + item.UniqueClientId).data('kendoDropDownTree').filterInput.val();
                additionalFilter = '&search=' + search + '&fkVal=' + fkVal;

                return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + additionalFilter;
            } else {
                let additionalFilter = '';

                var fkVal = $('#' + item.UniqueClientId).data('kendoDropDownTree').value();
                var search = $('#' + item.UniqueClientId).data('kendoDropDownTree').filterInput.val();
                additionalFilter = '&search=' + search + '&fkVal=' + fkVal;

                return rootURL + 'Entity/GetTreeFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn + '&filter=' + JSON.stringify(filter) + additionalFilter;
            }
        } else {
            if (this.isPreview) {
                return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id;
            }

            let additionalFilter = '';

            var fkVal = $('#' + item.UniqueClientId).data('kendoDropDownTree').value();
            var search = $('#' + item.UniqueClientId).data('kendoDropDownTree').filterInput.val();
            additionalFilter = '&search=' + search + '&fkVal=' + fkVal;

            return rootURL + 'Entity/GetTreeFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn + additionalFilter;
        }
    }

    _initDropDownTreeControl(item) {
        $("#" + item.UniqueClientId).kendoDropDownTree({
            autoBind: !this.isPreview,
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            ignoreCase: true,
            popup: {
                appendTo: this._getAppendTo(item)
            },
            value: this.serverData != null && this.serverData['fld_' + item.Id] != null ? this.serverData['fld_' + item.Id] : null,
            loadOnDemand: true,
            dataSource: {
                schema: {
                    model: {
                        id: "Id",
                        items: "Items",
                        hasChildren: (selectedItem) => {
                            if (selectedItem.HasChildren == null) {
                                return false;
                            }
                            return selectedItem.HasChildren;
                        }
                    }
                },
                serverFiltering: true,
                transport: {
                    //CG: read ca functie, nu {url} - vezi _getMultiSelectSourceUrl. options.data poarta
                    //aici si Id-ul nodului expandat, deci pleaca mai departe si intra si in cheia de cache
                    read: (options) => this._readFieldSourceInto(options, () => this._getDropDownTreeSourceUrl(item))
                }
            },
            dataBound: (evt) => {
                let val = $('#' + item.UniqueClientId).attr('initValue');
                if (val != null && val != '') {
                    $('#' + item.UniqueClientId).attr('initValue', null);

                    let cbo = $('#' + item.UniqueClientId).data("kendoDropDownTree");
                    cbo.dataSource.data().forEach(x => {
                        if (x.Id == val) {
                            cbo.value(val);
                            cbo.trigger('change');
                        }
                    });
                }
            },
            select: (e) => {
                if (item.CtlProps.SelectOnlyLeaves) {
                    let selectedItem = e.sender.dataItem(e.node);
                    if (selectedItem.hasChildren) {
                        e.preventDefault();
                        e.sender.treeview.toggle(e.node);
                    }
                }
            }
        });
    }

    //CG: mutat din transport-ul dataSource-ului, neschimbat (vezi _getMultiSelectSourceUrl)
    _getComboBoxSourceUrl(item) {
        if (item.DependsOnGuids != null && item.DependsOnGuids.length > 0) {
            let isReadonly = false;
            let setNullOnReadonly = true;
            let filter = {};

            item.DependsOnGuids.forEach(depends => {
                let dependant = this._getItemByGuid(depends, [this.metadata]);

                if (dependant.IdXpCommandLoad != null && !dependant.loadCommandHandled) {
                    setNullOnReadonly = false;
                }

                let value = this._getItemValueByGuid(depends, true);
                var tagName = dependant.Name;
                var tagNameFld = "fld_" + dependant.Name;
                var dataType = dependant.DataType;
                if (dependant.EntityField) {
                    tagName = dependant.EntityField.FieldName;
                    dataType = dependant.EntityField.DataType;
                }
                if (value === null || value === '' || (value instanceof Array && value.length == 0)) {
                    if (item.SqlWhere != null && item.SqlWhere != '' && (item.SqlWhere.indexOf(tagName) >= 0 || item.SqlWhere.indexOf(tagNameFld) >= 0)) {
                        isReadonly = true;

                        filter["fld_" + dependant.Id] = {
                            value: value,
                            type: dataType
                        };
                    }
                } else {
                    if (item.SqlWhere != null && item.SqlWhere != '' && (item.SqlWhere.indexOf(tagName) >= 0 || item.SqlWhere.indexOf(tagNameFld) >= 0)) {

                        filter["fld_" + dependant.Id] = {
                            value: value,
                            type: dataType
                        };
                    }
                }
            });

            if (this.isPreview) {
                return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + '&filter=' + JSON.stringify(filter);
            }

            if (isReadonly) {
                if (setNullOnReadonly) {
                    $('#' + item.UniqueClientId).data("kendoComboBox").value(null);
                }

                $('#' + item.UniqueClientId).data("kendoComboBox").readonly(true);

                let additionalFilter = '';

                var fkVal = $('#' + item.UniqueClientId).data('kendoComboBox').value();
                var search = $('#' + item.UniqueClientId).data('kendoComboBox').text();
                additionalFilter = '&search=' + search + '&fkVal=' + fkVal;

                return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + additionalFilter;
            } else {
                let additionalFilter = '';

                var fkVal = $('#' + item.UniqueClientId).data('kendoComboBox').value();
                var search = $('#' + item.UniqueClientId).data('kendoComboBox').text();
                additionalFilter = '&search=' + search + '&fkVal=' + fkVal;

                return rootURL + 'Entity/GetFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn + '&filter=' + JSON.stringify(filter) + additionalFilter;
            }
        } else {
            if (this.isPreview) {
                return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id;
            }

            let additionalFilter = '';

            var fkVal = $('#' + item.UniqueClientId).data('kendoComboBox').value();
            var search = $('#' + item.UniqueClientId).data('kendoComboBox').text();
            additionalFilter = '&search=' + search + '&fkVal=' + fkVal;

            return rootURL + 'Entity/GetFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn + additionalFilter;
        }
    }

    _getRadioButtonValue(item) {
        let value = $('#' + item.UniqueClientId).attr('current-value');
        return value != null && value !== '' ? value : null;
    }

    _getMultiSelectCheckBoxValue(item) {
        const control = $('#' + item.UniqueClientId);
        const selected = control.find('input[type="checkbox"]:checked').map((_, checkbox) => checkbox.value).get();
        if (control.find('input[type="checkbox"]').length > 0) {
            control.data('xpMultiSelectCheckBoxValue', selected);
            return selected;
        }
        const stored = control.data('xpMultiSelectCheckBoxValue');
        if (stored != null) {
            return stored;
        }
        try {
            const current = JSON.parse(control.attr('current-value') || '[]');
            return Array.isArray(current) ? current : [];
        } catch (_) {
            return [];
        }
    }

    _setMultiSelectCheckBoxValue(item, value) {
        const values = (value == null ? [] : (Array.isArray(value) ? value : [value])).map(v => v.toString());
        const control = $('#' + item.UniqueClientId);
        control.attr('current-value', JSON.stringify(values));
        control.data('xpMultiSelectCheckBoxValue', values);
        control.find('input[type="checkbox"]').each((_, checkbox) => $(checkbox).prop('checked', values.includes(checkbox.value)));
    }

    _setMultiSelectCheckBoxReadonly(item, readonly) {
        $('#' + item.UniqueClientId).attr('item-readonly', readonly ? 'true' : 'false')
            .find('input[type="checkbox"]').prop('disabled', readonly);
    }

    _clearMultiSelectCheckBoxValue(item) {
        const control = $('#' + item.UniqueClientId);
        control.attr('current-value', '[]').data('xpMultiSelectCheckBoxValue', []);
        control.find('input[type="checkbox"]').prop('checked', false);
    }

    _setRadioButtonValue(item, value) {
        let control = $('#' + item.UniqueClientId);
        let normalizedValue = value != null ? value.toString() : '';
        control.attr('current-value', normalizedValue);
        control.find('input[type="radio"]').prop('checked', false)
            .filter((_, radio) => radio.value === normalizedValue).prop('checked', true);
    }

    _setRadioButtonReadonly(item, readonly) {
        $('#' + item.UniqueClientId).attr('item-readonly', readonly ? 'true' : 'false')
            .find('input[type="radio"]').prop('disabled', readonly);
    }

    _getRadioButtonSourceUrl(item) {
        let filter = {};
        let eligible = true;

        (item.DependsOnGuids || []).forEach(depends => {
            let dependant = this._getItemByGuid(depends, [this.metadata]);
            let value = this._getItemValueByGuid(depends, true);
            let tagName = dependant.EntityField ? dependant.EntityField.FieldName : dependant.Name;
            let dataType = dependant.EntityField ? dependant.EntityField.DataType : dependant.DataType;
            let isUsed = item.SqlWhere != null && item.SqlWhere != ''
                && (item.SqlWhere.indexOf(tagName) >= 0 || item.SqlWhere.indexOf('fld_' + dependant.Name) >= 0);

            if (isUsed) {
                filter['fld_' + dependant.Id] = { value: value, type: dataType };
                if (value === null || value === '' || (value instanceof Array && value.length == 0)) {
                    eligible = false;
                }
            }
        });

        if (this.isPreview || !eligible) {
            if (!eligible) {
                this._setRadioButtonValue(item, null);
                this._setRadioButtonReadonly(item, true);
            }
            return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + '&filter=' + encodeURIComponent(JSON.stringify(filter));
        }

        return rootURL + 'Entity/GetFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn
            + '&filter=' + encodeURIComponent(JSON.stringify(filter)) + '&fkVal=' + encodeURIComponent(this._getRadioButtonValue(item) || '');
    }

    _renderRadioButtonItems(item, data) {
        let control = $('#' + item.UniqueClientId);
        let value = this._getRadioButtonValue(item);
        let readonly = control.attr('item-readonly') == 'true';
        control.empty();

        (data || []).forEach((row, index) => {
            let optionId = item.UniqueClientId + '-option-' + index;
            let wrapper = $('<div class="form-check"></div>');
            let radio = $('<input class="form-check-input" type="radio">')
                .attr({ id: optionId, name: item.UniqueClientId, value: row.Id })
                .prop('checked', row.Id != null && row.Id.toString() === (value || '').toString())
                .prop('disabled', readonly);
            let label = $('<label class="form-check-label"></label>').attr('for', optionId).text(row.Name != null ? row.Name : '');
            wrapper.append(radio, label);
            control.append(wrapper);
        });

        applyFieldComponentClasses(item);
        applyFieldComponentStyles(item);
        applyFieldComponentHtmlAttributes(item);
    }

    _loadRadioButtonItems(item) {
        return this._fetchFieldSource(this._getRadioButtonSourceUrl(item), null)
            .then(data => this._renderRadioButtonItems(item, data));
    }

    _initRadioButtonControl(item) {
        let initialValue = this.serverData != null ? this.serverData['fld_' + item.Id] : null;
        this._setRadioButtonValue(item, initialValue);
        this._setRadioButtonReadonly(item, item.IsReadOnly);
        this._loadRadioButtonItems(item);
    }

    _initMultiSelectCheckBoxControl(item) {
        const initialValue = this.serverData != null ? this.serverData['fld_' + item.Id] : null;
        this._setMultiSelectCheckBoxValue(item, initialValue);
        this._setMultiSelectCheckBoxReadonly(item, item.IsReadOnly);
        this._loadMultiSelectCheckBoxItems(item);
    }

    _getMultiSelectCheckBoxSourceUrl(item) {
        let filter = {};
        let eligible = true;
        (item.DependsOnGuids || []).forEach(depends => {
            let dependant = this._getItemByGuid(depends, [this.metadata]);
            let value = this._getItemValueByGuid(depends, true);
            let tagName = dependant.EntityField ? dependant.EntityField.FieldName : dependant.Name;
            let dataType = dependant.EntityField ? dependant.EntityField.DataType : dependant.DataType;
            let isUsed = item.SqlWhere != null && item.SqlWhere != ''
                && (item.SqlWhere.indexOf(tagName) >= 0 || item.SqlWhere.indexOf('fld_' + dependant.Name) >= 0);
            if (isUsed) {
                filter['fld_' + dependant.Id] = { value: value, type: dataType };
                if (value === null || value === '' || (Array.isArray(value) && value.length == 0)) {
                    eligible = false;
                }
            }
        });

        if (this.isPreview || !eligible) {
            if (!eligible) {
                this._clearMultiSelectCheckBoxValue(item);
                this._setMultiSelectCheckBoxReadonly(item, true);
            }
            return rootURL + 'Entity/GetEmptyFieldSource?idField=' + item.Id + '&filter=' + encodeURIComponent(JSON.stringify(filter));
        }
        const selectedValues = this._getMultiSelectCheckBoxValue(item);
        return rootURL + 'Entity/GetFieldSource?idField=' + item.Id + '&idExtConn=' + this.idExtConn
            + '&filter=' + encodeURIComponent(JSON.stringify(filter)) + '&fkVal=' + encodeURIComponent(selectedValues.join(','));
    }

    _renderMultiSelectCheckBoxItems(item, data) {
        const control = $('#' + item.UniqueClientId);
        const values = this._getMultiSelectCheckBoxValue(item);
        const readonly = control.attr('item-readonly') == 'true';
        control.empty();

        (data || []).forEach((row, index) => {
            const optionId = item.UniqueClientId + '-option-' + index;
            const wrapper = $('<div class="form-check"></div>');
            const checkbox = $('<input class="form-check-input" type="checkbox">')
                .attr({ id: optionId, name: item.UniqueClientId + '[]', value: row.Id })
                .prop('checked', row.Id != null && values.includes(row.Id.toString()))
                .prop('disabled', readonly);
            const label = $('<label class="form-check-label"></label>').attr('for', optionId).text(row.Name != null ? row.Name : '');
            wrapper.append(checkbox, label);
            control.append(wrapper);
        });

        control.attr('current-value', JSON.stringify(values));
        control.data('xpMultiSelectCheckBoxValue', values);
        this._setMultiSelectCheckBoxReadonly(item, readonly);
        applyFieldComponentClasses(item);
        applyFieldComponentStyles(item);
        applyFieldComponentHtmlAttributes(item);
    }

    _loadMultiSelectCheckBoxItems(item) {
        return this._fetchFieldSource(this._getMultiSelectCheckBoxSourceUrl(item), null)
            .then(data => {
                this._renderMultiSelectCheckBoxItems(item, data);
            });
    }

    _initComboBoxControl(item) {
        $("#" + item.UniqueClientId).kendoComboBox({
            autoBind: !this.isPreview,
            dataTextField: 'Name',
            dataValueField: 'Id',
            filter: 'contains',
            syncValueAndText: false,
            //cu AllowAdd dezactivam autocomplete-ul (suggest), altfel input-ul se completeaza cu o
            //valoare existenta si Enter o selecteaza in loc sa adauge textul tastat. Cautarea pe server
            //(serverFiltering + filter contains) nu e afectata.
            suggest: !this._isAllowAdd(item),
            ignoreCase: true,
            popup: {
                appendTo: this._getAppendTo(item)
            },
            value: this.serverData != null && this.serverData['fld_' + item.Id] != null ? this.serverData['fld_' + item.Id] : null,
            template: (dataItem) => {
                if (dataItem.Attr != null) {
                    if (dataItem.Attr.length == 2) {
                        if (dataItem.Attr[1] != null) {
                            return '<img src="' + (rootUrl + 'Entity/GetFileContent?idEntityField=' + dataItem.Attr[1] + '&pkVal=' + dataItem.Id) + '" width="60" height="60" /><span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + (dataItem.Attr[0] != null ? ('<br>' + dataItem.Attr[0]) : '') + '</span>'
                        }
                        else {
                            return '<span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + (dataItem.Attr[0] != null ? ('<br>' + dataItem.Attr[0]) : '') + '</span>';
                        }
                    }
                    else if (dataItem.Attr.length == 1) {
                        return '<span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + (dataItem.Attr[0] != null ? ('<br>' + dataItem.Attr[0]) : '') + '</span>';
                    }
                } else {
                    return '<span class="k-state-default ml-2">' + '<strong>' + dataItem.Name + '</strong>' + '</span>';
                }
            },
            dataSource: {
                serverFiltering: (item.DependsOnGuids != null && item.DependsOnGuids.length > 0) || (item.Rows != null && item.Rows > 0),
                transport: {
                    //CG: read ca functie, nu {url} - vezi _getMultiSelectSourceUrl
                    read: (options) => this._readFieldSourceInto(options, () => this._getComboBoxSourceUrl(item))
                }
            },
            dataBound: () => {
                let val = $('#' + item.UniqueClientId).attr('initValue');
                if (val != null && val != '') {
                    $('#' + item.UniqueClientId).attr('initValue', null);

                    let cbo = $('#' + item.UniqueClientId).data("kendoComboBox");
                    cbo.dataSource.data().forEach(x => {
                        if (x.Id == val) {
                            cbo.value(val);
                            cbo.trigger('change');
                        }
                    });
                }
            }
        });

        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).data("kendoComboBox").readonly(true);
        }
    }

    //CG: classId-ul hartii unui camp, folosit si ca referinta pe magistrala de evenimente; pe UniqueClientId
    //si nu pe Id, ca sa fie unic pe instanta - altfel doua formulare peste acelasi layout isi sterg reciproc abonamentele
    _getMapClassId(item) {
        return item.IdMap + '-' + item.UniqueClientId;
    }

    _initGeomPickerModalMapControl(item) {
        if (item.IsReadOnly) {
            $("#" + item.UniqueClientId).attr('readonly', true);
        } else {
            $("#" + item.UniqueClientId + '-action').on('click', (evt) => {
                this.initModal(item.Label, '70%', null, false, null, true);

                $('#' + this.uniqueModalInnerId).append('<div class="xp-map-container xp-form-map" map-id="' + item.IdMap + '"></div>');
                $('#' + this.uniqueModalInnerId).css('overflow', 'hidden');
                //CG: map-id e la nivel de layout, deci querySelector-ul pe pagina nimerea harta altei instante;
                //cautam in modalul propriu, unde tocmai am adaugat containerul
                let container = document.getElementById(this.uniqueModalInnerId).querySelector('.xp-map-container');
                container.mapControl = new MapControl(item.IdMap, container, rootURL, this._getMapClassId(item));
                container.mapControl.init().then(() => {
                    container.mapControl.addTemporaryVectorLayer({
                        uid: item.UniqueClientId,
                        name: item.Name,
                        geometryType: item.EntityField.DataSubType,
                        srid: item.EntityField.Srid,
                        geomField: item.EntityField.FieldName,
                        idField: 'id',
                        visible: true,
                        editable: true,
                        minFitScale: item.CtlProps.MinFitScale,
                        featureEditCallback: this._getFeatureEditedCallback()
                    }).then((result) => {
                        if (result != null && result.status == true) {
                            container.mapControl.isLoaded = true;

                            this._populateMap(container.mapControl, item);
                        }
                    });
                });
            });
        }
    }

    _getFeatureEditedCallback() {
        let callback = (result, uid) => {
            let field = this._searchFieldByUniqueId(this.metadata, uid);

            if (field != null) {
                if (field.CtlType == 'GeomPicker' && field.CtlProps.CtlSubType == 'MapView') {
                    $("#" + field.UniqueClientId).attr('current-value', result.length > 0 ? result[0] : '');

                    //if (result.length == 0) {
                    $event.notify(eventTypes.TEMPORARY_LAYER_SELECTION_CHANGED, { features: null, layerSettings: $("#" + field.UniqueClientId)[0].mapControl.layerHandler.getLayerById(field.Name)[0].get('temporarySettings'), isNew: true }, this, this._getMapClassId(field));
                    //}
                } else if (field.CtlType == 'GeomPicker' && field.CtlProps.CtlSubType == 'ModalMap') {
                    $("#" + field.UniqueClientId).val(result[0]);

                    if (window['onFormMapFeatureEdited' + '_' + this.mapLayerId] == null && window['onFormMapFeatureEdited' + this.pageGuid] == null && this.onFormMapFeatureEdited == null) {
                        this.closeModal(true);
                    }
                }

                if (this._isEligibleForValidation(field)) {
                    if (result.length > 0) {
                        this._decorateField(field, true);
                    } else {
                        this._decorateField(field, false);
                    }
                }

                if (window['onFormMapFeatureEdited' + '_' + this.mapLayerId] != null && !this.isPreview) {
                    window['onFormMapFeatureEdited' + '_' + this.mapLayerId](this, field);
                }
                else if (window['onFormMapFeatureEdited' + this.pageGuid] != null && !this.isPreview) {
                    window['onFormMapFeatureEdited' + this.pageGuid](field);
                }
                if (this.onFormMapFeatureEdited != null) {
                    this.onFormMapFeatureEdited(this, field);
                }
            }

            let dependants = this._getDependants(field.Guid);

            if (dependants != null && dependants.length > 0) {
                this._handleItemsState(dependants);

                let cascadedDependants = this.getCascadedDependants(item, dependants);

                this._handleCascadedItems(cascadedDependants);
            }

            //self check
            this._checkItemValidity(field);
        };

        return callback;
    }

    getCascadedDependants(item, dependants) {
        let cascadedDependants = [];

        let tagName = item.Name;
        let tagNameFld = "fld_" + item.Name;
        if (item.EntityField) {
            tagName = item.EntityField.FieldName;
        }

        dependants.forEach(dependant => {
            if (dependant.SqlWhere != null && dependant.SqlWhere != '' && (dependant.SqlWhere.indexOf(tagName) >= 0 || dependant.SqlWhere.indexOf(tagNameFld) >= 0)) {
                cascadedDependants.push(dependant);
            }
        });

        return cascadedDependants;
    }

    _initGeomPickerMapViewControl(item) {
        if (item.IdMap != null) {
            //CG: containerul e in interiorul controlului, deci il cautam acolo si nu pe toata pagina dupa map-id
            let container = document.getElementById(item.UniqueClientId).querySelector('.xp-map-container');
            $("#" + item.UniqueClientId)[0].mapControl = new MapControl(item.IdMap, container, rootURL, this._getMapClassId(item));
            $("#" + item.UniqueClientId)[0].mapControl.init().then(() => {
                $("#" + item.UniqueClientId)[0].mapControl.addTemporaryVectorLayer({
                    uid: item.UniqueClientId,
                    name: item.Name,
                    geometryType: item.EntityField.DataSubType,
                    srid: item.EntityField.Srid,
                    geomField: item.EntityField.FieldName,
                    idField: 'id',
                    visible: true,
                    editable: !item.IsReadOnly,
                    minFitScale: item.CtlProps.MinFitScale,
                    featureEditCallback: this._getFeatureEditedCallback()
                }).then((result) => {
                    if (result != null && result.status == true) {
                        $("#" + item.UniqueClientId)[0].mapControl.isLoaded = true;
                    }
                });
            });
        }
    }

    _handleItemsState(dependants, isPopulating = false) {
        if (!this.isPreview) {
            let serverGroups = {};

            dependants.forEach(dependant => {
                // DefValue commands must only re-run on genuine user input, never during initial
                // population (e.g. when a combobox loads its stored value). Otherwise an EDIT/ALLWAYS
                // DefValue would overwrite the persisted value on every form load.
                if (!isPopulating
                    && dependant.DefValue != null
                    && dependant.DefValue.ValueType == 'XP_COMMAND'
                    && dependant.DefValue.IdXpCommand != null
                    && (this.commands || []).find(row => row.Id == dependant.DefValue.IdXpCommand) != null
                    && this._isDefValueApplicable(dependant, false)) {

                    let cmdId = dependant.DefValue.IdXpCommand;

                    if (this.isClientCommand(cmdId)) {
                        this._handleDefValueCommandItem(dependant);
                    } else {
                        if (serverGroups[cmdId] == null) {
                            serverGroups[cmdId] = [];
                        }
                        serverGroups[cmdId].push(dependant);
                    }
                }

                this._checkItemVisibility(dependant).then(() => {
                    if (this._getVisibleState(dependant)) {
                        this._checkItemReadonly(dependant).then(() => {
                            if (!this._getReadonlyState(dependant)) {
                                this._checkItemValidity(dependant);
                            }
                        });
                    }
                });
            });

            Object.keys(serverGroups).forEach(cmdId => {
                this._handleSharedServerDefValueCommand(cmdId, serverGroups[cmdId]);
            });
        }
    }

    _handleCascadedItems(dependants, keepValue) {
        dependants.forEach(dependant => {
            if (dependant.TypeName == 'UISublistDto' || dependant.TypeName == 'UISubformDto') {
                this._handleCascadedSublist(dependant, keepValue);
            } else {
                switch (dependant.CtlType) {
                    case 'ComboBox': {
                        switch (this._getFieldControlSubType(dependant)) {
                            case 'ListView': break;//TO DO
                            case 'MultiSelect': this._handleCascadedMultiSelect(dependant, keepValue);
                                break;
                            case 'TreeView': this._handleCascadedDropDownTree(dependant, keepValue);
                                break;
                            case 'RadioButton': this._handleCascadedRadioButton(dependant, keepValue);
                                break;
                            case 'MultiSelectCheckBox': this._handleCascadedMultiSelectCheckBox(dependant, keepValue);
                                break;
                            default: this._handleCascadedCombobox(dependant, keepValue);
                                break;
                        }
                    }
                        break;
                    default: break;
                }
            }
        });
    }

    _handleCascadedSublist(item, keepValue) {
        let isEligible = false;
        let sublist = this.sublists[item.UniqueClientId];

        if (sublist && item.isLoaded) {
            item.DependsOnGuids.forEach(dependsOn => {
                let dependant = this._getItemByGuid(dependsOn, [this.metadata]);
                var tagName = dependant.Name;
                var tagNameFld = "fld_" + dependant.Name;

                if (item.SqlWhere != null && item.SqlWhere != '' && (item.SqlWhere.indexOf(tagName) >= 0 || item.SqlWhere.indexOf(tagNameFld) >= 0)) {
                    isEligible = true;
                }
            });
        }

        if (isEligible) {
            sublist.refresh();
        }
    }

    _handleCascadedMultiSelect(item, keepValue) {
        let isEligible = true;
        let cbo = $('#' + item.UniqueClientId).data("kendoMultiSelect");

        item.DependsOnGuids.forEach(dependsOn => {
            let dependant = this._getItemByGuid(dependsOn, [this.metadata]);
            var tagName = dependant.Name;
            var tagNameFld = "fld_" + dependant.Name;

            if (item.SqlWhere != null && item.SqlWhere != '' && (item.SqlWhere.indexOf(tagName) >= 0 || item.SqlWhere.indexOf(tagNameFld) >= 0)) {
                let value = this._getItemValueByGuid(dependsOn);

                if (value == null || value === '') {
                    isEligible = false;
                }
            }
        });

        let val = cbo.value();
        if (val != null && val != '') {
            $('#' + item.UniqueClientId).attr('initValue', val);
        }

        if (isEligible) {
            cbo.readonly(false);
            if (!keepValue) {
                cbo.value(null);
            }
            cbo.trigger('change');
            cbo.dataSource.read();

        } else {
            cbo.value(null);
            cbo.trigger('change');
            cbo.readonly(true);
        }
    }

    _handleCascadedRadioButton(item, keepValue) {
        let oldValue = this._getRadioButtonValue(item);
        if (!keepValue) {
            this._setRadioButtonValue(item, null);
        }

        this._setRadioButtonReadonly(item, false);
        this._loadRadioButtonItems(item).then(() => {
            if (keepValue) {
                this._setRadioButtonValue(item, oldValue);
            }
            this._checkItemValidity(item);
        });
    }

    _handleCascadedMultiSelectCheckBox(item, keepValue) {
        const oldValue = this._getMultiSelectCheckBoxValue(item);
        if (!keepValue) {
            this._clearMultiSelectCheckBoxValue(item);
        }
        this._setMultiSelectCheckBoxReadonly(item, false);
        this._loadMultiSelectCheckBoxItems(item).then(() => {
            if (keepValue) {
                this._setMultiSelectCheckBoxValue(item, oldValue);
            }
            this._checkItemValidity(item);
        });
    }

    _handleCascadedCombobox(item, keepValue) {
        let isEligible = true;
        let cbo = $('#' + item.UniqueClientId).data("kendoComboBox");

        item.DependsOnGuids.forEach(dependsOn => {
            let dependant = this._getItemByGuid(dependsOn, [this.metadata]);
            var tagName = dependant.Name;
            var tagNameFld = "fld_" + dependant.Name;

            if (item.SqlWhere != null && item.SqlWhere != '' && (item.SqlWhere.indexOf(tagName) >= 0 || item.SqlWhere.indexOf(tagNameFld) >= 0)) {
                let value = this._getItemValueByGuid(dependsOn);

                if (value == null || value === '') {
                    isEligible = false;
                }
            }
        });

        let val = cbo.value();
        if (val != null && val != '') {
            $('#' + item.UniqueClientId).attr('initValue', val);
        }

        if (isEligible) {
            cbo.readonly(false);
            if (!keepValue) {
                cbo.value(null);
            }
            cbo.trigger('change');
            cbo.dataSource.read();

        } else {
            cbo.value(null);
            cbo.trigger('change');
            cbo.readonly(true);
        }
    }

    _handleCascadedDropDownTree(item, keepValue) {
        let isEligible = true;
        let cbo = $('#' + item.UniqueClientId).data("kendoDropDownTree");

        item.DependsOnGuids.forEach(dependsOn => {
            let dependant = this._getItemByGuid(dependsOn, [this.metadata]);
            var tagName = dependant.Name;
            var tagNameFld = "fld_" + dependant.Name;

            if (item.SqlWhere != null && item.SqlWhere != '' && (item.SqlWhere.indexOf(tagName) >= 0 || item.SqlWhere.indexOf(tagNameFld) >= 0)) {
                let value = this._getItemValueByGuid(dependsOn);

                if (value == null || value === '') {
                    isEligible = false;
                }
            }
        });

        let val = cbo.value();
        if (val != null && val != '') {
            $('#' + item.UniqueClientId).attr('initValue', val);
        }

        if (isEligible) {
            cbo.readonly(false);
            if (!keepValue) {
                cbo.value(null);
            }
            cbo.trigger('change');
            cbo.dataSource.read();

        } else {
            cbo.value(null);
            cbo.trigger('change');
            cbo.readonly(true);
        }
    }

    _reloadDependantLayers() {
        let geomFieldIds = {};

        this.actionButtons.forEach(x => {
            if (x.SubType == 'SHOW_IN_MAP' || x.SubType == 'EDIT_GEOMETRY') {
                if (x.IdFieldTarget != null) {
                    geomFieldIds[x.IdFieldTarget] = {};
                }
            }
        });

        let geomFields = Object.keys(geomFieldIds);

        let maps = Array.from(document.getElementsByClassName('xp-map'));
        maps.forEach(map => {
            let layers = {};
            let mapControl = map.mapControl;

            geomFields.forEach(fieldId => {
                let foundLayers = mapControl.layerSettingsHandler.getAllLayersByGeometryField(fieldId);

                foundLayers.forEach(foundLayer => {
                    layers[foundLayer.Id] = {};
                });
            });

            //SM: in cazul in care formularul a fost deschis pentru adaugare impreuna cu o geometrie din lista, adaug si stratul care a comandat adaugarea
            //CG: stratul e retinut in lastEditedLayer la consumarea geometriei, ca sa nu depindem de globalul deja golit
            if (this.fromActionType == 'ADD' && this.lastEditedLayer != null) {
                if (!layers[this.lastEditedLayer]) {
                    layers[this.lastEditedLayer] = {};
                }
            }
            let layerIds = Object.keys(layers);

            layerIds.forEach(layerId => {
                mapControl.refreshLayer(layerId);
            });
        });
    }

    _getItemValueByGuid(guid, serializeDate) {
        let item = this._getItemByGuid(guid, [this.metadata]);
        let value = null;
        if (item != null) {
            switch (item.CtlType) {
                case 'Switch': value = this._threeStateSwitchGetValue("#" + item.UniqueClientId);
                    break;
                case 'Checkbox': value = this._getCheckboxValue(item);
                    break;
                case 'IntegerTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox') != null ? $("#" + item.UniqueClientId).data('kendoNumericTextBox').value() : null;
                    break;
                case 'DatePicker': {
                    value = $("#" + item.UniqueClientId).data("kendoDatePicker") != null ? $("#" + item.UniqueClientId).data("kendoDatePicker").value() : null;
                    if (serializeDate) {
                        value = this._serializeDate(value);
                    }
                }
                    break;
                case 'NumericTextBox': value = $("#" + item.UniqueClientId).data('kendoNumericTextBox') != null ? $("#" + item.UniqueClientId).data('kendoNumericTextBox').value() : null;
                    break;
                case 'TextBox': value = $("#" + item.UniqueClientId).val();
                    break;
                case 'TextArea': value = $("#" + item.UniqueClientId).val();
                    break;
                case 'Html': value = this._getHtmlValue(item);
                    break;
                case 'RichText': value = $("#" + item.UniqueClientId).data('kendoEditor') != null ? $("#" + item.UniqueClientId).data('kendoEditor').value() : null;
                    break;
                case 'DateTimePicker': {
                    value = $("#" + item.UniqueClientId).data("kendoDateTimePicker") != null ? $("#" + item.UniqueClientId).data("kendoDateTimePicker").value() : null;
                    if (serializeDate) {
                        value = this._serializeDateTime(value);
                    }
                }
                    break;
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ListView': value = $("#" + item.UniqueClientId).attr('current-value');
                            break;
                        case 'MultiSelect': value = $("#" + item.UniqueClientId).data('kendoMultiSelect').value();
                            break;
                        case 'TreeView': value = $("#" + item.UniqueClientId).data('kendoDropDownTree').value();
                            break;
                        case 'RadioButton': value = this._getRadioButtonValue(item);
                            break;
                        case 'MultiSelectCheckBox': value = this._getMultiSelectCheckBoxValue(item);
                            break;
                        default: value = $("#" + item.UniqueClientId).data('kendoComboBox') != null ? $("#" + item.UniqueClientId).data('kendoComboBox').value() : null;
                            break;
                    }
                }
                    break;
                case 'GeomPicker': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ModalMap': value = $("#" + item.UniqueClientId).val();
                            break;
                        case 'MapView': value = $("#" + item.UniqueClientId).attr('current-value');
                            break;
                    }
                }
                    break;
                default: break;
            }
        }

        return value;
    }

    _getItemByGuid(guid, items) {
        for (var item of items) {
            if (guid == item.Guid) {
                return item;
            }
            if (item.Items) {
                var result = this._getItemByGuid(guid, item.Items);
                if (result) {
                    return result;
                }
            }
        }
        return null;
    }

    _getDependants(itemId) {
        let result = [];

        //CG: dropzone.destroy() emite "removedfile", iar handler-ul cere dependentii - dar _disposeForm
        //goleste metadata inainte sa elibereze controalele, deci arborele nu mai exista la teardown
        if (this.metadata == null) {
            return result;
        }

        this._searchDependantItem(this.metadata, itemId, result);

        return result;
    }

    _searchDependantItem(item, itemId, resultBag) {
        if (item.DependsOnGuids != null && item.DependsOnGuids.length > 0) {
            let matches = item.DependsOnGuids.filter(row => { return row == itemId; });

            if (matches != null && matches.length > 0) {
                resultBag.push(item);
            }
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                this._searchDependantItem(child, itemId, resultBag);
            });
        }
    }

    _animateProgress(id, total, current) {
        let percentage = Math.round(current / total * 100);

        var elem = $('#' + id + '-bar')[0];
        elem.style.width = percentage + '%';
        elem.innerHTML = percentage + '%';
    }

    _markFailedProcessing(id) {
        var elem = $('#' + id + '-bar')[0];

        if (elem != null) {
            elem.style.backgroundColor = 'red';
        }

        //CG: modalul de incarcare e al gazdei, chiar si cand fisierul cade pe un rand de sublista
        let owner = this.hostFormControl != null ? this.hostFormControl : this;
        $('#' + owner.uniqueModalInnerId).find('#' + owner.uploadButtonsId).show();
    }

    _checkFileUploadAndSubmit() {
        //CG: un rand nu decide singur ca s-a terminat incarcarea - gazda numara si fisierele randurilor surori
        if (this.hostFormControl != null) {
            this.hostFormControl._checkFileUploadAndSubmit();
            return;
        }

        if (this._collectPendingUploads().length > 0) {
            return;
        }

        this.closeModal(true);

        //CG: reculegem randurile dupa incarcare, ca valorile trimise sa fie cele de dupa comiterea fisierelor
        this._storeRowsData();
        this._submitData(this.reloadAfterSubmit, this.ignoreNotificationAfterSubmit, this.initiatorIdAfterSubmit);
    }

    _initFileControl(item) {
        const currentFormControl = this;
        this.uploadedFiles[item.UniqueClientId] = {};
        this.uploadedFiles[item.UniqueClientId].uploadedFileProcessed = true;

        let dropzoneOptions = {
            url: rootURL + "Upload/UploadChunk",
            params: function (files, xhr, chunk) {
                if (chunk) {

                    currentFormControl._animateProgress(chunk.file.upload.uuid, chunk.file.upload.totalChunkCount, chunk.index);

                    return {
                        dzUuid: chunk.file.upload.uuid,
                        dzChunkIndex: chunk.index,
                        dzTotalFileSize: chunk.file.size,
                        dzCurrentChunkSize: chunk.dataBlock.data.size,
                        dzTotalChunkCount: chunk.file.upload.totalChunkCount,
                        dzChunkByteOffset: chunk.index * this.options.chunkSize,
                        dzChunkSize: this.options.chunkSize,
                        dzFileName: chunk.file.name
                    };
                }
            },
            uploadMultiple: false,
            maxFiles: 1,
            maxfilesexceeded: function (file) {
                this.removeAllFiles();
                this.addFile(file);
            },
            parallelUploads: 5,
            maxFilesize: 10240,
            chunking: true,
            forceChunking: true,
            parallelChunkUploads: false,
            chunkSize: 5000000,
            retryChunks: true,
            retryChunksLimit: 3,
            chunksUploaded: function (file, done) {
                currentFormControl._animateProgress(file.upload.uuid, 1, 1);
                $.ajax({
                    type: "POST",
                    async: true,
                    url: rootURL + "Upload/CommitChunks?dzIdentifier=" + file.upload.uuid
                        + "&fileName=" + encodeURIComponent(file.name)
                        + "&expectedBytes=" + file.size
                        + "&totalChunks=" + file.upload.totalChunkCount,
                    success: function (data) {
                        if (data != null && data.StatusCode == 200) {
                            done();
                            currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFiles += 1;
                            if (currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFiles == currentFormControl.uploadedFiles[item.UniqueClientId].filesToUpload) {
                                currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileProcessed = true;
                                currentFormControl._checkFileUploadAndSubmit();
                            }
                        } else {
                            file.accepted = false;
                            currentFormControl.dropzones[item.UniqueClientId].get(0).dropzone._errorProcessing([file], data.ReasonPhrase);
                            currentFormControl._markFailedProcessing(item.UniqueClientId);
                        }
                    },
                    error: function (msg) {
                        file.accepted = false;
                        currentFormControl.dropzones[item.UniqueClientId].get(0).dropzone._errorProcessing([file], msg.responseText);
                        currentFormControl._markFailedProcessing(item.UniqueClientId);
                    }
                });
            },
            thumbnailWidth: 260,
            thumbnailHeight: 260,
            addRemoveLinks: true,
            autoProcessQueue: false,
            dictRemoveFile: this._getResource('File_RemoveUpload'),
            init: function () {
                this.on('error', function (file, errorMessage) {
                    $.ajax({
                        type: "DELETE",
                        url: rootURL + "Upload/DeleteCanceledChunks?dzIdentifier=" + file.upload.uuid,
                        async: true
                    });
                });


                var wrapperThis = this;

                this.on("addedfile", function (file) {
                    while (this.files.length > this.options.maxFiles) {
                        this.removeFile(this.files[0]);
                    }

                    if (file.upload == null) {
                        currentFormControl.uploadedFiles[item.UniqueClientId].file = null;
                        currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileAdded = true;
                        currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileProcessed = true;
                    } else {

                        if (currentFormControl.uploadedFiles[item.UniqueClientId] == null) {
                            currentFormControl.uploadedFiles[item.UniqueClientId] = {};
                        }
                        currentFormControl.uploadedFiles[item.UniqueClientId].file = file;
                        currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileAdded = true;
                        currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileProcessed = false;
                    }


                    $('#' + item.UniqueClientId + '-img').hide();
                    $('#' + item.UniqueClientId + '-label').hide();

                    wrapperThis.emit("complete", file);
                    //CG: doar decoratiunile acestui dropzone; neancorat stergea preview-urile tuturor campurilor de fisier din pagina
                    $("#" + item.UniqueClientId).find(".dz-size, .dz-progress, .dz-error-message, .dz-success-mark, .dz-error-mark").remove();

                    if (this.options.maxFiles == 1) {
                        if ($('#' + item.UniqueClientId + '-details-buttons').length > 0) {
                            $('#' + item.UniqueClientId + '-details-buttons').remove();
                        }

                        $("#" + item.UniqueClientId).append('<div class="dz-details-buttons" id="' + item.UniqueClientId + '-details-buttons"></div>');

                        $("#" + item.UniqueClientId + ' .dz-remove').appendTo($('#' + item.UniqueClientId + '-details-buttons'));
                        $("#" + item.UniqueClientId + ' .dz-remove')[0].innerHTML = '';
                        $("#" + item.UniqueClientId + ' .dz-remove').addClass('btn btn-danger fal fa-trash-alt d-inline');
                    }
                    else {
                        var container = $(file.previewElement);
                        container.append('<button type="button" class="btn-delete btn-danger mt-2 mr-1" style="position:absolute; top: 0; right: 0; z-index: 30" title="' + currentFormControl._getResource("Remove") + '"><i class="fas fa-trash-alt" style="font-size:0.75rem"></i></button>');
                        container.on('click', '.btn-delete', function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            wrapperThis.removeFile(file);
                        });
                        $("#" + item.UniqueClientId + ' .dz-remove')[0].innerHTML = '';
                    }

                    // Dropzone creează preview-ul după inițializarea controlului; reaplicăm
                    // clasele și stilurile configurate pe componentele interne apărute.
                    applyFieldComponentClasses(item);
                    applyFieldComponentStyles(item);
                    applyFieldComponentHtmlAttributes(item);

                    if (currentFormControl._isEligibleForValidation(item)) {
                        currentFormControl._decorateField(item, true);
                    }

                    let dependants = currentFormControl._getDependants(item.Guid);

                    if (dependants != null && dependants.length > 0) {
                        currentFormControl._handleItemsState(dependants);

                        let cascadedDependants = this.getCascadedDependants(item, dependants);

                        currentFormControl._handleCascadedItems(cascadedDependants);
                    }

                    //self check
                    currentFormControl._checkItemValidity(item);
                });

                this.on("removedfile", function (file) {
                    $('#' + item.UniqueClientId + '-details-buttons').remove();
                    $('#' + item.UniqueClientId + '-img').show();
                    $('#' + item.UniqueClientId + '-label').show();
                    if (currentFormControl.uploadedFiles[item.UniqueClientId] != null) {
                        currentFormControl.uploadedFiles[item.UniqueClientId].uploadedFileAdded = false;
                    }

                    if (currentFormControl._isEligibleForValidation(item)) {
                        currentFormControl._decorateField(item, false);
                    }

                    let dependants = currentFormControl._getDependants(item.Guid);

                    if (dependants != null && dependants.length > 0) {
                        currentFormControl._handleItemsState(dependants);

                        let cascadedDependants = this.getCascadedDependants(item, dependants);

                        currentFormControl._handleCascadedItems(cascadedDependants);
                    }

                    //self check. Asta apare si la distrugerea formularului. ca sa nu dea eroare punem conditia asta
                    if (currentFormControl.metadata) {
                        currentFormControl._checkItemValidity(item);
                    }
                });
            }
        };

        if (item.EntityField.AcceptMimeType != null && item.EntityField.AcceptMimeType.trim() != '') {
            let acceptedMimeTypes = JSON.parse(item.EntityField.AcceptMimeType);
            dropzoneOptions.acceptedFiles = acceptedMimeTypes.join(',');
        }

        this.dropzones[item.UniqueClientId] = $("#" + item.UniqueClientId).dropzone(dropzoneOptions);
        $('#' + item.UniqueClientId)[0].dataset.idUiObj = item.Id;
        if (item.IsReadOnly) {
            $('#' + item.UniqueClientId).addClass('disabled-control');
        }
    }

    _getTemplate() {
        let template = ``;

        this._ensureUniqueClientIds(this.metadata);

        if (this.metadata.TypeName == 'UILayoutDto') {
            //CG: inaltimea de pagina se aplica doar formularului radacina; un rand de sublista trebuie sa se
            //stranga la continutul lui, altfel fiecare rand din stiva ocupa cat tot ecranul
            template += `<div class="form-layout-wrapper" style="display: none; height: ` + (this.parentGuid != null || this.isRow ? `auto` : `calc(100% - 3.4rem)`) + `; ` + this._getWrapperStyle(this.metadata) + `"` + `" id="` + this.metadata.UniqueClientId + `-wrapper` + `"><div class="panel-content form-row col-sm-12` + (this.isFilter ? ` pr-2 pl-3 mt-3` : ``) + this._getClassName(this.metadata) + `" ui-type="` + this.metadata.TypeName + `" ui-id="` + this.metadata.Id + `" ui-entity-id="` + this.metadata.IdEntity + `" id="` + this.metadata.UniqueClientId + `"` + (this.metadata != null && this.metadata != '' ? ` ui-name="` + this.metadata.Name + `"` : ``) + ` style="` + this._getInnerStyle(this.metadata) + `"` + this._getAttributes(this.metadata) + `>`;

            if (this.metadata.Description != null && this.metadata.Description.trim() != '') {
                template += `<div class="form-row col-sm-12" style="margin-left: 0 !important; margin-right: 0 !important; ` + this._getDescriptionStyle(this.metadata) + `">` + this.metadata.Description + `</div>`;
            }
            template += this._getChildrenTemplate(this.metadata);

            if (this.isFilter) {
                template += this._getButtons();
                template += `</div></div>`;
            }
            else {
                template += `</div></div>`;
                template += this._getButtons();
            }

            template += `<div id="` + this.uniqueModalId + `"></div>`;
        }

        return template;
    }

    _getButtons() {
        let template = ``;

        //CG: randul se salveaza impreuna cu formularul gazda, deci nu are bara proprie de butoane.
        //Suprimarea e aici si nu pe lista de actiuni: ramura de mai jos emite banda cu chenar chiar si goala.
        if (this.isRow) {
            return template;
        }

        if (this.isFilter) {
            template = `<div class="col-sm-12 mb-2">
                            <div class="form-group d-flex">
                                <button class="btn btn-secondary ml-auto" id="` + this.clearFilterButtonId + `" title="` + this._getResource('ClearFilter') + `" type="button"` + (this.isPreview ? ` disabled="disabled"` : ``) + `>` + this._getResource('ClearFilter') + `</button>
                                <button class="btn btn-primary ml-2" id="` + this.searchFilterButtonId + `" title="` + this._getResource('Filter') + `" type="button"` + (this.isPreview ? ` disabled="disabled"` : ``) + `>` + this._getResource('Filter') + `</button>
                            </div>
                        </div>`;
        } else {
            template = `<div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row align-items-right p-4 mr-0 ml-0 ` + (this.parentGuid != null && this.parentGuid != '' ? `mr-0 ml-0` : `mr-3 ml-3`) + `"` + (this.parentGuid != null && this.parentGuid != '' ? `` : ``) + `>` +
                this._getActionButtons()
                + `</div>`;
        }

        return template;
    }

    _getActionButtons() {
        let template = ``;
        let idx = 0;

        let hasMargin = false;

        this.actionButtons.forEach(actionButton => {
            if (actionButton.ClassName != null && actionButton.ClassName.indexOf('ml-auto') >= 0) {
                hasMargin = true;
            }
        });

        this.actionButtons.forEach(actionButton => {
            if (actionButton.SubType == 'SAVE' && !hasMargin) {
                actionButton.ClassName += ' ml-auto';
            } else if (actionButton.SubType == 'APPLY' && !hasMargin) {
                let saveExists = false;

                this.actionButtons.forEach(actionButton => {
                    if (actionButton.SubType == 'SAVE') {
                        saveExists = true;
                    }
                });

                if (!saveExists) {
                    actionButton.ClassName += ' ml-auto';
                }
            } else if (actionButton.SubType == 'CANCEL' && !hasMargin) {
                let saveExists = false;
                let applyExists = false;

                this.actionButtons.forEach(actionButton => {
                    if (actionButton.SubType == 'SAVE') {
                        saveExists = true;
                    } else if (actionButton.SubType == 'APPLY') {
                        applyExists = true;
                    }
                });

                if (!saveExists & !applyExists) {
                    actionButton.ClassName += ' ml-auto';
                }
            }

            let otherAttributes = '';

            if (actionButton.HtmlAttributes != null && actionButton.HtmlAttributes != '') {
                var attrKeys = [];

                if (actionButton.HtmlAttributes.toJSON != null) {
                    attrKeys = Object.keys(actionButton.HtmlAttributes.toJSON());
                } else {
                    attrKeys = Object.keys(actionButton.HtmlAttributes);
                }

                for (var i = 0; i < attrKeys.length; i++) {
                    otherAttributes += actionButton.HtmlAttributes[attrKeys[i]] + ' ';
                }
            }

            let actionButtonIconTemplate = ``;

            if (actionButton.Icon != null && actionButton.Icon != '') {
                actionButtonIconTemplate = `<i class="` + actionButton.Icon + ` mr-2"></i>`
            }

            template += `<button id="form-action-` + this.pageGuid + `-` + (actionButton.Id != 0 ? actionButton.Id : this.currentActionId) + `" class="btn ` + actionButton.ClassName + `" ` + otherAttributes + ` title="` + this._getActionResource(actionButton.Text) + `" type="button"` + (this.isPreview ? ` disabled="disabled"` : ``) + (this.isPreview ? `` : ` style="display:none;"`) + `">` + actionButtonIconTemplate + this._getActionResource(actionButton.Text) + `</button>`;

            if (actionButton.Id == 0) {
                this.currentActionId--;
            }
            idx++;
        });

        return template;
    }



    //CG: id-ul de DOM se atribuia ca efect lateral al generarii sablonului, care coboara doar prin
    //containere (layout, tab, grup, paragraf); _initControls parcurge insa tot arborele, asa ca un nod
    //nevizitat ramanea fara UniqueClientId si widget-ul se construia pe selectorul "#null"
    _ensureUniqueClientIds(item) {
        if (item == null) {
            return;
        }

        if (item.UniqueClientId == null) {
            item.UniqueClientId = this._generateUUID();
        }

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => this._ensureUniqueClientIds(child));
        }
    }

    _getChildrenTemplate(item) {
        let template = ``;

        if (item.Items != null && item.Items.length > 0) {
            item.Items.forEach(child => {
                if (child.UniqueClientId == null) {
                    child.UniqueClientId = this._generateUUID();
                }

                switch (child.TypeName) {
                    case 'UITabControlDto': template += this._getTabControlTemplate(child);
                        break;
                    case 'UITabPageDto': template += this._getTabPageTemplate(child);
                        break;
                    case 'UIGroupDto': template += this._getCollapsableGroupTemplate(child);
                        break;
                    case 'UIParagraphDto': template += this._getParagraphTemplate(child);
                        break;
                    case 'UISublistDto': template += this._getSublistTemplate(child);
                        break;
                    case 'UISubformDto': template += this._getSublistTemplate(child, 'xp-subform-container');
                        break;
                    case 'UIMapViewDto': template += this._getMapViewTemplate(child);
                        break;
                    case 'UIFieldControlDto': template += this._getFieldControlTemplate(child);
                        break;
                    case 'UICustomFieldControlDto': template += this._getFieldControlTemplate(child);
                        break;
                    default: template += ``;
                        break;
                }
            });
        }

        return template;
    }

    _getTabControlTemplate(item) {
        let template = `<div class="panel-content p-0` + this._getLayoutCols(item) + this._getClassName(item) + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `" id="` + item.UniqueClientId + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getWrapperStyle(item) + `"` + this._getAttributes(item) + `><ul class="nav nav-tabs" role="tablist">`;

        if (item.Items != null && item.Items.length > 0) {
            let firstActive = false;
            let pagesCount = 0;
            item.Items.forEach(child => {
                if (child.TypeName == 'UITabPageDto') {
                    if (child.UniqueClientId == null) {
                        child.UniqueClientId = this._generateUUID();
                    }

                    if (!firstActive) {
                        child.IsPageActive = true;
                    } else {
                        child.IsPageActive = false;
                    }

                    template += `<li class="nav-item" onclick="getXpForm('` + this.uniqueId + `')._tabOnClick('` + child.UniqueClientId + `')" style="cursor: pointer; ` + this._getPageButtonStyle(item) + `"><a id="` + child.UniqueClientId + `-anchor" class="nav-link` + (!firstActive ? ` active` : ``) + `" data-toggle="tab" role="tab" style=` + this._getPageLinkStyle(item) + `>` + (child.Text != null ? child.Text : this._getResource(child.TypeName)) + `</a></li>`;

                    firstActive = true;
                    pagesCount++;
                }
            });

            if (pagesCount == 0) {
                return ``;
            }
        } else {
            return ``;
        }

        template += `</ul>`;

        template += `<div class="tab-content p-0 pt-3" style="` + this._getPageWrapperStyle(item) + `">`;
        template += this._getChildrenTemplate(item);
        template += `</div></div>`;

        return template;
    }

    _getTabPageTemplate(item) {
        let template = `<div class="tab-pane fade` + (item.IsPageActive ? ` show active` : ``) + this._getClassName(item) + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `" id="` + item.UniqueClientId + `" role="tabpanel"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getWrapperStyle(item) + ` display: flex; flex-wrap: wrap;"` + this._getAttributes(item) + `>`;
        template += this._getChildrenTemplate(item);
        template += `</div>`;
        return template;
    }

    _getCollapsableGroupTemplate(item) {
        let template = `<div class="accordion accordion-outline` + this._getLayoutCols(item) + this._getClassName(item) + `" id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getWrapperStyle(item) + `"` + this._getAttributes(item) + `>`;
        template += `<div class="card" style="` + this._getCardStyle(item) + `">`;
        template += `<div class="card-header" style="height: 2rem; ` + this._getCardHeaderStyle(item) + `" onclick="getXpForm('` + this.uniqueId + `')._accordionOnClick('` + item.UniqueClientId + `', ` + item.Collapsable + `)">
                        <a id="` + item.UniqueClientId + `-anchor" href="javascript:void(0);" class="card-title` + (item.Collapsed ? ' collapsed' : ``) + `" style="padding: 0.5rem 0.5rem; ` + this._getCardHeaderLabelStyle(item) + `" aria-expanded="` + (!item.Collapsed ? 'true' : `false`) + `">` +
            (item.Text != null ? item.Text : this._getResource(item.TypeName))
            + `<span class="ml-auto">
                                <span class="collapsed-reveal">
                                    <i class="fal fa-minus fs-xl"></i>
                                </span>
                                <span class="collapsed-hidden">
                                    <i class="fal fa-plus fs-xl"></i>
                                </span>
                            </span>
                        </a>
                    </div>`;
        template += `<div id="` + item.UniqueClientId + `-inner" class="collapse` + (!item.Collapsed ? ' show' : ``) + `" style="` + this._getCardInnerStyle(item) + `">
                                <div class="card-body form-row">`;
        template += this._getChildrenTemplate(item);
        template += `</div>`;
        template += `</div>`;
        template += `</div>`;
        template += `</div>`;

        return template;
    }

    _getParagraphTemplate(item) {
        let template = `<div class="` + this._getLayoutCols(item) + this._getClassName(item) + ` form-group" id="` + item.UniqueClientId + `-wrapper" style="` + this._getWrapperStyle(item) + `">`;

        if (item.Label != null && item.Label !== '') {
            template += `<label class="form-label" style="` + this._getLabelStyle(item) + `">` + item.Label + this._getLabelTooltipIndicator(item) + `</label>`;
        }

        if (item.Description != null && item.Description.trim() != '') {
            template += `<div class="form-field-description" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
        }

        template += `<div class="form-row mr-0 ml-0 col-12` + this._getClassName(item) + `" id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInnerStyle(item) + `"` + this._getAttributes(item) + `>`;
        template += this._getChildrenTemplate(item);
        template += `</div>`;
        template += `</div>`;

        return template;
    }

    _getMapViewTemplate(item) {
        let template = `<div class="` + this._getLayoutCols(item) + this._getClassName(item) + ` form-group" id="` + item.UniqueClientId + `-wrapper" style="` + this._getWrapperStyle(item) + `">`;
        if (item.Label != null && item.Label !== '') {
            template += `<label class="form-label" style="` + this._getLabelStyle(item) + `">` + item.Label + this._getLabelTooltipIndicator(item) + `</label>`;
        }

        if (item.Description != null && item.Description.trim() != '') {
            template += `<div class="form-field-description" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
        }

        template += `<div class="xp-mapview-container" id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInnerStyle(item) + `"` + this._getAttributes(item) + `>
                        <div class="xp-map-container xp-form-map" map-id="` + item.IdMap + `"></div>
                    </div>`;

        template += `</div>`;

        return template;
    }

    //CG: acelasi schelet pentru sublista si subformular; markerClass deosebeste subformularul pentru stiluri si depanare
    _getSublistTemplate(item, markerClass) {
        item.isLoaded = false;
        let template = `<div class="` + this._getLayoutCols(item) + this._getClassName(item) + ` form-group" id="` + item.UniqueClientId + `-wrapper" style="` + this._getWrapperStyle(item) + `">`;
        if (item.Label != null && item.Label !== '') {
            template += `<label class="form-label" style="` + this._getLabelStyle(item) + `">` + item.Label + this._getLabelTooltipIndicator(item) + `</label>`;
        }

        if (item.Description != null && item.Description.trim() != '') {
            template += `<div class="form-field-description" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
        }

        //CG: xp-list-container ramane si pe subformular - descoperirea, registrul this.sublists si cascadarea se bazeaza pe el
        let containerClass = markerClass != null ? `xp-list-container ` + markerClass : `xp-list-container`;

        template += `<div class="` + containerClass + `" id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInnerStyle(item) + `"` + this._getAttributes(item) + `></div>`;

        template += `</div>`;

        return template;
    }

    _getFieldControlSubType(item) {
        if (item.CtlProps != null) {
            return item.CtlProps.CtlSubType;
        }

        return null;
    }

    _getFieldControlTemplate(item) {
        let wrapperStyle = '';

        if (!this.isFilter) {
            wrapperStyle = 'display: none;';
        } else if (item.Hidden) {
            wrapperStyle = 'display: none;';
        }

        let template = `<div class="form-item-wrapper form-group` + this._getLayoutCols(item) + this._getClassName(item) + `" id="` + item.UniqueClientId + `-wrapper" style="` + wrapperStyle + this._getWrapperStyle(item) + `">`;
        let labelActions = this._getControlActionsTemplate(item, 'DYNAMIC_ON_LABEL', false);
        let controlActions = this._getControlActionsTemplate(item, 'DYNAMIC_ON_CONTROL', false);

        if (item.CtlType == 'Checkbox') {
            template += `<div class="xp-checkbox-row d-flex align-items-center">` + this._getFieldTypeControlTemplate(item);
            if (item.Label != null && item.Label !== '') {
                template += `<label class="form-check-label" for="` + item.UniqueClientId + `" style="` + this._getLabelStyle(item) + `margin: 0;">` + item.Label + this._getLabelTooltipIndicator(item) + `</label>`;
            }
            template += labelActions + controlActions + `</div>`;
            template += `<span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
            if (item.Description != null && item.Description.trim() != '') {
                template += `<div class="form-field-description" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
            }
        } else if (item.CtlType == 'Switch') {
            if ((item.Label != null && item.Label !== '') || labelActions != '') {
                template += `<div class="xp-control-label-row d-flex align-items-center col-sm-12 pl-0">`;
                if (item.Label != null && item.Label !== '') {
                    template += `<label class="form-label mb-0 mr-2" style="` + this._getLabelStyle(item) + `">` + item.Label + this._getLabelTooltipIndicator(item) + `</label>`;
                }
                template += labelActions + `</div>`;
            }
            if (item.Description != null && item.Description.trim() != '') {
                template += `<div class="form-field-description col-sm-12" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
            }
            template += this._getControlActionRowTemplate(item, controlActions);
        } else {
            if ((item.Label != null && item.Label !== '') || labelActions != '') {
                template += `<div class="xp-control-label-row d-flex align-items-center">`;
                if (item.Label != null && item.Label !== '') {
                    template += `<label class="form-label mb-0 mr-2" style="` + this._getLabelStyle(item) + `">` + item.Label + this._getLabelTooltipIndicator(item) + `</label>`;
                }
                template += labelActions + `</div>`;
            }
            if (item.Description != null && item.Description.trim() != '') {
                template += `<div class="form-field-description" style="padding: 0.5rem 0.5rem; margin-bottom: 0.5rem; background: #eef7fd; opacity: 0.8; font-weight: 400; font-size: 0.875rem; border-radius: 8px; width: fit-content; ` + this._getDescriptionStyle(item) + `"><span style="color:indianred; padding-right: 0.25rem;">*</span>` + item.Description + `</div>`;
            }
            template += this._getControlActionRowTemplate(item, controlActions);
        }

        template += `</div>`;

        return template;
    }

    _getControlActionRowTemplate(item, actionsTemplate) {
        let controlTemplate = this._getFieldTypeControlTemplate(item);
        if (actionsTemplate == '') {
            return controlTemplate;
        }

        return `<div class="xp-control-input-row d-flex align-items-center">
                    <div class="xp-control-input flex-grow-1" style="min-width: 0;">` + controlTemplate + `</div>` +
            actionsTemplate +
            `</div>`;
    }

    _getControlActionsTemplate(control, type, inMenu) {
        let actions = (control.Actions || []).filter(action => action.Type == type);
        if (actions.length == 0) {
            return '';
        }

        let hasAutoMargin = !inMenu && type == 'DYNAMIC_ON_LABEL'
            && actions.some(action => action.ClassName != null && action.ClassName.split(/\s+/).includes('ml-auto'));
        let displayClass = inMenu ? `d-flex flex-column align-items-stretch`
            : hasAutoMargin ? `d-flex align-items-center flex-grow-1`
                : `d-inline-flex align-items-center`;
        let widthStyle = !inMenu && type == 'DYNAMIC_ON_LABEL' ? ` style="width: 100%;"` : ``;
        let template = `<div class="xp-control-actions ` + displayClass + (inMenu ? `` : ` ml-2`) + `"` + widthStyle + `>`;
        actions.forEach(action => {
            template += this._getControlActionTemplate(action, control.UniqueClientId, inMenu);
        });
        return template + `</div>`;
    }

    _getControlActionTemplate(action, controlClientId, inMenu) {
        let isGroup = action.SubType == 'GROUP';
        if (action.SubType == 'SEPARATOR') {
            return inMenu ? `<div class="dropdown-divider"></div>` : `<span class="border-left mx-1" style="height: 1.25rem;"></span>`;
        }

        let content = ``;
        if (action.Icon != null && action.Icon != '') {
            content += `<i class="` + action.Icon + (action.Text != null && action.Text != '' ? ` mr-1` : ``) + `"></i>`;
        }
        if (action.Text != null && action.Text != '') {
            content += action.Text;
        } else if (content == '' && action.Title != null) {
            content = action.Title;
        }

        let attributes = ``;
        if (action.HtmlAttributes != null) {
            Object.keys(action.HtmlAttributes).forEach(key => {
                if (key != '_events' && key != '_handlers' && key != 'uid' && key != 'parent') {
                    attributes += ` ` + key + `="` + action.HtmlAttributes[key] + `"`;
                }
            });
        }

        let className = action.ClassName != null && action.ClassName != '' ? action.ClassName : 'btn-primary';
        let title = action.Title != null && action.Title != '' ? action.Title : (action.Text || '');
        let style = action.Style != null && action.Style != '' ? ` style="` + action.Style + `"` : '';
        if (isGroup) {
            let groupClass = inMenu ? `xp-control-action-group xp-control-action-group-menu` : `xp-control-action-group xp-control-action-group-root`;
            let menuStyle = inMenu ? `left: 100%; top: 0;` : `left: 0; top: 100%;`;
            let groupButtonClass = inMenu ? `dropdown-item d-flex align-items-center justify-content-between` : `btn btn-sm ` + className;
            let groupTemplate = `<div class="` + groupClass + ` position-relative">` +
                `<button type="button" class="` + groupButtonClass + ` xp-control-action-group-button xp-control-action-has-menu" title="` + title + `" aria-haspopup="true" aria-expanded="false"` + style + attributes + `>` + content + `</button>` +
                `<div class="dropdown-menu xp-control-action-menu" style="` + menuStyle + `">`;
            (action.Items || []).forEach(child => {
                groupTemplate += this._getControlActionTemplate(child, controlClientId, true);
            });
            return groupTemplate + `</div></div>`;
        }

        return `<button type="button" class="` + (inMenu ? `dropdown-item` : `btn btn-sm ` + className) + ` xp-control-action" data-control-client-id="` + controlClientId + `" data-control-action-id="` + action.Id + `" title="` + title + `"` + style + attributes + `>` + content + `</button>`;
    }

    _getFieldTypeControlTemplate(item) {
        let template = ``;

        if (item.CtlType != null) {
            switch (item.CtlType) {
                case 'Switch': template = this._getSwitchFieldTypeControlTemplate(item);
                    break;
                case 'Checkbox': template = this._getCheckboxFieldTypeControlTemplate(item);
                    break;
                case 'IntegerTextBox': template = this._getIntegerTextBoxFieldTypeControlTemplate(item);
                    break;
                case 'NumericTextBox': template = this._getNumericTextBoxFieldTypeControlTemplate(item);
                    break;
                case 'TextBox': template = this._getTextBoxFieldTypeControlTemplate(item);
                    break;
                case 'TextArea': template = this._getTextAreaFieldTypeControlTemplate(item);
                    break;
                case 'Html': template = this._getHtmlFieldTypeControlTemplate(item);
                    break;
                case 'RichText': template = this._getRichTextFieldTypeControlTemplate(item);
                    break;
                case 'DatePicker': template = this._getDatePickerFieldTypeControlTemplate(item);
                    break;
                case 'DateTimePicker': template = this._getDateTimePickerFieldTypeControlTemplate(item);
                    break;
                case 'ComboBox': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ListView': template = this._getComboBoxListViewFieldTypeControlTemplate(item);
                            break;
                        case 'MultiSelect': template = this._getMultiSelectFieldTypeControlTemplate(item);
                            break;
                        case 'TreeView': template = this._getDropDownTreeFieldTypeControlTemplate(item);
                            break;
                        case 'RadioButton': template = this._getRadioButtonFieldTypeControlTemplate(item);
                            break;
                        case 'MultiSelectCheckBox': template = this._getMultiSelectCheckBoxFieldTypeControlTemplate(item);
                            break;
                        default: template = this._getComboBoxFieldTypeControlTemplate(item);
                            break;
                    }
                }
                    break;
                case 'GeomPicker': {
                    switch (this._getFieldControlSubType(item)) {
                        case 'ModalMap': template = this._getGeomPickerModalMapFieldTypeControlTemplate(item);
                            break;
                        case 'MapView': template = this._getGeomPickerMapViewFieldTypeControlTemplate(item);
                            break;
                    }
                }
                    break;
                case 'File': template = this._getFileFieldTypeControlTemplate(item);
                    break;
                default: template = ``;
                    break;
            }
        }

        return template;
    }

    _getSwitchFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getCheckboxFieldTypeControlTemplate(item) {
        return `<input type="checkbox" id="` + item.UniqueClientId + `" class="form-check-input xp-checkbox-control" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `position: static; margin: 0 8px 0 0;"` + this._getAttributes(item) + `/>`;
    }

    _getIntegerTextBoxFieldTypeControlTemplate(item) {
        return `<input id="` + item.UniqueClientId + `" class="form-control" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getNumericTextBoxFieldTypeControlTemplate(item) {
        return `<input id="` + item.UniqueClientId + `" class="form-control" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getTextBoxFieldTypeControlTemplate(item) {
        return `<input type="text" id="` + item.UniqueClientId + `" class="form-control normal-input" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getTextAreaFieldTypeControlTemplate(item) {
        return `<textarea id="` + item.UniqueClientId + `" class="form-control normal-input" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></textarea>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getHtmlFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" class="form-control normal-input" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="padding: 0; height: auto; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `>
                    <div id="` + item.UniqueClientId + `-editor" style="display: none; width: 100%; height: 100%; min-height: 12rem;"></div>
                    <div id="` + item.UniqueClientId + `-rendered" style="display: none; width: 100%; min-height: 2.25rem; padding: 0;"></div>
                </div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getRichTextFieldTypeControlTemplate(item) {
        return `<textarea id="` + item.UniqueClientId + `" class="form-control normal-input" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></textarea>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getDatePickerFieldTypeControlTemplate(item) {
        return `<input id="` + item.UniqueClientId + `" class="form-control" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` autocomplete="off" style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getDateTimePickerFieldTypeControlTemplate(item) {
        return `<input id="` + item.UniqueClientId + `" class="form-control" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` autocomplete="off" style="` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getFileFieldTypeControlTemplate(item) {
        return `<div class="dropzone needsclick d-block d-flex justify-content-center align-items-center" id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `>
                    <div class="dz-message needsclick" style="margin:auto;">
                        <i class="fal fa-cloud-upload text-muted" id="` + item.UniqueClientId + `-img" style="justify-content: center; display: flex;"></i>
                        <span class="text-uppercase ml-2" style="text-align: center;" id="` + item.UniqueClientId + `-label">` + this._getResource('File_UploadHint') + `</span>
                    </div>
                </div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getMultiSelectFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getDropDownTreeFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getRadioButtonFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" class="xp-radio-button-group" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + ` current-value=""></div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getMultiSelectCheckBoxFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" class="xp-multiselect-checkbox-group" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + ` current-value="[]"></div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getComboBoxFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `></div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getComboBoxListViewFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + ` current-value="">
                    <div id="` + item.UniqueClientId + `-img" class="justify-content-center align-items-center" style="width: 100%; border: 2px dashed #dedede; border-radius: 5px; background: #f5f5f5; padding: 0.5rem; height: 150px; cursor: pointer; display:none;">
                        <div class="d-flex justify-content-center" style="height: 100%; width: 50%; background-color: #3c3c3c;">
                            <img src="" style="height: 100%;"></img>
                        </div>
                        <div class="d-flex justify-content-center" style="height: 100%; width: 50%; flex-direction: column; align-content: center; flex-wrap: wrap; text-align: center;">
                            <span class="list-view-selection-title" style="font-weight: bold;"></span>
                            <span class="list-view-selection-description"></span>
                        </div>
                    </div>
                    <div id="` + item.UniqueClientId + `-placeholder" class="d-flex justify-content-center list-view-body align-items-center" style="width: 100%; flex-wrap: wrap; border: 2px dashed #dedede; border-radius: 5px; background: #f5f5f5; padding: 0.5rem; height: 150px; cursor: pointer;">
                        <div style="margin:auto; text-align: center; width: 100%;">
                            <i class="fal fa-hand-pointer text-muted" style="font-size: 3rem; width: 100%; padding-bottom: 0.25rem;"></i>
                            <span class="text-uppercase ml-2" style="text-align: center; font-size: initial;">` + this._getResource('ComboBoxSelectViewHint') + `</span>
                        </div>
                    </div>
                </div>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getGeomPickerModalMapFieldTypeControlTemplate(item) {
        return `<span class="d-flex">
                    <input type="text" id="` + item.UniqueClientId + `" class="form-control normal-input" autocomplete="off" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="border-bottom-right-radius: 0px !important; border-top-right-radius: 0px !important;` + this._getInputStyle(item) + `"` + this._getAttributes(item) + `/>
                    <button id="` + item.UniqueClientId + `-action" class="btn btn-primary fal fa-map-marker-edit" style="border-bottom-left-radius: 0px !important; border-top-left-radius: 0px !important; padding-left: 0.55rem !important; padding-right: 0.55rem !important;"></button>
                </span>
                <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>`;
    }

    _getGeomPickerMapViewFieldTypeControlTemplate(item) {
        return `<div id="` + item.UniqueClientId + `" ui-type="` + item.TypeName + `" ui-id="` + item.Id + `"` + (item.Name != null && item.Name != '' ? ` ui-name="` + item.Name + `"` : ``) + ` style="position:relative; width: 100%; ` + this._getInputStyle(item) + `"` + this._getAttributes(item) + ` current-value="">
                    <div class="xp-map-container xp-form-map" map-id="` + item.IdMap + `"></div>
                     <span class="form-item-validation" id="` + item.UniqueClientId + `-validation" style="color: #FF5733; font-weight: 500; display: none;">` + this._getFieldValidationMessage(item) + `</span>
                </div>`;
    }

    _getFieldValidationMessage(item) {
        if (this.isFilter) {
            return '';
        }
        return this._getResource('ItemValidationMessage').replaceAll('{FieldLabel}', item.Label);
    }

    //CG: golirea containerului scoate doar DOM-ul; un rand de sublista e o instanta FormControl cu modalul
    //lui, iar un dropzone isi tine handlerele pe element - fara eliberare fiecare reincarcare le lasa orfane.
    //Se apeleaza si din reloadForm: acolo o sublista amanata intr-un tab neaccesat ar ramane in registru cu
    //randurile de dinainte, peste un container care nu mai exista, si le-ar trimite asa la salvare
    _releaseControls() {
        Object.keys(this.htmlEditors).forEach(key => {
            let editor = this.htmlEditors[key];
            if (editor != null) {
                editor.destroy();
            }
        });
        this.htmlEditors = {};

        Object.keys(this.sublists).forEach(key => {
            let sublist = this.sublists[key];
            if (sublist != null && typeof sublist.destroy === 'function') {
                sublist.destroy();
            }
        });
        this.sublists = {};

        Object.keys(this.dropzones).forEach(key => {
            let element = this.dropzones[key] != null ? this.dropzones[key].get(0) : null;
            if (element != null && element.dropzone != null) {
                element.dropzone.destroy();
            }
        });
        this.dropzones = {};
    }

    _disposeForm() {
        this.metadata = null;

        $(document).off('.' + this.uniqueId + '.xpControlActions');

        this._releaseControls();

        let container = $('#' + this.container);
        if (container.length > 0) {
            //CG: widget-urile Kendo isi tin popup-urile in body, deci golirea containerului le-ar lasa orfane;
            //kendo.destroy le parcurge recursiv si le elibereaza impreuna cu popup-ul lor. Pornim insa de la
            //copii, nu de la container: kendo.destroy face addBack(), iar containerul poate fi chiar widget-ul
            //gazda (la filtrul din legenda e fereastra Kendo), pe care destroy-ul l-ar scoate din pagina
            kendo.destroy(container.children());
            container[0].innerHTML = '';
        }
    }

    _getResource(name) {
        if (this.localization[name] != null && this.localization[name].trim() != '') {
            return this.localization[name];
        }

        return name;
    }

    _getCustomFormResource(name) {
        if (this.customFormResources[name] != null && this.customFormResources[name].trim() != '') {
            return this.customFormResources[name];
        }

        return name;
    }

    _getActionResource(name) {
        if (name == 'EDIT' || name == 'DELETE' || name == 'SHOW_IN_MAP' || name == 'EDIT_GEOMETRY' || name == 'SAVE' || name == 'CANCEL' || name == 'APPLY' || name == 'SELECT_FROM_MAP') {
            name = 'ElementAction_' + name;
        }

        if (this.actionLocalization[name] != null && this.actionLocalization[name].trim() != '') {
            return this.actionLocalization[name];
        }

        return name;
    }

    _tabOnClick(id) {
        let sublists = $('#' + id).find('.xp-list-container');

        if (sublists.length > 0) {
            for (let i = 0; i < sublists.length; i++) {
                let sublist = sublists[i];

                let sublistMetadata = this._searchFieldByUniqueId(this.metadata, sublist.id);

                if (sublistMetadata != null && !sublistMetadata.isLoaded) {
                    this._initSublistControl(sublistMetadata, false);
                    sublistMetadata.isLoaded = true;
                }
            }
        }

        $('#' + id).parent().parent().find('.nav-link').removeClass('active');
        $('#' + id).parent().parent().find('.nav-link').attr('aria-selected', 'false');
        $('#' + id + '-anchor').addClass('active');
        $('#' + id + '-anchor').attr('aria-selected', 'true');

        $('#' + id).addClass('show');
        $('#' + id).addClass('active');

        $('#' + id).siblings().removeClass('show');
        $('#' + id).siblings().removeClass('active');

        let lists = $('.k-grid-header:visible');

        for (var i = 0; i < lists.length; i++) {
            let list = lists[i];
            let listItem = $(list).parent();

            if (listItem.data('kendoGrid')) {
                listItem.data('kendoGrid').resize();
            } else if (listItem.parent().data('kendoGrid')) {
                listItem.parent().data('kendoGrid').resize();
            }
        }

        //this.lastChosenTab = id;

        if (this.saveTabs && this.objectId != null && this.objectId != 0) {
            let formTabs = sessionStorage.getItem('formTabs');

            if (formTabs != null && formTabs.trim() != '') {
                formTabs = JSON.parse(formTabs);
            } else {
                formTabs = {};
            }

            let tabMetadata = this.getFieldMetadataByUniqueId(id);

            if (tabMetadata != null) {
                if (this.formId != null) {
                    formTabs[xapp.currentApp + '_' + this.formId + '_' + this.objectId] = tabMetadata.Id;
                }
                else if (this.listId != null) {
                    formTabs["lst_" + xapp.currentApp + '_' + this.listId + '_' + this.objectId] = tabMetadata.Id;
                }
                else if (this.mapLayerId != null) {
                    formTabs["map_lyr_" + xapp.currentApp + '_' + this.mapLayerId + '_' + this.objectId] = tabMetadata.Id;
                }
                sessionStorage.setItem('formTabs', JSON.stringify(formTabs));
            }
        }
    }

    _accordionOnClick(id, collapsable) {
        if (collapsable) {
            if ($('#' + id + '-anchor').hasClass('collapsed')) {
                $('#' + id + '-anchor').attr('aria-expanded', true);
                $('#' + id + '-anchor').removeClass('collapsed');
                $('#' + id + '-inner').addClass('show');
            } else {
                $('#' + id + '-anchor').attr('aria-expanded', false);
                $('#' + id + '-anchor').addClass('collapsed');
                $('#' + id + '-inner').removeClass('show');
            }
        }

        let lists = $('.k-grid-header:visible');

        for (var i = 0; i < lists.length; i++) {
            let list = lists[i];
            let listItem = $(list).parent();

            if (listItem.data('kendoGrid')) {
                listItem.data('kendoGrid').resize();
            } else if (listItem.parent().data('kendoGrid')) {
                listItem.parent().data('kendoGrid').resize();
            }
        }
    }

    _generateUUID() {
        var d = new Date().getTime();
        var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0;
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16;
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        }).replaceAll('-', '');
    }

    _getLayoutCols(item) {
        if (item.LayoutCols != null && item.LayoutCols != '' && item.LayoutCols > 0) {
            if (item.LayoutCols > 12) {
                return ' col-sm-12';
            } else {
                return ' col-sm-' + item.LayoutCols;
            }
        } else if (item.TypeName == 'UIFieldControlDto' || item.TypeName == 'UICustomFieldControlDto') {
            return ' col-sm-6';
        }

        return ' col-sm-12';
    }

    _getClassName(item) {
        if (item.ClassName != null && item.ClassName != '') {
            return ' ' + item.ClassName;
        }

        return '';
    }

    _getStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '') {
            return style + item.Style.trim();
        } else {
            return style;
        }
    }

    _getWrapperStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleWrapper != null) {
            return style + JSON.parse(item.Style).styleWrapper.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getInputStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleInput != null) {
            return style + JSON.parse(item.Style).styleInput.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getDescriptionStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleDescription != null) {
            return style + JSON.parse(item.Style).styleDescription.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getLabelStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleLabel != null) {
            return style + JSON.parse(item.Style).styleLabel.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getLabelTooltipIndicator(item) {
        let tooltip = item.CtlProps != null ? item.CtlProps.LabelTooltip : null;
        if (tooltip == null || String(tooltip).trim() == '') {
            return '';
        }

        let safeTooltip = String(tooltip)
            .replaceAll('&', '&amp;')
            .replaceAll('"', '&quot;')
            .replaceAll('<', '&lt;')
            .replaceAll('>', '&gt;');
        return ` <span class="xp-label-tooltip-indicator fal fa-info-circle" title="` + safeTooltip + `" role="img" aria-label="` + safeTooltip + `"></span>`;
    }

    _getInnerStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleInner != null) {
            return style + JSON.parse(item.Style).styleInner.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getPageButtonStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).stylePageButton != null) {
            return style + JSON.parse(item.Style).stylePageButton.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getPageLinkStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).stylePageLink != null) {
            return style + JSON.parse(item.Style).stylePageLink.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getPageWrapperStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).stylePageWrapper != null) {
            return style + JSON.parse(item.Style).stylePageWrapper.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getCardStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleCard != null) {
            return style + JSON.parse(item.Style).styleCard.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getCardHeaderStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleCardHeader != null) {
            return style + JSON.parse(item.Style).styleCardHeader.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getCardHeaderLabelStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleCardHeaderLabel != null) {
            return style + JSON.parse(item.Style).styleCardHeaderLabel.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getCardInnerStyle(item) {
        let style = '';

        if (item.Style != null && item.Style.trim() != '' && JSON.parse(item.Style).styleCardInner != null) {
            return style + JSON.parse(item.Style).styleCardInner.trim().replaceAll('\n', '');
        } else {
            return style;
        }
    }

    _getAttributes(item) {
        if (item.HtmlAttributes != null) {
            let attributes = '';

            let keys = Object.keys(item.HtmlAttributes);

            for (var i = 0; i < keys.length; i++) {
                if (keys[i] != '_events' && keys[i] != '_handlers' && keys[i] != 'uid' && keys[i] != 'parent') {
                    attributes += ' ' + keys[i] + '="' + item.HtmlAttributes[keys[i]] + '"';
                }
            }

            return attributes;
        } else {
            return '';
        }
    }

    getItemById(id) {
        return $('#' + id);
    }
}
